import { Component, ViewChild, HostListener, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Router } from '@angular/router';
import { PlatformLocation } from "@angular/common";
import { Constant, PlatFormType, ManageTitle, ContentTypeValues, SolrContentTypeValues } from 'src/app/common/constant/constant';
import { NgbModal, NgbModalConfig, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../services/common/common.service';
import { RepairOrderService } from 'src/app/services/repair-order/repair-order.service';
import {RepairOrderService as ROService} from 'src/app/services/repair-order/repair-order.service';
import { ApiService } from '../../../services/api/api.service';
import { Title,DomSanitizer } from "@angular/platform-browser";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { LandingpageService } from '../../../services/landingpage/landingpage.service';
import { ManageListComponent } from '../../../components/common/manage-list/manage-list.component';
import * as ClassicEditor from "src/build/ckeditor";
import { countries } from 'country-data';
import { ActionFormComponent } from 'src/app/components/common/action-form/action-form.component';
import { MediaUploadComponent } from 'src/app/components/media-upload/media-upload.component';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { SuccessModalComponent } from '../../../components/common/success-modal/success-modal.component';
import { ThreadService } from "../../../services/thread/thread.service";
import { BaseService } from 'src/app/modules/base/base.service';
import { ProductMatrixService } from '../../../services/product-matrix/product-matrix.service';
import { ThreadPostService } from '../../../services/thread-post/thread-post.service';
import { Subscription } from "rxjs";
import * as moment from 'moment-timezone';
import { StripeCardsComponent } from 'src/app/components/common/stripe-cards/stripe-cards.component';
import { IscanRoFormComponent } from 'src/app/components/common/iscan-ro-form/iscan-ro-form.component';
import { CountryPhonenumberComponent } from 'src/app/components/common/country-phonenumber/country-phonenumber.component';
import { environment } from 'src/environments/environment';
import { ConfirmationComponent } from '../../../components/common/confirmation/confirmation.component';
import { SuccessComponent } from '../../../components/common/success/success.component';
import { UserDashboardService } from '../../../services/user-dashboard/user-dashboard.service';
import { RoEstimateListComponent } from 'src/app/components/common/ro-estimate-list/ro-estimate-list.component';
import { CalproAdasReportComponent } from 'src/app/components/common/calpro-adas-report/calpro-adas-report.component';
import { Message, MessageService, PrimeNGConfig } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import {Store} from '@ngrx/store';
import {State} from 'src/app/models/state.model';
import {ImportAction} from 'src/app/actions/import.actions';

@Component({
  selector: 'app-repair-order-manage',
  templateUrl: './repair-order-manage.component.html',
  styleUrls: ['./repair-order-manage.component.scss'],
  providers: [MessageService]
})
export class RepairOrderManageComponent implements OnInit, OnDestroy {
  userCountryPhoneRef: CountryPhonenumberComponent;
  @ViewChild('top',{static: false}) top: ElementRef;
  @ViewChild('dd1') dropdown1: Dropdown;
  @ViewChild('dd2') dropdown2: Dropdown;
  @ViewChild('dd3') dropdown3: Dropdown;
  @ViewChild('dd4') dropdown4: Dropdown;
  @ViewChild('dd5') dropdown5: Dropdown;
  @ViewChild('dd6') dropdown6: Dropdown;
  @ViewChild('dd7') dropdown7: Dropdown;
  @ViewChild('dd8') dropdown8: Dropdown;
  @ViewChild('dropdownInventorySource') dropdownInventorySource: Dropdown;

  @Output() ROManageService: EventEmitter<any> = new EventEmitter();
  @Input() workOrderId;
  @Input() workOrderType;
  @Input() workOrderPage;
  @Input() serviceTypeId: any = 0;
  @Input() newFlag = false;
  @Input() createParamSalesRepId: string;
  @Input() createParamShopId: string;
  @Input() createParamMarketId: string;
  @Input() createParamContactId: string;
  @Input() createParamReportId: string;
  @Input() createParamVIN: string;
  @Input() calproAdasReportData: any = [];
  public removeReportFlag: boolean = false;

  public setInterval: any;
  estimateListRef: RoEstimateListComponent;
  calproReportRef: CalproAdasReportComponent;
  public shopUserEmailFlag: boolean = false;
  public shopUserEmail: string = '';
  public contactFirstUser: boolean = false;
  public businessRoleDisable: boolean = false;
  public accountTypeDisable: boolean = false;
  public requiredFlag: boolean = false;
  public requiredFields: any = [];
  stripeCardPageRef: StripeCardsComponent;
  iscanPageRef: IscanRoFormComponent;
  public cardAction: boolean = true;
  public cardAccess: string = "manage";
  public shopEmail: string = "";
  public loading: boolean = true;
  public invisibleFlag: boolean = false;
  public showShopTechFlag: boolean = false;
  public calproAccess: boolean = false;
  public defaulLabel: string = 'Select';
  public sconfig: PerfectScrollbarConfigInterface = {};
  baseApiUrl: any;
  baseV3ApiUrl: any;
  subscription: Subscription = new Subscription();
  public selectedMarket: any = '';
  public supportTypeOptions: any = [];
  //public supportTypeOptions: any = [{id: 1, name: "Vehicle", class: "tc-vehicle", isSelected: true, disabled: false, display: true}, {id: 2, name: "Scan tool", class: "tc-scan-tool", isSelected: false, disabled: false, display: true}, {id: 7, name: "General", class: "tc-general", isSelected: false, disabled: false, display: true}];
  public customerRoles: any = [{id: 1, name: 'Business Contact', disabled: false}, {id: 2, name: 'Billing Contact', disabled: false}, {id: 3, name: 'Shop Technician', disabled: false}];
  public businessRoles: any = [{id: 9, name: 'Customer Account Owner'}, {id: 11, name: 'Customer Admin'}, {id: 12, name: 'Customer End User'}];
  public imagePath: string = "assets/images";
  public threadCategory: any = 0;
  public threadCategoryTile: string = "Vehicle";
  public threadCategoryImage: string = `${this.imagePath}/repair-order/vehicle-info.svg`;
  public toolType: any = '';
  public toolName: any = '';
  public redirectionPage='';
  public pageTitleText='';
  public apiKey: string = Constant.ApiKey;
  public fromSearch = "";
  public toolTypeOptions: any = [];
  public toolNameOptions: any = [];
  public filterOptions: any = [];
  public attachmentLoading: boolean = true;
  public attachmentsData: any;
  public action = "view";
  public businessCount: number = 0;
  public approvedFlag=0;
  public editThreadId='';
  public dispatchId: any = 0;
  public adasReportId: any = 0;
  public assetPath: string = "assets/images/";
  public assetShopPath: string = `${this.assetPath}shop`;
  public assetPartPath: string = `${this.assetPath}parts`;
  public redirectUrl: string = "shop/view/";
  public defShopBanner: string = `${this.assetPath}common/default-shop-banner.png`;
  public collabticDomain: boolean = false;
  public editAccess: boolean;
  public displayNoRecords: boolean = false;
  public displayNoRecordsDefault: boolean = false;
  public assignTechDisable: boolean = true;
  public workstreamDisable: boolean = false;
  public endUser: boolean = false;
  public endUserOwner: boolean = false;
  public endUserAdmin: boolean = false;
  public endUserCustomer: boolean = false;
  public isAdmin: boolean = false;
  public editCustomerFlag: boolean = false;
  public addUserFlag: boolean = false;
  public editUserFlag: boolean = false;
  public callProFlag: boolean = false;
  public expandFlag: boolean;
  public accessFrom: string = "manage-workorder";
  public shopApiCall;
  public shopWsApiCall;
  public shopType: string = "";
  public publishStatus: string = "";
  public searchVal: string = "";
  public itemLimit: any = 20;
  public itemOffset: any = 0;
  public threadId: any = 0;
  public userId;
  public user;
  public domainId;
  public roleId;
  public businessRoleId;
  public countryId='';
  public platformId: string;
  public apiData: Object;
  public dayList: any = [{id: '0', name: 'Select'}, {id: '1 Day', name: '1 Day'},  {id: '2 Days', name: '2 Days'}, {id: '3 Days', name: '3 Days'}, {id: '4 Days', name: '4 Days'}, {id: '5 Days', name: '5 Days'}, {id: '6 Days', name: '6 Days'}, {id: '7 Days', name: '7 Days'}, {id: '8 Days', name: '8 Days'}, {id: '9 Days', name: '9 Days'}, {id: '10 Days', name: '10 Days'}, {id: '11 Days', name: '11 Days'}, {id: '12 Days', name: '12 Days'}, {id: '13 Days', name: '13 Days'}, {id: '14 Days', name: '14 Days'}, {id: '15 Days', name: '15 Days'}, {id: '16 Days', name: '16 Days'}, {id: '17 Days', name: '17 Days'}, {id: '18 Days', name: '18 Days'}, {id: '19 Days', name: '19 Days'}, {id: '20 Days', name: '20 Days'}, {id: '21 Day', name: '21 Day'}, {id: '22 Days', name: '22 Days'}, {id: '23 Days', name: '23 Days'}, {id: '24 Days', name: '24 Days'}, {id: '25 Days', name: '25 Days'}, {id: '26 Days', name: '26 Days'}, {id: '27 Days', name: '27 Days'}, {id: '28 Days', name: '28 Days'}, {id: '29 Days', name: '29 Days'}, {id: '30 Days', name: '30 Days'}];
  public hourList: any = [{id: '0', name: 'Select'}, {id: '1 Hour', name: '1 Hour'}, {id: '2 Hours', name: '2 Hours'}, {id: '3 Hours', name: '3 Hours'}, {id: '4 Hours', name: '4 Hours'}, {id: '5 Hours', name: '5 Hours'}, {id: '6 Hours', name: '6 Hours'}, {id: '7 Hours', name: '7 Hours'}, {id: '8 Hours', name: '8 Hours'}, {id: '9 Hours', name: '9 Hours'}, {id: '10 Hours', name: '10 Hours'}, {id: '11 Hours', name: '11 Hours'}, {id: '12 Hours', name: '12 Hours'}];
  public durationList: any = [{id: '0', name: 'Select'},{id: '10 Mins', name: '10 Mins'}, {id: '20 Mins', name: '20 Mins'}, {id: '30 Mins', name: '30 Mins'}, {id: '40 Mins', name: '40 Mins'}, {id: '50 Mins', name: '50 Mins'}];
  public approveOptions: any = [{id: 1, name: 'Yes', label: 'Yes 1', disabled: null}, {id: 0, name: 'No', label: 'No 1', disabled: null}];
  public appointmentOptions: any = [{id: 1, name: 'Date', label: 'Date & Time'},{id: 2, name: 'ASAP', label: 'ASAP'},{id: 3, name: 'Flexible', label: 'Flexible Time'}];
  public selectedAppointmentOptionId: any = 1;
  public selectedAppointmentOption: any = this.appointmentOptions[0].name;
  public isSameContact: boolean = false;
  public bodyHeight: number;
  public innerHeight: number;
  public tableRemoveHeight: number = 160;
  public fromPublic: any = 0;
  public groupId: number = 6;
  public displayNoRecordsShow = 0;
  public itemEmpty: boolean;
  public thumbView: boolean = true;
  public itemLength: number = 0;
  public itemTotal: number = 0;
  public itemList: object;
  public ROViewData = [];
  public RODetailData:any = [];
  public calproAdasData: any = [];
  public itemResponse = [];
  public shopSelectionList = [];
  public businessInfo: any = [];
  public pinImg: string;
  public pinStatus: number;
  public likeCount: number;
  public pinCount: number;
  public pinTxt: string;
  public navAction: string = "single";
  public title: string = "Repair Order";
  public shortTitle: string = "RO";
  public contentTypeValue;
  public contentTypeDefaultNewImg;
  public contentTypeDefaultNewText;
  public contentTypeDefaultNewTextDisabled: boolean = false;
  public shopUrl='';
  public newPartInfo: string = "Get started by tapping on ‘New SHOP’.";
  public chevronImg: string = `${this.assetPartPath}chevron.png`;
  public headercheckDisplay: string = "checkbox-hide";
  public headerCheck: string = "unchecked";
  public priorityIndexValue='';
  public shopIdArrayInfo: any=[];
  public shopAPICount: any="0";

  public makeValid: boolean = true;
  public modelValid: boolean = true;
  public yearValid: boolean = true;
  public serialNumberValid: boolean = true;
  public toolTypeValid: boolean = true;
  public toolNameValid: boolean = true;
  public scanVersionValid: boolean = true;
  public serialNumberReadOnly: boolean = false;
  public generateInvoiceFlag: boolean = false;
  public genereateInvoiceId: any = 0;

  public lazyLoading: boolean = false;
  public scrollInit: number = 0;
  public lastScrollTop: number = 0;
  public scrollTop: number;
  public scrollCallback: boolean = true;
  public opacityFlag: boolean = false;
  public step2: boolean = true;

  repairOrderListColumns: any = [];
  repairOrderList: any = [];
  public pageAccess: string = "parts";
  public successFlag: boolean = false;
  public successMsg: string = "";
  public visibilityChangeLimit=0;
  public showMap: any = false;
  public shopId: number;
  public marketId: number = 0;
  public marketName: string = "None";
  public businessName: string = '';
  public shopIndex: number;

  public description: string = '';
  public internalNotes: string = '';
  public odometerFlag: boolean = false;
  public problemDescFlag: boolean = false;
  public errroMsgFlag: boolean = false;
  public jobcodeArr: any = [];

  public readOnlyFlag: boolean = false;
  public ordernumberReadOnlyFlag: boolean = false;
  public dninvoiceReadOnlyFlag: boolean = false;
  public productservicesReadOnlyFlag: boolean = false;
  public serviceError: boolean = false;
  public serviceErrorMsg: string = '';
  public technicians: any = [];
  //public timeZoneList: any = [{id: 'EST', name: 'EST'},{id: 'CST', name: 'CST'},{id: 'MST', name: 'MST'},{id: 'PST', name: 'PST'}];
  public timeZoneList: any = [];
  public timeZoneInfo: any = '';
  // public currentTime: any = new Date();
  public ctime: string = moment().format('hh:mm A');
  public currDate: any = '';
  public paymentMethodSection: boolean = false;
  public creditCardCount:any = 0;
  public maskEmail: string = Constant.maskEmail;

  public modalConfig: any = {
    backdrop: "static",
    keyboard: false,
    centered: true,
  };

  public tvsDomain: boolean = false;
  public searchAction: boolean = false;
  public bodyElem;
  public descMoreModal: boolean = true;
  public manageTitle: string = '';
  serviceForm: UntypedFormGroup;
  serviceShopForm: UntypedFormGroup;
  serviceTechForm: UntypedFormGroup;
  serviceContactForm: UntypedFormGroup;
  toolNameForm: UntypedFormGroup;
  public businessPhoneNumberData:any;
  public phoneNumberData:any;
  public icountryName = '';
  public icountryCode = '';
  public idialCode = '';
  public iphoneNumber = '';
  public phonenoInputFlag:boolean = true;
  public phoneNumberValid:boolean = false;
  public invalidNumber:boolean = true;
  public emailValidationError:boolean = false;
  public emailValidationErrorMsg = "";
  public userPhoneNumberData:any;
  public userCountryName = '';
  public userCountryCode = '';
  public userDialCode = '';
  public userPhoneNumber = '';
  public userPhonenoInputFlag:boolean = true;
  public userPhoneNumberValid:boolean = false;
  public userInvalidNumber:boolean = true;
  public userEmailValidationError:boolean = false;
  public userEmailValidationErrorMsg = "";
  public emailDisable: boolean = false;
  public contactEmailDisable: boolean = false;
  public billingInfoSection: boolean = false;
  public paymentSectionFlag: boolean = false;
  public paymentSectionToggleDisable: boolean = true;
  selectedCustomer: any = [];
  selectedCustomerId: any = [];
  selectedContact: any = [];
  selectedContactId: any = [];
  selectedBillingContact: any = [];
  selectedBillingContactId: any = [];
  selectedTech: any = [];
  selectedTechId: any = [];
  regContactId: any = [];
  serviceSubmit = false;
  serviceFormValid = false;
  Time: any = [];
  Status: any = [];
  contacts: any = [];
  bussContacts: any = [];
  bussCustomers: any = [];
  Technician: any = [];
  serviceTech: any = [];
  Models: any = [];
  Makes: any = [];
  Years: any = [];
  vinIsValid = false;
  public vinVerfied = true;
  makeList: any = [];
  public parkingLot: boolean = false;
  public vehicleFormInfo = [];
  public vinValid = true;
  public vinDisable = false;
  public modelDisable:boolean = true;
  public modelLoading:boolean = false;
  public techLoading: boolean = false;
  public toolTypeDisable:boolean = true;
  public toolTypeLoading:boolean = false;
  public toolNameDisable:boolean = true;
  public toolNameLoading:boolean = false;
  public vinData: any = [];
  public modelPlaceHoder = "Select";
  public serviceShopSubmit:boolean = false;
  public serviceContactSubmit:boolean = false;
  public serviceTechSubmit:boolean = false;
  public toolNameSubmit: boolean = false;
  submitClicked = false
  formProcessing: boolean = false;
  public actionForm = '';
  public actionTitle = '';
  public actionFlag:boolean = false;
  public modalState = 'new';
  public servicetype: any = '';
  public ordertype: any = '';
  public servicetypeOptions: any = [];
  public ordertypeOptions: any = [];
  public marketDataOptions: any = [];
  public salesRepOptions: any = [];
  public paymentMethods: any = [];
  public autoSelectedWorkstream: any = [];
  public workstreamSelection: any = [];
  public workstreamValid: boolean = true;
  public defaultWSLabel: string = 'Select Workstream';
  public defaultCLabel: string = 'Select Contacts';
  public workstreamName = [];
  public workstreamItems: any = [];
  public workstreamId: any = [];
  public workstream: any = [];
  public currYear: any = moment().format('Y');
  public initYear = 1960;
  public marketFlag: boolean = false;
  public salesRepFlag: boolean = false;
  public postUploadActionTrue: boolean = false;
  public postUpload: boolean = true;
  public manageAction: string;
  public postApiData: object;
  public uploadedItems: any = [];
  public editAttachments: any = [];

  public commentUploadedItemsFlag: boolean = false;
  public commentUploadedItemsLength: number = 0;
  public contentType: number = parseInt(ContentTypeValues.RepairOrder);
  public mediaUploadItems: any = [];
  public mediaAttachments: any = [];
  public mediaAttachmentsIds: any = [];
  public displayOrder: number = 0;
  public EditAttachmentAction: 'attachments';
  public attachmentItems: any = [];
  public updatedAttachments: any = [];
  public deletedFileIds: any = [];
  public removeFileIds: any = [];

  public mediaConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'attachment-modal'};
  public unit: string = '';
  public unitOptions: any = [];

  public bussContact: string = '';
  public bussCustomer: string = '';
  public contactTechnician: string = '';
  public bodyClass2: string = "submit-loader";
  public bodyClass3: string = "action-sidebar";
  public bodyClass:string = "auth-index";
  public bodyClass1: string = "landing-page";
  public customerFormClass = '';
  public isSameBusinessEmail: any = 0;
  public isCustomerEmailInvite: any = 0;
  public isContactEmailInvite: any = 0;
  public disableSameBusinessEmail: boolean = false;
  public isSameContactPhone: any = 0;
  public disableSameContact: boolean = false;
  public checkBusinessEmailFlag: any = null;
  public businessEmailExist: boolean = false;
  public businessEmailExistMessage: string = "";
  public shopExist = true;
  public contactExist: boolean = false;
  public toolNameExist = false;
  public existError = '';
  public viewOptions: any = [];
  public view: any = '';
  public platform: any = 3;
  displayModal = false;
  displayNote = false;
  Shops: any = [];
  public empty: any = [];
  public contactDisable: boolean = true;
  public billingContactDisable: boolean = true;
  public requestTypeDisable: boolean = false;
  public showClear = false;
  public businessRoleClear: boolean = false;
  public selectedShop: any = [];
  public selectedEmail: any = '';
  //public serviceId: number = null;
  public odo;
  public roPageData:any;
  public roEstimationFlag: boolean = false;
  public escalationMatrix_array=[];
  public moreTitle: string = '';
  public moreDesc: string = '';
  public createRO: string = '';
  public editRO:boolean = false;
  public estimationSelectedItems: any;
  countryDropdownData: any;
  stateDropdownData: any;
  companyStateDropdownData: any[];
  public fuserDomain: boolean = false;
  public diagnationDomain: boolean = false;
  public iscanDomain: boolean = false;
  public aetoolsDomain: boolean = false;
  public lmvDomain: boolean = false;
  public defaultWorkstreamFlag: boolean = false;
  public cardFlag: boolean = false;
  public initcomplaint: string = '';
  public billingfirstname: string = '';
  public billinglastname: string = '';

  public vinDisplayModal: boolean = false;
  public dialogLoader: boolean = false;
  public dialogClose: boolean = false;
  public dialogEscClose: boolean = false;
  public vinDecode: string = 'Decoding VIN..';
  public dialogContent: string = this.vinDecode;

  public submitModal: boolean = false;
  public submitDialogClose: boolean = false;
  public submitDialogEscClose: boolean = false;
  public submitDialogContent: string = 'Submitting your request..';
  public submitEstimateDialogContent: string = 'Generating Estimate Template..';

  public tagItems: any;
  public errorCodes = [];
  public errorCodesNames = [];
  public trouble_code:any = [];
  public showErrorDTC: boolean = true;
  public roSub: Subscription;

  public roEstimatePreview: boolean = false;
  public roInvoicePreview: boolean = false;
  public supportTicketPath: string = "support-tickets";
  public previewUrl: string = "";
  public detailCallbackData: any = [];
  public tzMap: Record<string, string> = {
    // Eastern
    "EST": "America/New_York", // Eastern Standard Time (UTC-5)
    "EDT": "America/New_York", // Eastern Daylight Time (UTC-4)

    // Central
    "CST": "America/Chicago",  // Central Standard Time (UTC-6)
    "CDT": "America/Chicago",  // Central Daylight Time (UTC-5)

    // Mountain
    "MST": "America/Denver",   // Mountain Standard Time (UTC-7)
    "MDT": "America/Denver",   // Mountain Daylight Time (UTC-6)

    // Pacific
    "PST": "America/Los_Angeles", // Pacific Standard Time (UTC-8)
    "PDT": "America/Los_Angeles", // Pacific Daylight Time (UTC-7)

    // Alaska
    "AKST": "America/Anchorage",  // Alaska Standard Time (UTC-9)
    "AKDT": "America/Anchorage",  // Alaska Daylight Time (UTC-8)

    // Hawaii–Aleutian
    "HST": "Pacific/Honolulu",    // Hawaii Standard Time (UTC-10, no DST)
    "HAST": "America/Adak",       // Aleutian Islands (UTC-10)
    "HADT": "America/Adak",       // Aleutian Islands DST (UTC-9)

    // Atlantic (Puerto Rico, USVI)
    "AST": "America/Puerto_Rico", // Atlantic Standard Time (UTC-4, no DST)

    // Chamorro (Guam, Northern Mariana Islands)
    "ChST": "Pacific/Guam",       // Chamorro Standard Time (UTC+10, no DST)

    // Samoa
    "SST": "Pacific/Pago_Pago",   // Samoa Standard Time (UTC-11, no DST)

    // Special case: Arizona (Mountain but no DST)
    "AZ": "America/Phoenix"       // Arizona (UTC-7 year-round)
  };


  public Editor = ClassicEditor;

  public configCke: any;
  public configCkeComplaint: any;
  public configCkeNotes: any;
  // configCke: any = {
  //   placeholder: 'Enter Additional Problem Detail',
  //   toolbar: {
  //     items: [
  //       "bold",
  //        "Emoji",
  //        "italic",
  //        "link",
  //       "strikethrough",
  //        "|",
  //        "fontSize",
  //        "fontFamily",
  //        "fontColor",
  //        "fontBackgroundColor",
  //        "|",
  //        "bulletedList",
  //        "numberedList",
  //        "todoList",
  //        "|",
  //        "uploadImage",
  //        "pageBreak",
  //        "blockQuote",
  //        "insertTable",
  //        "mediaEmbed",
  //        "undo",
  //        "redo",

  //      ],
  //   },
  //   link: {
  //     // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
  //     addTargetToExternalLinks: true,
  //   },
  //   mediaEmbed:{ previewsInData: true },
  //   simpleUpload: {
  //     // The URL that the images are uploaded to.
  //     //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
  //     //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
  //     uploadUrl: this.apiUrl.uploadURL,
  //   },
  //   image: {
  //     resizeOptions: [
  //       {
  //         name: "resizeImage:original",
  //         value: null,
  //         icon: "original",
  //       },
  //       {
  //         name: "resizeImage:50",
  //         value: "50",
  //         icon: "medium",
  //       },
  //       {
  //         name: "resizeImage:75",
  //         value: "75",
  //         icon: "large",
  //       },
  //     ],
  //     toolbar: [
  //       "imageStyle:inline",
  //       "imageStyle:block",
  //       "imageStyle:side",
  //       "|",
  //       "resizeImage:50",
  //       "resizeImage:75",
  //       "resizeImage:original",
  //       "|",
  //       "toggleImageCaption",
  //       "imageTextAlternative",
  //     ],
  //   },
  //   table: {
  //     contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  //   },
  //   // This value must be kept in sync with the language defined in webpack.config.js.
  //   language: "en",
  // };

  // configCkeComplaint: any = {
  //   placeholder: 'Enter Customer Complaint',
  //   toolbar: {
  //     items: [
  //       "bold",
  //        "Emoji",
  //        "italic",
  //        "link",
  //       "strikethrough",
  //        "|",
  //        "fontSize",
  //        "fontFamily",
  //        "fontColor",
  //        "fontBackgroundColor",
  //        "|",
  //        "bulletedList",
  //        "numberedList",
  //        "todoList",
  //        "|",
  //        "uploadImage",
  //        "pageBreak",
  //        "blockQuote",
  //        "insertTable",
  //        "mediaEmbed",
  //        "undo",
  //        "redo",

  //      ],
  //   },
  //   link: {
  //     // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
  //     addTargetToExternalLinks: true,
  //   },
  //   mediaEmbed:{ previewsInData: true },
  //   simpleUpload: {
  //     // The URL that the images are uploaded to.
  //     //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
  //     //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
  //     uploadUrl: this.apiUrl.uploadURL,
  //   },
  //   image: {
  //     resizeOptions: [
  //       {
  //         name: "resizeImage:original",
  //         value: null,
  //         icon: "original",
  //       },
  //       {
  //         name: "resizeImage:50",
  //         value: "50",
  //         icon: "medium",
  //       },
  //       {
  //         name: "resizeImage:75",
  //         value: "75",
  //         icon: "large",
  //       },
  //     ],
  //     toolbar: [
  //       "imageStyle:inline",
  //       "imageStyle:block",
  //       "imageStyle:side",
  //       "|",
  //       "resizeImage:50",
  //       "resizeImage:75",
  //       "resizeImage:original",
  //       "|",
  //       "toggleImageCaption",
  //       "imageTextAlternative",
  //     ],
  //   },
  //   table: {
  //     contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  //   },
  //   // This value must be kept in sync with the language defined in webpack.config.js.
  //   language: "en",
  // };

  // configCkeNotes: any = {
  //   placeholder: 'Internal Notes',
  //   toolbar: {
  //     items: [
  //       "bold",
  //        "Emoji",
  //        "italic",
  //        "link",
  //       "strikethrough",
  //        "|",
  //        "fontSize",
  //        "fontFamily",
  //        "fontColor",
  //        "fontBackgroundColor",
  //        "|",
  //        "bulletedList",
  //        "numberedList",
  //        "todoList",
  //        "|",
  //        "uploadImage",
  //        "pageBreak",
  //        "blockQuote",
  //        "insertTable",
  //        "mediaEmbed",
  //        "undo",
  //        "redo",

  //      ],
  //   },
  //   link: {
  //     // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
  //     addTargetToExternalLinks: true,
  //   },
  //   mediaEmbed:{ previewsInData: true },
  //   simpleUpload: {
  //     // The URL that the images are uploaded to.
  //     //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
  //     //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
  //     uploadUrl: this.apiUrl.uploadURL,
  //   },
  //   image: {
  //     resizeOptions: [
  //       {
  //         name: "resizeImage:original",
  //         value: null,
  //         icon: "original",
  //       },
  //       {
  //         name: "resizeImage:50",
  //         value: "50",
  //         icon: "medium",
  //       },
  //       {
  //         name: "resizeImage:75",
  //         value: "75",
  //         icon: "large",
  //       },
  //     ],
  //     toolbar: [
  //       "imageStyle:inline",
  //       "imageStyle:block",
  //       "imageStyle:side",
  //       "|",
  //       "resizeImage:50",
  //       "resizeImage:75",
  //       "resizeImage:original",
  //       "|",
  //       "toggleImageCaption",
  //       "imageTextAlternative",
  //     ],
  //   },
  //   table: {
  //     contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  //   },
  //   // This value must be kept in sync with the language defined in webpack.config.js.
  //   language: "en",
  // };

  extraData = {metadata: null};
  cardCaptureReady = 0;
  stripeOptions = {
    disableLink: true,
    hidePostalCode: true,
    style: {
      base: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      complete: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      empty: {
        color: "#495057",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      },
      invalid: {
        color: "#eb1c26",
        fontFamily: "",
        fontSize: "",
        fontSmoothing: "",
        fontStyle: "",
        fontVariant: "",
        iconColor: "",
        lineHeight: "",
        letterSpacing: "",
        textAlign: "",
        textDecoration: "",
        textShadow: "",
        textTransform: "",
      }
    }
  };
  public collabticApi: string;
  public estimateCount: any = 0;
  public invoiceCount: any = 0;
  public paymentCount: any = 0;
  public paymentData: any = [];
  public isEstimateApprove: any = 0;
  public isInvoiceApprove: any = 0;
  public estimateVersion: any = '';
  public estimateDate: string = '';
  public estimateData: any = [];
  public estimateHistory: any = [];
  public isManualEst: any = 0;
  public isManualInvoice: any = 0;
  public invoiceDate: string = '';
  public invoiceVersion: any = '';
  public invoiceData: any = [];
  public invoiceHistory: any = [];
  public stripeInfo: any = [];
  public estimateFlag: boolean = true;
  public estimateSubmit: boolean = false;
  public invoiceSubmit: boolean = false;
  public paymentItemData: any = [];
  public estimateInfo = [{estimateCount: this.estimateCount, invoiceCount: this.invoiceCount, paymentCount: this.paymentCount, isEstimateApprove: this.isEstimateApprove, estimateId: 0, invoiceId: 0, estimateData: this.estimateData, estimateHistory: this.estimateHistory, isManualEst: this.isManualEst, isInvoiceApprove: this.isInvoiceApprove, invoiceData: this.invoiceData, invoiceHistory: this.invoiceHistory, isManualInvoice: this.isManualInvoice, paymentData: this.paymentData, stripeInfo: this.stripeInfo}]
  public sidebarList: any = [
    {id: 1, name: this.shortTitle, class: 'menu-item ro', section: 'repair-order', 'display': true, isActive: true, isHide: false, icon: 'ro.png'},
    {id: 6, name: 'ADAS Report', class: 'menu-item calpro-adas', section: 'adas', 'display': false, isActive: false, isHide: true, icon: 'calpro-adas.png'},
    {id: 2, name: 'Estimate', class: 'menu-item estimate', section: 'manage-estimation', 'display': false, isActive: false, isHide: false, icon: 'estimate.png'},
    {id: 4, name: 'Invoice', class: 'menu-item invoice', section: 'manage-invoice', 'display':false, isActive: false, isHide: false, icon: 'invoice.png'}    
  ];
  public roFlag: boolean = true;
  public roEstimateFlag: boolean = false;
  public roInvoiceFlag: boolean = false;
  public roAdasReportFlag: boolean = false;
  public roViewEstActionFlag: boolean = false;
  public appEstimateFlag: boolean = false;
  public actionSection: string = 'repair-order';
  public actionType: any = SolrContentTypeValues.repairOrder;
  public systemMsg: Message[];
  public teamId: string = localStorage.getItem('defaultTechSupportTeamId');
  public jobTypeOptions: any = [];
  public selectedJobItemIds: any = [];
  public selectedJobItems: any = [];
  public isTechMarketMap: boolean = false;
  public gbbDomain: boolean = false;
  public dmaDomain: boolean = false;
  public placeholderText1: string = '';
  public partNumberStr: string = '';
  public partBatteryTypeStr: string = '';
  public partDescriptionStr: string = '';
  public adasThirdPartData: any = '';

  public inventorySourceOptions: any = [
    {id: 1, name: 'Installer Inventory'},
    {id: 2, name: 'Shipped to Customer'},
  ];
  public inventorySource: number | null = null;
  public customerInventory: any = 1;
  public availableQty: any = 0;
  public allocatedCount: any = 0;
  public isSpecialPart: any = false;
  public insuranceCompanyId: any = '';
  public estimateCreatedOn: any;
  public orderCreatedOn: any;
  public verificationCreatedOn: any;
  public companiesPopList: any = [];
  public SHIDomain: boolean = false;

  public partsSelectedCols = [];
  public partsSelectedList = [];
  public toolsSelectedCols = [];
  public toolsSelectedList = [];
  
  constructor(
    private router: Router,
    private location: PlatformLocation,
    private commonApi: CommonService,
    public acticveModal: NgbActiveModal,
    private modalService: NgbModal,
    private config: NgbModalConfig,
    public apiUrl: ApiService,
    private repairOrderApi: RepairOrderService,
    private titleService: Title,
    private formBuilder: UntypedFormBuilder,
    private LandingpagewidgetsAPI: LandingpageService,
    private authenticationService: AuthenticationService,
    private baseSerivce: BaseService,
    private threadApi: ThreadService,
    private ProductMatrixApi: ProductMatrixService,
    private threadPostService: ThreadPostService,
    private userDashboardApi: UserDashboardService,
    private primengConfig: PrimeNGConfig,
    private cdr: ChangeDetectorRef,
    private roService: ROService,
    private store: Store<State>,
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    config.size = "dialog-centered";

    this.configCke = {
      placeholder: 'Enter Additional Problem Detail',
      toolbar: {
        items: [
          "bold",
           "Emoji",
           "italic",
           "link",
          "strikethrough",
           "|",
           "fontSize",
           "fontFamily",
           "fontColor",
           "fontBackgroundColor",
           "|",
           "bulletedList",
           "numberedList",
           "todoList",
           "|",
           "uploadImage",
           "pageBreak",
           "blockQuote",
           "insertTable",
           "mediaEmbed",
           "undo",
           "redo",
  
         ],
      },
      link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,
      },
      mediaEmbed:{ previewsInData: true },
      simpleUpload: {
        // The URL that the images are uploaded to.
        //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
        //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
        uploadUrl: this.apiUrl.uploadURL,
      },
      image: {
        resizeOptions: [
          {
            name: "resizeImage:original",
            value: null,
            icon: "original",
          },
          {
            name: "resizeImage:50",
            value: "50",
            icon: "medium",
          },
          {
            name: "resizeImage:75",
            value: "75",
            icon: "large",
          },
        ],
        toolbar: [
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "resizeImage:50",
          "resizeImage:75",
          "resizeImage:original",
          "|",
          "toggleImageCaption",
          "imageTextAlternative",
        ],
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      // This value must be kept in sync with the language defined in webpack.config.js.
      language: "en",
    };
  
    this.configCkeComplaint = {
      placeholder: 'Enter Customer Complaint',
      toolbar: {
        items: [
          "bold",
           "Emoji",
           "italic",
           "link",
          "strikethrough",
           "|",
           "fontSize",
           "fontFamily",
           "fontColor",
           "fontBackgroundColor",
           "|",
           "bulletedList",
           "numberedList",
           "todoList",
           "|",
           "uploadImage",
           "pageBreak",
           "blockQuote",
           "insertTable",
           "mediaEmbed",
           "undo",
           "redo",
  
         ],
      },
      link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,
      },
      mediaEmbed:{ previewsInData: true },
      simpleUpload: {
        // The URL that the images are uploaded to.
        //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
        //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
        uploadUrl: this.apiUrl.uploadURL,
      },
      image: {
        resizeOptions: [
          {
            name: "resizeImage:original",
            value: null,
            icon: "original",
          },
          {
            name: "resizeImage:50",
            value: "50",
            icon: "medium",
          },
          {
            name: "resizeImage:75",
            value: "75",
            icon: "large",
          },
        ],
        toolbar: [
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "resizeImage:50",
          "resizeImage:75",
          "resizeImage:original",
          "|",
          "toggleImageCaption",
          "imageTextAlternative",
        ],
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      // This value must be kept in sync with the language defined in webpack.config.js.
      language: "en",
    };
  
    this.configCkeNotes = {
      placeholder: 'Internal Notes',
      toolbar: {
        items: [
          "bold",
           "Emoji",
           "italic",
           "link",
          "strikethrough",
           "|",
           "fontSize",
           "fontFamily",
           "fontColor",
           "fontBackgroundColor",
           "|",
           "bulletedList",
           "numberedList",
           "todoList",
           "|",
           "uploadImage",
           "pageBreak",
           "blockQuote",
           "insertTable",
           "mediaEmbed",
           "undo",
           "redo",
  
         ],
      },
      link: {
        // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
        addTargetToExternalLinks: true,
      },
      mediaEmbed:{ previewsInData: true },
      simpleUpload: {
        // The URL that the images are uploaded to.
        //uploadUrl: Constant.CollabticApiUrl+""+Constant.uploadUrl,
        //uploadUrl:"https://collabtic-v2api.collabtic.com/accounts/UploadAttachtoSvr",
        uploadUrl: this.apiUrl.uploadURL,
      },
      image: {
        resizeOptions: [
          {
            name: "resizeImage:original",
            value: null,
            icon: "original",
          },
          {
            name: "resizeImage:50",
            value: "50",
            icon: "medium",
          },
          {
            name: "resizeImage:75",
            value: "75",
            icon: "large",
          },
        ],
        toolbar: [
          "imageStyle:inline",
          "imageStyle:block",
          "imageStyle:side",
          "|",
          "resizeImage:50",
          "resizeImage:75",
          "resizeImage:original",
          "|",
          "toggleImageCaption",
          "imageTextAlternative",
        ],
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
      },
      // This value must be kept in sync with the language defined in webpack.config.js.
      language: "en",
    };

    this.roService.adasThirdPartyData$.subscribe(data => {
      console.log(this.roAdasReportFlag)
      console.log(data)
    });
  }

  @HostListener("scroll", ["$event"])
  onScroll(event) {
    this.scroll(event);
  }

  // convenience getters for easy access to form fields
  get sf() { return this.serviceForm.controls; }
  get stf() { return this.serviceTechForm.controls; }
  get scf() { return this.serviceContactForm.controls; }
  get shf() { return this.serviceShopForm.controls; }
  get tnf() { return this.toolNameForm.controls; }

  ngOnInit(): void {
    this.baseV3ApiUrl = this.apiUrl.apiCollabticV3BaseUrl();
    console.log(this.router.url)
    this.baseApiUrl = this.apiUrl.apiCollabticBaseUrl();
    let currDate:any = this.commonApi.createDateAsUTC(new Date());
    currDate = moment(new Date());
    this.currDate = new Date(currDate);
    this.bodyElem = document.getElementsByTagName('body')[0];
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;

    window.addEventListener('scroll', this.scroll, true);

    let platformId = localStorage.getItem("platformId");
    if (platformId == null || platformId == 'null') {
      platformId = PlatFormType.Collabtic;
    }
    if (platformId == PlatFormType.Collabtic) {
      this.collabticApi = Constant.CollabticApiUrl;
    } else if (platformId == PlatFormType.MahleForum) {
      this.collabticApi = Constant.TechproMahleApi;
    } else if (platformId == PlatFormType.CbaForum) {
      this.collabticApi = Constant.CbaApiUri;
    } else if (platformId == PlatFormType.KiaForum) {
      this.collabticApi = Constant.KiaApiUri;
    } else {
      this.collabticApi = Constant.CollabticApiUrl;
    }

    let isTechMarketMap:any = localStorage.getItem('isTechMarketMap');
    this.isTechMarketMap = (isTechMarketMap > 0) ? true : false;
    this.countryId = localStorage.getItem('countryId');
    let businessRole = localStorage.getItem('businessRole');
    this.businessRoleId = (businessRole) ? businessRole : 0;
    this.fuserDomain = this.domainId == '343' ? true : false;
    this.diagnationDomain = this.domainId == '338' ? true : false;
    this.SHIDomain = this.domainId == '518' ? true : false;
    this.endUser = (this.roleId == 4) ? true : false;
    this.endUserOwner = (this.endUser && this.businessRoleId == 9) ? true : false;
    this.endUserAdmin = (this.endUser && this.businessRoleId == 11) ? true : false;
    this.endUserCustomer = (this.endUser && this.businessRoleId == 12) ? true : false;
    this.isAdmin = (this.roleId != 4) ? true : false;
    this.defaultWorkstreamFlag = (this.roleId == 4) ? true : false;
    switch(this.domainId) {
      case 343:
        this.fuserDomain = true;
        break;
      case 338:
        this.diagnationDomain = true;
        this.threadCategory = 1;
        break;
      case 366:
        this.iscanDomain = true;
        this.cardFlag = true;
        break;
      case 411:
        this.aetoolsDomain = true;
        this.defaultWorkstreamFlag = true;
        this.setupDefaultWorkstream();
        break;
      case 395:
        this.lmvDomain = true;
        this.defaultWorkstreamFlag = (this.endUser) ? false : true;
        if(this.defaultWorkstreamFlag) {
          this.setupDefaultWorkstream();
        }
        break;
      case 432:
        this.servicetype = (this.endUser) ? 2 : this.servicetype;
        break;
      case 462:
      case 511:
        this.gbbDomain = true;
        break;
      case 526:
        this.dmaDomain = true;
        break;  
    }

    if(this.dmaDomain) {
      this.setupDmaSidebar();
      this.threadCategory = 10;
      this.threadCategoryTile = 'Part';
      this.threadCategoryImage = `${this.threadCategoryImage}/thread/tc-part-normal.svg`;
    }

    if(this.SHIDomain){
      this.partsSelectedList = [
       {
        id: 1,
         partBannerImg: "assets/images/repair-order/parts-image-1.png",
         isDefault: 0,
         part: "MCC",
         partdesc: "Marathon Cryopump Controller",
         parttype: "Controller",
         partsystem: "-",
         partinventory: "5",
         partavailable: "3",
       },
       {
         id: 2,
         partBannerImg: "assets/images/repair-order/parts-imag-2.png",
         isDefault: 0,
         part: "FSGL",
         partdesc: "Flexible & Superflex Gas Lines",
         parttype: "Gas Line",
         partsystem: "-",
         partinventory: "10",
         partavailable: "6",
       },
     ]
    

    this.partsSelectedCols = [
      {
        columnName: "image",
        columnpredefind: "1",
        field: 'image',
        header: 'Picture',
        columnpclass: " shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "part",
        columnpredefind: "1",
        field: 'part',
        header: 'Part#',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partdesc",
        columnpredefind: "1",
        field: 'partdesc',
        header: 'Part Description',
        columnpclass: "shi-tb-col-7",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "parttype",
        columnpredefind: "1",
        field: 'parttype',
        header: 'Type',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partsystem",
        columnpredefind: "1",
        field: 'partsystem',
        header: 'System',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partinventory",
        columnpredefind: "1",
        field: 'partinventory',
        header: 'Inventory',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partavailable",
        columnpredefind: "1",
        field: 'partavailable',
        header: 'Available',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
    ];



  this.toolsSelectedList = [
       {
         id: 1,
         toolBannerImg: "assets/images/repair-order/tools-imag-1.png",
         isDefault: 0,
         toolId: "4354679",
         assetId: "34545658",
         toolname: "Installation Wrench Kits",
         tooldesc: "Tools for installation, maintenance or service on SHI systems",
         sr: "H14300328",
       },
       {
         id: 2,
         toolBannerImg: "assets/images/repair-order/tools-imag-2.png",
         isDefault: 0,
         toolId: "4354678",
         assetId: "34545657",
         toolname: "Gas Charging Valve",
         tooldesc: "Gas Charging Valve",
         sr: "M15645728",
       },
     ]
    

    this.toolsSelectedCols = [
      {
        columnName: "image",
        columnpredefind: "1",
        field: 'image',
        header: 'Picture',
        columnpclass: " shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "toolId",
        columnpredefind: "1",
        field: 'toolId',
        header: 'Tool ID',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "assetId",
        columnpredefind: "1",
        field: 'assetId',
        header: 'Asset ID',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "toolname",
        columnpredefind: "1",
        field: 'toolname',
        header: 'Tool Name',
        columnpclass: "shi-tb-col-6",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "tooldesc",
        columnpredefind: "1",
        field: 'tooldesc',
        header: 'Tool Description',
        columnpclass: "shi-tb-col-7",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "sr",
        columnpredefind: "1",
        field: 'sr',
        header: 'Sr#',
        columnpclass: "shi-tb-col-2",
        headerId: "0",
        inputType: "0"
      },
    ];

  }

    if (this.createParamReportId && this.createParamReportId != '' && this.createParamReportId != undefined) {
      this.calproAdasData = this.calproAdasReportData;
    }

    this.servicetype = (this.serviceTypeId > 0) ? this.serviceTypeId : this.servicetype;

    this.editUserFlag = (!this.endUserCustomer) ? true : false;
    this.step2 = (this.iscanDomain && this.endUser) ? false : true;
    if(this.endUser) {
      this.threadCategory = 1;
      if(!this.lmvDomain) {
        this.setupDefaultWorkstream();
      }
    }

    let callProFlag:any = localStorage.getItem('callProFlag');
    callProFlag = (callProFlag && callProFlag != undefined) ? callProFlag : 0;
    this.callProFlag = (callProFlag == 1) ? true : false;
    if(this.callProFlag) {
      this.checkAccessLevel();
    }

    let salesRep:any = localStorage.getItem('salesRepCount');
    salesRep = (salesRep) ? salesRep : 0;
    this.salesRepFlag = (salesRep > 0) ? true : false;

    let showShopTech:any = localStorage.getItem('showShopTech');
    showShopTech = (showShopTech && showShopTech != '' && showShopTech != undefined) ? showShopTech : 'false';
    this.showShopTechFlag = (showShopTech == 'false' || this.dmaDomain) ? false : true;

    if(this.defaultWorkstreamFlag) {
      this.threadCategory = 1;
      let itemwsid;
      switch(this.domainId) {
        case 411:
          itemwsid = "770";
          break;
        case 395:
          if(!this.endUser) {
            itemwsid = "788";
          }
          break;
      }
      let itemwsidArr:any = [];
      itemwsidArr.push(itemwsid);
      this.workstreamId = itemwsidArr;
      this.assignTechDisable = false;
    }

    let getParams:any = localStorage.getItem('param');
    getParams = (getParams && getParams != 'undefined') ? JSON.parse(getParams) : '';
    if(getParams != '') {
      let contItems = getParams.items;
      let cindex = contItems.findIndex(option => parseInt(option.contentTypeId) == this.contentType);
      if(cindex >= 0) {
        this.title = contItems[cindex].name;
        this.shortTitle = this.title.split(' ').map(x => x[0]).join('');
        this.sidebarList[0].name = this.shortTitle;
      }
    }

    this.placeholderText1 = this.gbbDomain ? "Customer Order#" : "Customer Shop "+this.shortTitle+"#";

    this.bodyHeight = window.innerHeight;
    this.platformId = localStorage.getItem('platformId');
    this.collabticDomain = (this.platformId=='1') ? true : false;
    this.setScreenHeight();

    this.unit = "MI";
    this.unitOptions = ["MI" ,"KM"];

    this.problemDescFlag = (this.diagnationDomain) ? this.problemDescFlag : false;

    this.servicetype = (this.diagnationDomain || this.defaultWorkstreamFlag || (this.endUser && this.lmvDomain && !this.defaultWorkstreamFlag)) ? 1 : this.servicetype;
    
    this.resetServiceFormData();
    this.loadScript();

    const payload = new FormData();
    payload.append('domainId', this.domainId);
    payload.append('userId', this.userId);
    this.repairOrderApi.getCompaniesList(payload).subscribe((res)=> {
      if (res?.status == 'Success') {
        this.companiesPopList = res?.data || [];
      }
    });

    let skipSetup = false;
    this.roService.adasThirdPartyDataSubjectRo$.subscribe(data => {
      console.log(this.roAdasReportFlag, this.calproReportRef)
      console.log(data)
      if(this.roAdasReportFlag) {
        return false;
      }
      
      if (data) {
        if(this.calproReportRef) {
          this.calproReportRef.thirdPartyReport.data = data.reportData;
          this.calproReportRef.thirdPartyReport.roMapData = data.roMapData;
        }
        this.roService.setAdasThirdPartyDataRo(null);
        this.adasThirdPartyDataUpdate(this.calproReportRef.thirdPartyReport);          
      }
    });
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', this.serviceForm.value);
    if (!this.endUser && this.createParamShopId && this.createParamShopId != '' && this.createParamShopId != undefined) {
      this.getShopList(this.createParamShopId);
    }
    setTimeout(() => {
      this.initializeCreateParams();
    }, 2000);
  }

  public initializeCreateParams() {
    if (this.createParamSalesRepId && this.createParamSalesRepId != '' && this.createParamSalesRepId != undefined) {
      this.serviceForm.value.salesRepId = parseInt(this.createParamSalesRepId);
    }
    if (this.createParamShopId && this.createParamShopId != '' && this.createParamShopId != undefined) {
      this.shopId = parseInt(this.createParamShopId);
      this.serviceForm.value.shopId = this.shopId;
      if(!this.endUser) {
        this.shopChanged('change', '', this.shopId);
        //console.log('createParamShopId', this.shopId , this.selectedShop);
      }
      this.marketId = this.selectedShop?.marketId;
      this.createParamMarketId = this.selectedShop?.marketId;
      this.marketName = this.selectedShop?.marketName;
    }
    if (this.createParamMarketId && this.createParamMarketId != '' && this.createParamMarketId != undefined) {
      this.serviceForm.value.marketId = parseInt(this.createParamMarketId);
      let marketIndex = this.marketDataOptions.findIndex(option => option.id == this.createParamMarketId);
      if(marketIndex > 0) {
        this.marketName = this.marketDataOptions[marketIndex].name;
      }
    }
    if(!this.endUser && this.createParamContactId && this.createParamContactId != '' && this.createParamContactId != undefined) {
      this.selectedContactId = [parseInt(this.createParamContactId)];
      this.serviceForm.value.serviceContact = this.selectedContactId;
      this.serviceForm.patchValue({serviceContact: this.selectedContactId});
    }
    if (this.createParamReportId && this.createParamReportId != '' && this.createParamReportId != undefined) {
      this.calproAdasData = this.calproAdasReportData;
      this.removeReportFlag = true;
      this.serviceForm.patchValue({adasReportId: parseInt(this.createParamReportId)});
    }
    if (this.createParamVIN && this.createParamVIN != '' && this.createParamVIN != undefined) {
      let wsId = localStorage.getItem('defaultWorkstream');
      this.workstreamId = [];
      this.workstreamSelection = this.workstreamItems.filter(option => option.id == wsId);
      this.workstreamId = [wsId];
      this.serviceForm.patchValue({workstream: this.workstreamSelection});
      this.getCategoryData();
      setTimeout(() => {
        this.serviceForm.patchValue({vin: this.createParamVIN});
        this.vinChanged('change', this.createParamVIN, 'adasReport');
      }, 2000);
    }
    console.log('initializeCreateParams', this.serviceForm.value);
  }

  public loadScript() {
    const node = document.createElement('script');
    node.src = 'https://maps.googleapis.com/maps/api/js?key=' + environment.googleApiKey;
    node.type = 'text/javascript';
    console.log(node);
    document.getElementsByTagName('head')[0].appendChild(node);
  }

 scroll = (event: any): void => {
    if(event.target.id == 'ro-scroll') {
      if(this.dropdown1 && this.dropdown1.show){
         this.dropdown1.hide();
      }
      if(this.dropdown2 && this.dropdown2.show){
         this.dropdown2.hide();
      }
      if(this.dropdown3 && this.dropdown3.show){
         this.dropdown3.hide();
      }
      if(this.dropdown4 && this.dropdown4.show){
         this.dropdown4.hide();
      }
      if(this.dropdown5 && this.dropdown5.show){
         this.dropdown5.hide();
      }
      if(this.dropdown6 && this.dropdown6.show){
         this.dropdown6.hide();
      }
      if(this.dropdown7 && this.dropdown7.show){
         this.dropdown7.hide();
      }
      if(this.dropdown8 && this.dropdown8.show){
         this.dropdown8.hide();
      }
    }
 }

  roApiCallBack(apiData) {
    this.workOrderId = (this.workOrderType == 'edit') ? this.workOrderId : apiData['workOrderId'];
    let timeout = (this.roViewEstActionFlag) ? 100 : 2000;
    if(!this.roViewEstActionFlag) {
      const msgModalRef = this.modalService.open(SuccessModalComponent, this.modalConfig);
      if(this.workOrderType == 'edit'){
        msgModalRef.componentInstance.successMessage = "RO Updated Successfully";
      }
      else{
        msgModalRef.componentInstance.successMessage = "RO Created Successfully";
      }
      setTimeout(() => {
        msgModalRef.dismiss('Cross click');
      }, 2000);
    }

    setTimeout(() => {
      let data = {
        id: this.workOrderId,
        action: 'update',
        closeFlag: !this.roViewEstActionFlag,
        roAction: ''
      };
      this.ROManageService.emit(data);
      if(this.roViewEstActionFlag) {

      }
      setTimeout(() => {
        if(this.roViewEstActionFlag) {
          this.successFlag = false;
          this.postUpload = false;
          if(this.editRO) {
            this.viewEstimate();
          } else {
            setTimeout(() => {
              this.workOrderId = this.workOrderId;
              this.workOrderType = 'edit';
              this.editRO = true;
              this.manageTitle = `Edit ${this.title} ID# ${this.workOrderId}`;
              this.createRO = `Update ${this.shortTitle}`;
              this.editRepairOrderDetail();
            }, 2000);
          }
        }
      }, 1000);
    }, timeout);
  }

  emptyContact() {
    this.selectedContact = [];
    this.selectedContactId = [];
    this.contacts = [];
    this.shopUserEmailFlag = false;
    this.shopUserEmail = '';
    this.selectedBillingContact = [];
    this.selectedBillingContactId = [];
  }

  createForm(action, item:any = '', date:any = '') {
    this.isCustomerEmailInvite = 0;
    this.isContactEmailInvite = 0;
    this.customerFormClass = '';
    switch (action) {
      case 'service':
        this.vinIsValid = false;
        this.vinValid = true;
        this.emptyContact();
        console.log(this.workstreamSelection)
        const vinPattern = `^(?=.*[0-9])(?=.*[A-z])[0-9A-z-]{17}$`;
        let marketId = 0;
        /* let marketId = (item.marketIdInt && item.marketIdInt != undefined) ? item.marketIdInt : 0;
        let userMarketData: any = localStorage.getItem('userMarketData');
        userMarketData = (userMarketData && userMarketData != undefined) ? JSON.parse(userMarketData) : [];
        let userMarketId:any = localStorage.getItem('marketId');
        if(userMarketData.length == 1 && userMarketId > 0) {
          marketId = parseInt(userMarketId);
        } */
        let salesRepId = (item.salesRepIdInt && item.salesRepIdInt != undefined) ? item.salesRepIdInt : 0;

        if (this.createParamSalesRepId && this.createParamSalesRepId != '' && this.createParamSalesRepId != undefined) {
          salesRepId = parseInt(this.createParamSalesRepId);
        }
        if (this.createParamMarketId && this.createParamMarketId != '' && this.createParamMarketId != undefined) {
          marketId = parseInt(this.createParamMarketId);
        }

        if(this.diagnationDomain){
          if(this.editRO){
            this.serviceForm = this.formBuilder.group({
              workstream: [this.workstreamSelection],
              servicetype: [this.servicetype],
              repairOrder: [''],
              shopId: ['', [Validators.required]],
              serviceContact: ['', [Validators.required]],
              cardHolderName: '',
              vin: ['',],
              make: [''],
              model: [''],
              odo: [''],
              year: [''],
              ordernumber: ['', [Validators.required]],
              //productservices: ['',[Validators.required]],
              dninvoice: ['', [Validators.required]],
              serviceTech: [''],
              description: [''],
              billingfirstname: [''],
              billinglastname: [''],
              initcomplaint: [''],
              marketId,
              salesRepId,
              estimateCreatedOn: [this.estimateCreatedOn, []],
              insuranceCompanyId: [this.insuranceCompanyId, []]
            });
          }
          else{
            this.serviceForm = this.formBuilder.group({
              workstream: [this.workstreamSelection, [Validators.required]],
              servicetype: [this.servicetype],
              repairOrder: [''],
              shopId: ['', [Validators.required]],
              serviceContact: ['', [Validators.required]],
              vin: ['', [Validators.pattern(vinPattern)]],
              make: ['', [Validators.required]],
              model: ['', [Validators.required]],
              odo: ['', []],
              unit: ['', []],
              year: ['', [Validators.required]],
              ordernumber: ['', [Validators.required]],
              //productservices: ['',[Validators.required]],
              dninvoice: ['',[Validators.required]],
              serviceTech: ['', [Validators.required]],
              description: ['', [Validators.required]],
              billingfirstname: ['', []],
              billinglastname: ['', []],
              initcomplaint: ['', []],
              marketId,
              salesRepId,
              adasReportId: ['', []],
              estimateCreatedOn: [this.estimateCreatedOn, []],
              insuranceCompanyId: [this.insuranceCompanyId, []]
            });
          }
        }
        else{
          let aptDate:any = item.appointmentDateStr && item.appointmentDateStr != undefined ? item.appointmentDateStr : '';
          if(aptDate != '') {
            let mdate:any = moment(aptDate);
            aptDate = new Date(mdate);
          }
          let cdueDate:any = item.dueDateStr && item.dueDateStr != undefined ? item.dueDateStr : '';
          if(cdueDate != '') {
            let cdate:any = moment(cdueDate);
            cdueDate = new Date(cdate);
          }          
          this.servicetype = (this.defaultWorkstreamFlag) ? 1 : this.servicetype;
          let paymentToggle = 0;
          let referenceShopRO = item.referenceShopROStr && item.referenceShopROStr != undefined ? item.referenceShopROStr : '';
          referenceShopRO = (referenceShopRO == 0) ? '' : referenceShopRO;
          this.ordertype = item.orderTypeJsonArr && item.orderTypeJsonArr != undefined && item.orderTypeJsonArr.length>0 ? item.orderTypeJsonArr[0].id : '';
          let customerSyteLine = item.customerSyteLineStr && item.customerSyteLineStr != undefined ? item.customerSyteLineStr : '';
          let customerPO = item.customerpoStr && item.customerpoStr != undefined ? item.customerpoStr : '';
          
          let currDate = '';
          if(this.domainId == 462 || this.domainId == 511) {
            currDate = '';  
          } else {
            currDate = (!this.editRO) ? this.currDate : '';
          }

          let appointmentDate = item.appointmentDateStr && item.appointmentDateStr != undefined ? aptDate : currDate;
          let appointmentTime = item.appointmentTimeStr && item.appointmentTimeStr != undefined ? item.appointmentTimeStr : '';
          if(appointmentTime != '') {
            appointmentTime = moment(appointmentTime, "HH:mm:ss A").format('h:mm A');            
          }
          if(!this.editRO && appointmentTime == '') {
            let ctime = (this.domainId != 462 && this.domainId != 511) ? this.ctime : '';
            appointmentTime = ctime;
          }
          let timeZone = item.appointmentTimeZoneStr && item.appointmentTimeZoneStr != undefined ? item.appointmentTimeZoneStr : '';
          if(timeZone != '') {
            this.timeZoneList.push({id: timeZone, name: timeZone});
          }
          let dueDate = item.dueDateStr && item.dueDateStr != undefined ? cdueDate : this.currDate;
          let dueTime = item.dueTimeStr && item.dueTimeStr != undefined ? item.dueTimeStr : this.ctime;
          let assignTech = (item.assignTechnicianIdStr && item.assignTechnicianIdStr != undefined) ? JSON.parse(item.assignTechnicianIdStr) : [];
          let isPreApproved = 'No';
          if(!this.editRO) {
            let roInternalApprove:any = localStorage.getItem('roInternalApprove');
            let roCustomerApprove:any = localStorage.getItem('roCustomerApprove');
            if(this.endUser) {
              isPreApproved = roCustomerApprove > 0 ? 'Yes' : isPreApproved;
            } else {
              isPreApproved = roInternalApprove > 0 ? 'Yes' : isPreApproved;
            }
          }
          this.assignTechDisable = (isPreApproved == 'Yes') ? false : this.assignTechDisable;
          let jobItems = (item.jobItemsIntArr && item.jobItemsIntArr != undefined) ? JSON.parse(item.jobItemsIntArr) : [];
          let jobType = (item.jobTypeIdInt && item.jobTypeIdInt != undefined) ? item.jobTypeIdInt : 1;

          if(!this.editRO) {
            
          }
          let marketId = (item.marketIdInt && item.marketIdInt != undefined) ? item.marketIdInt : 0;
          /* if(userMarketData.length == 1 && userMarketId > 0) {
            marketId = parseInt(userMarketId);
          } */
          let salesRepId = (item.salesRepIdInt && item.salesRepIdInt != undefined) ? item.salesRepIdInt : 0;

          let asap = item.isAsapInt && item.isAsapInt != undefined ? item.isAsapInt : 0;
          let flexible = item.isFlexibleInt && item.isFlexibleInt != undefined ? item.isFlexibleInt : 0;
          this.selectedAppointmentOptionId = (asap > 0) ? 2 : (flexible > 0) ? 3 : 1;
          let soi = this.appointmentOptions.findIndex(option => option.id == this.selectedAppointmentOptionId);
          let appointmentOption = this.selectedAppointmentOption;
          if(soi >= 0) {
            appointmentOption = this.appointmentOptions[soi].name;
            this.selectedAppointmentOption =  appointmentOption;
          }         

          let vinNo = '';
          let contactId = '';
          let shopId = 0;
          let adasReportId = '';
          let adasThirdPartyReportId = 0;
          if (this.createParamSalesRepId && this.createParamSalesRepId != '' && this.createParamSalesRepId != undefined) {
            salesRepId = parseInt(this.createParamSalesRepId);
          }
          if (this.createParamMarketId && this.createParamMarketId != '' && this.createParamMarketId != undefined) {
            marketId = parseInt(this.createParamMarketId);
          }

          if (this.createParamReportId && this.createParamReportId != '' && this.createParamReportId != undefined) {
            adasReportId = this.createParamReportId;
          }
          if (this.createParamVIN && this.createParamVIN != '' && this.createParamVIN != undefined) {
            vinNo = this.createParamVIN;
          }

          this.insuranceCompanyId = item.insuranceCompanyIdInt && item.insuranceCompanyIdInt != undefined ? `${item.insuranceCompanyIdInt}` : '';
          this.estimateCreatedOn = item.estimateCreatedOnStr && item.estimateCreatedOnStr != undefined ? item.estimateCreatedOnStr : '';

          this.serviceForm = this.formBuilder.group({
            workstream: [this.workstreamSelection, [Validators.required]],
            servicetype: [this.servicetype, [Validators.required]],
            ordertype: [this.ordertype],            
            repairOrder: [''],
            referenceShopRO: [referenceShopRO],
            customerSyteLine: [customerSyteLine],
            customerPO: [customerPO],
            shopId: ['', [Validators.required]],
            serviceContact: ['', [Validators.required]],
            billingContact: [''],
            isSameContact: item.isSameContactInt && item.isSameContactInt != undefined ? item.isSameContactInt : 0,
            paymentMethod: [''],
            isPreApproved: [isPreApproved],
            paymentToggle:[paymentToggle],
            threadCategory: [this.threadCategory, [Validators.required]],
            vin: ['', [Validators.pattern(vinPattern)]],
            make: [''],
            model: [''],
            odo: [''],
            unit: [''],
            year: [''],
            serialNumber: [''],
            toolType: [''],
            toolName: [''],
            scanVersion: [''],
            appointmentOption: [appointmentOption],
            isAsap: asap,
            appointmentDate: [appointmentDate],
            appointmentTime: [appointmentTime],
            appointmentTimeZone: timeZone,
            dueDate: [dueDate],
            dueTime: [dueTime],
            durationDays: item.durationDaysStr && item.durationDaysStr != undefined ? item.durationDaysStr : '0',
            durationHours: item.durationHoursStr && item.durationHoursStr != undefined ? item.durationHoursStr : this.hourList[1].id,
            durationMinutes: item.durationMinutesStr && item.durationMinutesStr != undefined ? item.durationMinutesStr : '0',
            isFlexible: flexible,
            isParkingLot: item.isParkingLotInt && item.isParkingLotInt != undefined ? item.isParkingLotInt : 0,
            serviceTech: [''],
            description: [''],
            internalNotes: item.internalNotesStr && item.internalNotesStr != undefined ? item.internalNotesStr : '',
            jobItems,
            jobType,
            assignTechnicianId: (assignTech.length > 0) ? assignTech[0].toString() : '',
            licensePlate: item.licensePlateStr && item.licensePlateStr != undefined ? item.licensePlateStr : '',
            assetTag: item.assetTagStr && item.assetTagStr != undefined ? item.assetTagStr : '',
            marketId,
            salesRepId,
            adasReportId,
            adasThirdPartyReportId,
            estimateCreatedOn: [this.estimateCreatedOn, []],
            insuranceCompanyId: [this.insuranceCompanyId, []],
            orderCreatedOn: [this.orderCreatedOn, []],
            verificationCreatedOn: [this.verificationCreatedOn, []],
          });
          console.log(this.serviceForm)
          if(!this.editRO) {
            //this.getAssigneeList();
          }
          setTimeout(() => {
            let preapprove = isPreApproved;
            if(!this.editRO) {
              switch(this.domainId) {
                case 63:
                case 346:
                case 397:
                //case 432:
                case 462:
                  //preapprove = 'No';
                  break;
              }
            }
            console.log(marketId,  salesRepId);
            this.serviceForm.patchValue({isPreApproved: preapprove, appointmentOption, shopId: this.shopId, marketId, salesRepId});
            console.log(this.serviceForm)
            //this.shopChanged('change', '', this.shopId);
          }, 250);
        }
        break;
      case 'serviceTech':
        console.log(item)
        let techId = (item == '') ? 0 : item.id;
        let tfirstName = (item == '') ? '' : item.firstName;
        let tlastName = (item == '') ? '' : item.lastName;
        let temail = (item == '') ? '' : item.email;
        let tcountryName = (item == '') ? '' : item.countryName == null ? this.icountryName : item.countryName;
        let tcountryCode = (item == '') ? '' : item.countryCode == null ? this.icountryCode : item.countryCode;
        let tdialCode = (item == '') ? '' : item.dialCode == null ? this.idialCode : item.countryCode;
        let tphoneNumber = (item == '') ? '' : item.phoneNumber == null ? this.iphoneNumber : item.phoneNumber;
        this.icountryCode = (item = '') ? this.icountryCode : tcountryCode;
        this.iphoneNumber = (item = '') ? this.iphoneNumber : tphoneNumber;
        this.icountryName = (item = '') ? this.icountryName : tcountryName;
        this.idialCode = (item = '') ? this.idialCode : tdialCode;
        this.phoneNumberData = {
          countryCode: this.icountryCode,
          phoneNumber: this.iphoneNumber,
          country: this.icountryName,
          dialCode: this.idialCode,
          access: 'phone'
        }
        this.serviceTechForm = this.formBuilder.group({
          contactId: [techId],
          firstName: [tfirstName, [Validators.required]],
          lastName: [tlastName, [Validators.required]],
          email: [temail, [Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          countryName: [tcountryName],
          countryCode: [tcountryCode],
          dialCode: [tdialCode],
          phoneNumber: [tphoneNumber]
        });
        break;
      case 'serviceShop':
        this.customerFormClass = (item == '') ? 'new-customer' : 'edit-customer';
        this.businessEmailExist = false;
        this.businessEmailExistMessage = '';
        let cfirstName = (item != '') ? 'fname' : '';
        let clastName = (item != '') ? 'lname' : '';
        let shopId = (item == '') ? 0 : item.id;
        let shopName = (item == '') ? '' :item.name;
        let addressLine1 = (item == '') ? '' : item.addressLine1;
        let addressLine2 = (item == '') ? '' : item.addressLine2;
        let city = (item == '') ? '' : item.city;
        let state = (item == '') ? '' : item.state;
        let zip = (item == '') ? '' : item.zip;
        let customerId = (item == '') ? '' : item.customerId;
        let cmarketId = (item == '') ? 0 : item.marketId;
        let cemail = (item == '') ? '' : item.email;
        let scountryName = (item == '') ? '' : item.countryName;
        let scountryCode = (item == '') ? '' : item.countryCode;
        let sdialCode = (item == '') ? '' : item.dialCode;
        let phone = (item == '') ? '' : item.phoneNumber;
        if(item?.phoneNumber && item?.phoneNumber != undefined) {
          phone = item.phoneNumber;
        }
        if(item?.phone && item?.phone != undefined) {
          phone = item.phone;
        }
        this.icountryName = (item == '' || scountryName) ? this.icountryName : scountryName;
        this.icountryCode = (item == '' || scountryCode == null) ? this.icountryCode : scountryCode;
        this.idialCode = (item == '' || sdialCode == '') ? this.idialCode : sdialCode;
        this.iphoneNumber = (item == '' || phone == null) ? this.iphoneNumber : phone;
        this.phoneNumberData = {
          countryCode: this.icountryCode,
          phoneNumber: this.iphoneNumber,
          country: this.icountryName,
          dialCode: this.idialCode,
          access: 'phone'
        }
        let uemail = (item == '') ? '' : item.email;
        let ucountryName = '';
        let ucountryCode = '';
        let udialCode = '';
        let uphone = '';
        let userEmailCheck = 0;
        
        if(cemail != '' && item.isMaskCustomer) {
          cemail = '';
        }       
        
        let csplitEmail = cemail.split(this.maskEmail);
        cemail = (csplitEmail.length > 1) ? '' : cemail;

        this.userCountryName = ucountryName;
        this.userCountryCode = ucountryCode;
        this.userDialCode = udialCode;
        this.userPhoneNumber = uphone;
        this.userPhoneNumberData = {
          countryCode: this.userCountryCode,
          phoneNumber: this.userPhoneNumber,
          country: this.userCountryName,
          dialCode: this.userDialCode,
          access: 'userPhone'
        }
        this.serviceShopForm = this.formBuilder.group({
          shopId: [shopId],
          shopName: [shopName, [Validators.required]],
          addressLine1: [addressLine1],
          addressLine2: [addressLine2],
          city: [city],
          state: [state],
          zip: [zip],
          customerId: [customerId],
          marketId: [cmarketId],
          countryName: [scountryName],
          countryCode: [scountryCode],
          dialCode: [sdialCode],
          phone: [phone],
          email: [cemail, [Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          firstName: [cfirstName],
          lastName: [clastName],
          userEmail: [uemail, [Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          userCountryName: [ucountryName],
          userCountryCode: [ucountryCode],
          userDialCode: [udialCode],
          userPhone: [uphone],
          userEmailCheck
        });
        const selectedMarket = this.marketDataOptions.filter(
          (element) => element.id == cmarketId
        );
        this.selectedMarket = selectedMarket[0];
        break;
      case 'serviceContact':
      case 'serviceBillingContact':
      case 'serviceTechContact':
        console.log(item)
        let isPrimary = 0;
        if(item != '' && item.email == this.Shops[0].email && this.businessCount == 1) {
          isPrimary = 1;
        }
        let contactId = (item == '') ? 0 : item.id;
        let firstName = (item == '') ? '' : item.firstName;
        let lastName = (item == '') ? '' : item.lastName;
        let email='';
        let cuserEmailCheck = (item == '') ? 0 : item.emailFlag;
        /* if(action == 'serviceContact' && this.shopUserEmailFlag){
            email = (item == '') ? '' : item.email;
            email = this.shopUserEmail != null && this.shopUserEmail != undefined ? this.shopUserEmail : email ;
        }
        else{
          email = (item == '') ? '' : item.email;
        } */
        email = (item == '') ? '' : item.email;
        let splitEmail = email.split(this.maskEmail);
        email = (splitEmail.length > 1) ? '' : email;
        let customerRole = [];
        let businessRole = (item == '') ? '' : item.businessRole;
        if(item == '') {
          let crId = (action == 'serviceContact') ? 1 : (action == 'serviceBillingContact') ? 2 : 3;
          this.customerRoles.forEach(crItem => {
            crItem.disabled = false;
            if(crId == crItem.id) {
              //crItem.disabled = true;
              customerRole.push(crItem);
            }
          });
          businessRole = (action == 'serviceContact') ? 11 : (action == 'serviceBillingContact' || action == 'serviceTechContact') ? 12 : businessRole;
        } else {
          let custRole = item.customerRole;
          console.log(custRole, item)
          if(custRole) {
            custRole.forEach(crItem => {
              let crIndex = this.customerRoles.findIndex(option => option.id == crItem);
              if(crIndex >= 0) {
                //this.customerRoles[crIndex].disabled = true;
                if(item.email == this.Shops[0].email && crItem == 1) {
                  this.customerRoles[crIndex].disabled = true;
                }
                customerRole.push(this.customerRoles[crIndex]);
              }
            });
          }
        }
        let countryName = (item == '') ? '' : item.countryName;
        let countryCode = (item == '') ? '' : item.countryCode;
        let dialCode = (item == '') ? '' : item.dialCode;
        let phoneNumber = (item == '') ? '' : item.phoneNumber;
        phoneNumber = (item != '' && item.phoneNumber == null) ? '' : item.phoneNumber;
        this.icountryCode = (item = '') ? this.icountryCode : countryCode;
        this.iphoneNumber = (item = '') ? this.iphoneNumber : phoneNumber;
        this.icountryName = (item = '') ? this.icountryName : countryName;
        this.idialCode = (item = '') ? this.idialCode : dialCode;
        this.phoneNumberData = {
          countryCode: this.icountryCode,
          phoneNumber: this.iphoneNumber,
          country: this.icountryName,
          dialCode: this.idialCode,
          access: 'phone'
        }

        this.serviceContactForm = this.formBuilder.group({
          contactId: [contactId],
          firstName: [firstName, [Validators.required]],
          lastName: [lastName],
          email: [email, [Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          countryName: [countryName],
          countryCode: [countryCode],
          dialCode: [dialCode],
          phoneNumber: [phoneNumber],
          customerRole: [customerRole],
          businessRole: [businessRole],
          userEmailCheck: [cuserEmailCheck],
          isPrimary
        });
        if(item != '') {
          let access = this.getContactAccess();
          this.updateValidators(this.serviceContactForm, 'email', 'init', access);
        }
        break;
      case 'toolName':
        let toolName = '';
        this.toolNameForm = this.formBuilder.group({
          toolName: [toolName, [Validators.required]]
        });
        break;
    }
  }

  getRecentVin() {
    let workstreams: any = JSON.stringify(this.workstreamId);
    const vinData = this.serviceForm.get('vin');
    const apiData = {
      apiKey: Constant.ApiKey,
      countryId: this.countryId,
      userId: this.userId,
      domainId: this.domainId,
      access: 'thread',
      workstreams
    };
    const inputData = {
      baseApiUrl: Constant.CollabticApiUrl,
      apiUrl: Constant.CollabticApiUrl + '/' + Constant.getRecentVins,
      field: 'vinNo',
      selectionType: 'single',
      filteredItems: [vinData.value],
      filteredLists: [vinData.value],
      actionApiName: '',
      actionQueryValues: '',
      title: 'Recent VINs'
    };
    const modalRef = this.modalService.open(ManageListComponent, { backdrop: 'static', keyboard: true, centered: true });
    modalRef.componentInstance.accessAction = false;
    modalRef.componentInstance.apiData = apiData;
    modalRef.componentInstance.height = innerHeight - 140;
    modalRef.componentInstance.access = 'newthread';
    modalRef.componentInstance.inputData = inputData;
    modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
      console.log(receivedService);
      const response = receivedService[0];
      this.vinDisable = true;
      this.modelDisable = true;
      this.serviceForm.patchValue({vin: response.vinNo});
      this.vinData = {
        make: response.make,
        model: response.model,
        year: response.year,
      };
      this.vinIsValid = true;
      this.vinValid = true;
      this.vinVerfied = true;
      this.setVINValues('vin');
      modalRef.dismiss('Cross click');
    });
  }

  vinChanged(action, val= '', access = '') {
    let vinData = this.serviceForm.get('vin');
    let vinLen = val.length;
    console.log(vinData.value)
    console.log(val)
    if(access != 'adasReport' && action != 'edit-api' && vinLen == 17) {
      this.dialogClose = false;
      this.dialogEscClose = false;
      this.dialogLoader = true;
      this.vinDisplayModal = true;
    }
    this.vinIsValid = (action == 'api' || action == 'edit-api' || vinLen == 17) ? true: vinData.valid;
    let vinApi = (vinLen == 17) ? true : false;
    /* switch (action) {
      case 'change':
        this.vinIsValid = true;
        this.vinValid = (val.length == 17 && vinData.value == '') || (val.length == 17 && vinData.value.length == 17) ? true : false;
        val = val.toUpperCase();
        this.vinVerfied = false;
        break;
      default:
        const svcFormData = new FormData();
        svcFormData.set('apiKey', Constant.ApiKey);
        svcFormData.set('countryId', this.countryId);
        svcFormData.set('domainId', this.domainId);
        svcFormData.set('userId', this.userId);
        svcFormData.set('vin', vinData.value);
        this.LandingpagewidgetsAPI.vehicleInfoByVIN(svcFormData).subscribe(
          (response) => {
            this.vinValid = (response.status == 'Success') ? true : false;
            if (this.vinValid) {
              this.vinDisable = true;
              this.vinVerfied = true;
              this.modelDisable = true;
              this.vinData = {
                make: response?.vinDetails[0]?.make,
                model: response?.vinDetails[0]?.model,
                year: response?.vinDetails[0]?.year,
              };
              this.setVINValues('vin');
            }
          }
        );
        break;
    } */
    if(vinApi) {
      const svcFormData = new FormData();
        svcFormData.set('apiKey', Constant.ApiKey);
        svcFormData.set('countryId', this.countryId);
        svcFormData.set('domainId', this.domainId);
        svcFormData.set('userId', this.userId);
        svcFormData.set('vin', vinData.value);
        svcFormData.set('workstreams', JSON.stringify(this.workstreamId));
        this.LandingpagewidgetsAPI.vehicleInfoByVIN(svcFormData).subscribe(
          (response) => {
            this.dialogClose = true;
            this.dialogEscClose = true;
            this.dialogLoader = false;
            this.vinDisplayModal = false;
            this.vinValid = (response.status == 'Success') ? true : false;
            if (this.vinValid) {
              this.vinDisable = true;
              this.vinVerfied = true;
              this.modelDisable = true;
              this.vinData = {
                make: response?.vinDetails[0]?.make,
                model: response?.vinDetails[0]?.model,
                year: response?.vinDetails[0]?.year,
              };
              this.setVINValues('vin');
            }
          }
        );
    }
  }

  setVINValues(access) {
    this.getMakeModelsList(this.vinData.make, access);
    this.serviceForm.patchValue({
      make: this.vinData?.make,
      model: this.vinData?.model,
      year: this.vinData?.year,
    });
  }

  getMakeModelsList(makeName, access = '') {
    let workstreamsList: any = this.workstreamId;
    this.modelLoading = true;
    this.modelDisable = true;
    const apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      countryId: this.countryId,
      userId: this.userId,
      displayOrder: 0,
      type: 1,
      makeName,
      offset: '',
      limit: '',
      workstreamsList
    };
    
    this.LandingpagewidgetsAPI.getMakeModelsList(apiInfo).subscribe(
      (response) => {
        this.modelDisable = (access == 'vin') ? true : false;
        this.modelLoading = false;
        this.Models = response?.modelData;
        setTimeout(() => {
          this.modelPlaceHoder = 'Select';
        }, 50);
      }
    );
  }

  // Form Action
  formAction(action) {
    console.log(action, this.actionForm);
    switch (action) {
      case 'submit':
        this.submitClicked = true;
        this.formSubmit();
        break;

      default:
        this.formProcessing = false;
        this.formCancel();
        break;
    }
  }

  // Get Geo Code
  geocode(address): Promise<any> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({address: address},
        (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            resolve(results[0]);
          } else {
            reject(new Error(status));
          }
        }
      );
    });
  }

  // Form Submit
  formSubmit() {
    const apiInfo = {
      apikey: Constant.ApiKey,
      countryId: this.countryId,
      domainId: this.domainId,
      userId: this.userId,
      action: 'new',
    };
    switch (this.actionForm) {
      case 'shop':
        this.shopExist = false;
        this.serviceShopSubmit = true;
        for (const i in this.serviceShopForm.controls) {
          this.serviceShopForm.controls[i].markAsDirty();
          this.serviceShopForm.controls[i].updateValueAndValidity();
        }
        this.invalidNumber = (this.iphoneNumber.length == 0 || (this.iphoneNumber.length > 0 && !this.phoneNumberValid)) ? false : true;
        this.userInvalidNumber = (this.userPhoneNumber.length == 0 || (this.userPhoneNumber.length > 0 && !this.userPhoneNumberValid)) ? false : true;
        let shopObj = this.serviceShopForm.value;
        console.log(this.serviceShopForm, shopObj, this.serviceShopForm.valid, this.shopExist, this.invalidNumber, this.userInvalidNumber, this.businessEmailExist)
        if (this.serviceShopForm.valid && (!this.shopExist && !this.invalidNumber && !this.userInvalidNumber && !this.businessEmailExist)) {
          console.log('in')
          this.formProcessing = true;
          let phoneNumber = (shopObj.countryCode == 'IN' && shopObj.phone.length > 10) ? shopObj.phone.substring(1) : shopObj.phone;
          let userPhoneNumber = (shopObj.userCountryCode == 'IN' && shopObj.userPhone.length > 10) ? shopObj.userPhone.substring(1) : shopObj.userPhone;
          let shopAction = (shopObj.shopId == 0) ? apiInfo.action : 'edit';
          let email = shopObj.email;
          if(shopAction == 'edit') {
            let selectedEmail = this.selectedShop.email;
            let splitEmail = selectedEmail.split(this.maskEmail);            
            if(email == '' && splitEmail.length > 1) {
              email = selectedEmail;
            }
          }
          apiInfo.action = shopAction;
          apiInfo['contentTypeId'] = ContentTypeValues.RepairOrder;
          apiInfo['shopId'] = shopObj.shopId;
          apiInfo['name'] = shopObj.shopName;
          this.businessName = shopObj.shopName;
          apiInfo['customerId'] = shopObj.customerId;
          apiInfo['addressLine1'] = shopObj.addressLine1;
          apiInfo['addressLine2'] = shopObj.addressLine2;
          apiInfo['city'] = shopObj.city;
          apiInfo['state'] = shopObj.state;
          apiInfo['zip'] = shopObj.zip;
          apiInfo['countryName'] = shopObj.countryName;
          apiInfo['countryCode'] = shopObj.countryCode;
          apiInfo['dialCode'] = shopObj.dialCode;
          apiInfo['phone'] = phoneNumber;
          apiInfo['email'] = email;
          apiInfo['marketId'] = shopObj.marketId;
          if(shopAction == 'new') {
            apiInfo['firstName'] = shopObj.firstName;
            apiInfo['lastName'] = shopObj.lastName;
            apiInfo['userEmail'] = shopObj.userEmail;
            apiInfo['userCountryName'] = shopObj.userCountryName;
            apiInfo['userCountryCode'] = shopObj.userCountryCode;
            apiInfo['userDialCode'] = shopObj.userDialCode;
            apiInfo['userPhone'] = userPhoneNumber;
          }
          console.log(shopObj);
          //apiInfo['lat'] = "0";
          //apiInfo['lng'] = "0";
          console.log(apiInfo);

          const address = shopObj.addressLine1 + shopObj.addressLine2 + ',' + shopObj.city + ',' + shopObj.state + ',' + shopObj.zip;
          if(shopObj.addressLine1 != '' && shopObj.city != '' && shopObj.state != '' && shopObj.zip != '') {
            this.geocode(address).then(response => {
              //this.formProcessing = false;
              console.log(response.geometry.location.lat());
              console.log(response.geometry.location.lng());
              let lat = response.geometry.location.lat();
              let lng = response.geometry.location.lng();
              apiInfo['lat'] = lat.toString();
              apiInfo['lng'] = lng.toString();
              this.manageShop(apiInfo);
            })
            .catch(err => {
              console.log(err);
            });
          } else {
            apiInfo['lat'] = "0";
            apiInfo['lng'] = "0";
            this.manageShop(apiInfo);
          }

          //this.manageShop(apiInfo);
        } else {
          this.formProcessing = false;
        }
      break;
      case 'contact':
      case 'billingContact':
      case 'techContact':
        let contactForm = this.serviceContactForm;
        let cf = this.scf;
        this.serviceContactSubmit = true;
        for (const i in contactForm.controls) {
          contactForm.controls[i].markAsDirty();
          contactForm.controls[i].updateValueAndValidity();
        }
        let isPrimary = 0;
        this.invalidNumber = (this.iphoneNumber.length > 0 && !this.phoneNumberValid) ? false : true;
        let contactObj = contactForm.value;
        console.log(contactObj, cf.email.errors, contactForm, this.invalidNumber)
        if (contactForm.valid && (!cf.email.errors || cf.email.errors == null || !this.invalidNumber)) {
          this.formProcessing = true;
          let contactAction = (contactObj.contactId == 0) ? apiInfo.action : 'edit';
          let email = contactObj.email;
          if(contactAction == 'edit') {
            let contactId = contactObj.contactId;
            let contactIndex = this.contacts.findIndex(option => option.id == contactId);
            let selectedEmail = this.contacts[contactIndex].email;
            let splitEmail = selectedEmail.split(this.maskEmail);            
            if(email == '' && splitEmail.length > 1) {
              email = selectedEmail;
            }            
          }
          let phoneNumber = (contactObj.countryCode == 'IN' && contactObj.phoneNumber.length > 10) ? contactObj.phoneNumber.substring(1) : contactObj.phoneNumber;
          let custRole = [];
          contactObj.customerRole.forEach(cust => {
            let cid = cust.id;
            custRole.push(cid.toString());
          });
          apiInfo.action = contactAction;
          apiInfo['shopId'] = this.shopId;
          apiInfo['contactId'] = contactObj.contactId;
          apiInfo['firstName'] = contactObj.firstName;
          apiInfo['lastName'] = contactObj.lastName;
          apiInfo['email'] = email;
          apiInfo['countryName'] = contactObj.countryName;
          apiInfo['countryCode'] = contactObj.countryCode;
          apiInfo['dialCode'] = contactObj.dialCode;
          apiInfo['phoneNumber'] = phoneNumber;
          apiInfo['isCreateUser'] = 1;
          apiInfo['accessFrom'] = 'common';
          apiInfo['customerRole'] = JSON.stringify(custRole);
          apiInfo['businessRole'] = contactObj.businessRole;
          apiInfo['emailFlag'] = contactObj.userEmailCheck;
          if(contactAction == 'edit' && contactObj.isPrimary == 1) {
            apiInfo['isPrimaryEmailEdit'] = 1;
            isPrimary = 1;
          }
          console.log(apiInfo);
          this.LandingpagewidgetsAPI.manageServiceContactAPI(apiInfo).subscribe((response) => {
            this.formProcessing = false;
            let error = response.error;
            if(!error) {
              console.log(response.data)
              this.bodyElem.classList.remove(this.bodyClass3);
              this.actionTitle = '';
              this.serviceContactSubmit = false;
              this.formProcessing = false;
              const contact = response.data[0];
              let id = contact.id;
              let itemVal = this.renderContact(contact);
              let serviceContact = this.serviceForm.get('serviceContact');
              let contactVal = serviceContact.value;
              let contactFlag = (this.actionForm == 'contact') ? true : false;
              let cphone = (contact.phoneNumber == '' || contact.phoneNumber == null || contact.phoneNumber == 'null') ? '' : contact.phoneNumber;
              let cdialCode = (contact.dialCode == '' || contact.dialCode == null || contact.dialCode == 'null') ? '' : contact.dialCode;
              if(contactAction == 'new') {
                let contacts = this.contacts;
                let contactData = {
                  id: id,
                  name: itemVal,
                  firstName: contact.firstName,
                  lastName: contact.lastName,
                  email: contact.email,
                  countryName: contact.countryName,
                  countryCode: contact.countryCode,
                  dialCode: cdialCode,
                  phoneNumber: cphone,
                  loginId: contact.loginId,
                  customerRole: JSON.parse(contact.customerRole),
                  businessRole: contact.businessRole,
                  emailFlag: contact.emailFlag
                };
                contacts.unshift(contactData);
                let customerRole:any = JSON.parse(contact.customerRole);
                if(!this.diagnationDomain) {
                  customerRole.forEach(citem => {
                    switch(parseInt(citem)) {
                      case 3:                        
                        let uname;
                        let email = contact.email != '' && contact.email != undefined ? ', '+contact.email : '';
                        let splitEmail = email.split(this.maskEmail);
                        email = (splitEmail.length > 1) ? '' : email;
                        let firstName = contact.firstName != '' && contact.firstName != undefined ? ''+contact.firstName : '';
                        let lastName = contact.lastName != '' && contact.lastName != undefined ? ' '+contact.lastName : '';
                        let sdialCode = (contact.dialCode == '' || contact.dialCode == undefined || contact.dialCode == null || contact.dialCode == 'null') ? '' : contact.dialCode+" ";
                        let phone = (contact.phoneNumber == '' || contact.phoneNumber == null || contact.phoneNumber == 'null') ? '' : ", "+`${sdialCode}${contact.phoneNumber}`;
                        uname = firstName+lastName+email+phone;
                        this.Technician.unshift({
                          id:contact.loginId,
                          name:uname,
                          label:uname,
                          view:'1'
                        });
                        setTimeout(() => {
                          let item = {
                            value: contact.loginId
                          }
                          this.techChanged(item, 'trigger');
                        }, 500);
                        break;
                    }
                  });
                }
                console.log(contactFlag)
                if(contactFlag) {
                  this.setupSelectedContacts(contact);
                  if(this.diagnationDomain) {
                    this.bussinessContactInfo(contact);
                  }
                  setTimeout(() => {
                    this.serviceForm.patchValue({serviceContact: this.selectedContactId});
                  }, 100);
                } else {
                  if(this.actionForm == 'techContact') {
                    console.log(contactData)
                    this.selectedTechId.push(contactData.loginId);
                    this.selectedTech.push(contactData.name);
                    this.serviceForm.patchValue({serviceTech: this.selectedTechId});
                    console.log(this.selectedTech, this.selectedTechId)
                  } else {
                    this.setupSelectedBillingContacts(contact);
                    setTimeout(() => {
                      this.serviceForm.patchValue({billingContact: this.selectedBillingContactId});
                    }, 100);
                  }
                }
              } else {
                let modifiedItems = response.modifiedItems;
                let changeFlag = modifiedItems.changeFlag;
                console.log(modifiedItems, changeFlag)
                if(changeFlag && isPrimary == 1) {
                  let changeFields = modifiedItems.changeField;
                  let fields = changeFields.split(',');
                  fields.forEach(field => {
                    console.log(field)
                    switch(field.trim()) {
                      case 'Email':
                        console.log(this.Shops, contact.email, contact.shopId, this.selectedShop)
                        let itemws = 0;
                        this.Shops[itemws].email = contact.email;
                        let name = this.Shops[itemws].name+" ID#"+this.Shops[itemws].id;
                        let addressLine1 = (this.Shops[itemws].addressLine1 == '' || this.Shops[itemws].addressLine1 == null) ? '' : ", "+this.Shops[itemws].addressLine1;
                        let addressLine2 = (this.Shops[itemws].addressLine2 == '' || this.Shops[itemws].addressLine2 == null) ? '' : ", "+this.Shops[itemws].addressLine2;
                        let city = (this.Shops[itemws].city == '' || this.Shops[itemws].city == null) ? '' :  ", "+this.Shops[itemws].city;
                        let state = (this.Shops[itemws].state == '' || this.Shops[itemws].state == null) ? '' : ", "+this.Shops[itemws].state;
                        let zip = (this.Shops[itemws].zip == '' || this.Shops[itemws].zip == null) ? '' : " "+this.Shops[itemws].zip;
                        let email = (this.Shops[itemws].email == '' || this.Shops[itemws].email == null) ? '' : this.Shops[itemws].email;
                        let dialCode = (this.Shops[itemws].dialCode == '' || this.Shops[itemws].dialCode == null) ? '' : this.Shops[itemws].dialCode+" ";
                        let phone = (this.Shops[itemws].phone == '' || this.Shops[itemws].phone == null) ? '' : ", "+dialCode+this.Shops[itemws].phone;
                        let splitEmail = email.split(this.maskEmail);
                        email = (splitEmail.length > 1) ? '' : email;
                        email = (email == '' || email == null) ? '' : ", "+email;
                        this.Shops[itemws].showval = name+addressLine1+addressLine2+city+state+zip+email+phone;
                        let selectedShop = this.Shops.filter(
                          (element) => element.id == contact.shopId
                        );
                        console.log(selectedShop);
                        this.selectedShop = selectedShop[0];
                        break;
                    }
                  });
                }
                let roList = modifiedItems['roList'];
                if(roList.length > 0) {
                  this.updateBulkSolr(roList);
                }
                console.log(this.contacts, id)
                let contactIndex = this.contacts.findIndex(option => option.id == id);
                console.log(contactIndex)
                this.contacts[contactIndex].shopId = this.shopId;
                this.contacts[contactIndex].name = itemVal;
                this.contacts[contactIndex].firstName = contact.firstName;
                this.contacts[contactIndex].lastName = contact.lastName;
                this.contacts[contactIndex].email = contact.email;
                this.contacts[contactIndex].countryName = contact.countryName;
                this.contacts[contactIndex].countryCode = contact.countryCode;
                this.contacts[contactIndex].dialCode = contact.dialCode;
                this.contacts[contactIndex].phoneNumber = contact.phoneNumber;
                this.contacts[contactIndex].emailFlag = contact.emailFlag;
                console.log(contactVal)
                if(contactVal) {
                  let contactFormIndex = contactVal.findIndex(option => option == id);
                  contactVal[contactFormIndex] = id;
                } else {
                  contactVal = [id];
                }
                let contactId, selectedContact;
                if(contactFlag) {
                  this.serviceForm.patchValue({serviceContact: contactVal});
                  contactId = this.selectedContactId;
                  selectedContact = this.selectedContact;
                } else {
                  this.serviceForm.patchValue({servicebliingContact: contactVal});
                  contactId = this.selectedBillingContactId;
                  selectedContact = this.selectedBillingContact;
                }
                let scIndex = contactId.findIndex(option => option == id);
                selectedContact[scIndex] = this.renderContact(contact);
              }
              this.contactExist = false;
              this.actionFlag = false;
              this.actionForm = '';
              contactForm.reset();
            } else {
              this.contactExist = true;
              this.existError = response.message;
            }
          });
        } else {
          this.formProcessing = false;
        }
        break;
      case 'tech':
        this.serviceTechSubmit = true;
        for (const i in this.serviceTechForm.controls) {
          this.serviceTechForm.controls[i].markAsDirty();
          this.serviceTechForm.controls[i].updateValueAndValidity();
        }
        this.invalidNumber = (this.iphoneNumber.length > 0 && !this.phoneNumberValid) ? false : true;
        let techObj = this.serviceTechForm.value;
        console.log(techObj, this.stf.email.errors, this.serviceTechForm, this.invalidNumber)
        if (this.serviceTechForm.valid && (!this.stf.email.errors || this.stf.email.errors == null || !this.invalidNumber)) {
          this.formProcessing = true;
          let techAction = 'new';
          let techPhoneNumber = (techObj.countryCode == 'IN' && techObj.phoneNumber.length > 10) ? techObj.phoneNumber.substring(1) : techObj.phoneNumber;
          let emailVal = techObj.email != null ? techObj.email : '';

          if(this.actionTitle == 'Edit Technician'){
          const signupData = new FormData();
          signupData.append('apiKey', Constant.ApiKey);
          signupData.append('firstname', techObj.firstName);
          signupData.append('lastname', techObj.lastName);
          signupData.append('domainId', this.domainId );
          signupData.append('userId', this.userId);
          signupData.append('dealerId', techObj.contactId);
          signupData.append('emailAddress', emailVal);
          signupData.append('access_type', 'desktop');
          signupData.append('overwrite', '0');
          signupData.append('fromPublic', '1');
          signupData.append('phoneNumber', techPhoneNumber);
          signupData.append('countryName', techObj.countryName);
          signupData.append('countryCode', techObj.countryCode);
          signupData.append('dialCode', techObj.dialCode);
          //new Response(signupData).text().then(console.log);
          //return false;

          this.userDashboardApi.updateuserInfobyAdmin(signupData).subscribe((response) => {
            console.log(response);
            this.bodyElem.classList.remove(this.bodyClass3);
            this.serviceTechSubmit = false;
            this.formProcessing = false;

            this.serviceError = response.userStatus == 1 ? true : false;
            if(this.serviceError){
              this.serviceErrorMsg = response.message;
              return false;
            }
            else{
              this.serviceError = false;
              this.serviceErrorMsg = '';
            }
            this.actionTitle = '';

            let phone = (techPhoneNumber!='')? ", "+techPhoneNumber : '';
            let uname = techObj.firstName+" "+techObj.lastName;
            let email = emailVal != '' && emailVal != undefined ? ', '+emailVal : '';
            uname = uname+email+phone;
            let contactIndex = this.Technician.findIndex(option => option.id == techObj.contactId);
            if(contactIndex != '-1'){
              this.Technician[contactIndex].id = techObj.contactId;
              this.Technician[contactIndex].name = uname;
              this.Technician[contactIndex].label = uname;
              this.Technician[contactIndex].firstName = techObj.firstName;
              this.Technician[contactIndex].lastName = techObj.lastName;
              this.Technician[contactIndex].email = emailVal != '' && emailVal != undefined ? emailVal : '';
              this.Technician[contactIndex].phoneNumber = techPhoneNumber != '' && techPhoneNumber != undefined ? techPhoneNumber : '';
            }
            if(this.selectedTechId[0] == techObj.contactId){
              let dataupate = {
                id: techObj.contactId,
                name: uname,
                label: uname,
                firstName: techObj.firstName,
                lastName: techObj.lastName,
                email:emailVal != '' && emailVal != undefined ? emailVal : '',
                phoneNumber:techPhoneNumber != '' && techPhoneNumber != undefined ? techPhoneNumber : '',
                view: '1'
              }
              this.selectedTech=[];
              this.selectedTech.push(dataupate);
              setTimeout(() => {
                this.serviceForm.patchValue({serviceTech: this.selectedTechId[0]});
              }, 100);
            }
            this.serviceError = false;
            this.serviceErrorMsg = '';
            this.actionFlag = false;
            this.serviceTechForm.reset();
          });
        }
        else{
          const signupData = new FormData();
          signupData.append('api_key', Constant.ApiKey);
          signupData.append('firstname', techObj.firstName);
          signupData.append('lastname', techObj.lastName);
          signupData.append('email', emailVal);
          signupData.append('password', '@Password123');
          signupData.append('phoneNumber', techPhoneNumber);
          signupData.append('countryName', techObj.countryName);
          signupData.append('countryCode', techObj.countryCode);
          signupData.append('dialCode', techObj.dialCode);
          signupData.append('step', '3');
          signupData.append('subdomainName', this.businessName );
          signupData.append('subdomainId', this.domainId );
          signupData.append('version', '2');
          signupData.append('fromTechnician', '1');
          signupData.append('roleId', '4');
          signupData.append('businessName', this.businessName);
          signupData.append('businessId', this.shopId.toString());

          this.authenticationService.signup(signupData).subscribe((response) => {
            this.bodyElem.classList.remove(this.bodyClass3);
            this.serviceTechSubmit = false;
            this.formProcessing = false;
            const tech = techObj;

            let id = response.Userid;
            let name;
            let email = '';
            let ph = techPhoneNumber != '' ? ", "+techPhoneNumber : '';

            this.serviceError = response.userStatus == 1 ? true : false;
            if(this.serviceError){
              this.serviceErrorMsg = response.message;
              return false;
            }
            else{
              this.serviceError = false;
              this.serviceErrorMsg = '';
            }

            this.actionTitle = '';

            if(response.status == "Failure"){
              email = response.data.email != '' && response.data.email != undefined ? ", "+response.data.email : '';
            }
            else{
              email = response.Email != '' && response.Email != undefined ? ", "+response.Email : '';
            }
            email = emailVal == '' ? '' : email;
            name = techObj.firstName+" "+techObj.lastName+email+ph;
            let dataupate = {
              id: id,
              name: name,
              label: name,
              firstName: techObj.firstName,
              lastName: techObj.lastName,
              email:emailVal,
              phoneNumber:techPhoneNumber,
              view: '1'
            }
            this.Technician.unshift(dataupate);
            this.selectedTechId=[];
            this.selectedTechId.push(id);
            this.selectedTech=[];
            this.selectedTech.push(dataupate);
            setTimeout(() => {
              this.serviceForm.patchValue({serviceTech: this.selectedTechId[0]});
            }, 100);
            this.serviceError = false;
            this.serviceErrorMsg = '';
            this.actionFlag = false;
            this.actionForm = '';
            this.serviceTechForm.reset();
          });
        }
        } else {
          this.formProcessing = false;
        }
        break;
      case 'toolName':
        this.toolNameSubmit = true;
        for (const i in this.toolNameForm.controls) {
          this.toolNameForm.controls[i].markAsDirty();
          this.toolNameForm.controls[i].updateValueAndValidity();
        }
        let toolnameObj = this.toolNameForm.value;
        let toolName = toolnameObj.toolName;
        if (this.toolNameForm.valid && !this.toolNameExist) {
          this.formProcessing = true;
          let editAction:any = 0;
          let isValidate:any = 0;
          let matrixData = new FormData();
          matrixData.append('apiKey', Constant.ApiKey);
          matrixData.append('userId', this.userId);
          matrixData.append('domainId', this.domainId);
          matrixData.append('countryId', this.countryId);
          matrixData.append('ModelName', toolName);
          matrixData.append('MakeName', this.toolType);
          matrixData.append('isEdit', editAction);
          matrixData.append('isValidate', isValidate);
          this.ProductMatrixApi.manageMatrix(matrixData).subscribe((response) => {
            if(response.status == 'Success') {
              this.actionFlag = false;
              this.actionForm = '';
              this.actionTitle = '';
              this.toolNameSubmit = false;
              this.formProcessing = false;
              let resData = response.modelDataInfo[0];
              let item = resData.modelItems[0];
              let id = parseInt(item.id);
              let name = item.name;
              let serialNumber = resData.PartNumber;
              let toolNameData = {id, name, serialNumber};
              this.toolNameOptions.splice(0, 1, toolNameData);
              let newData = {id: 0, name: 'New', serialNumber: ''};
              this.toolNameOptions.unshift(newData);
              this.toolName = name;
              this.serviceForm.patchValue({toolName: name, serialNumber});
            }
          });
        }
        break;
    }
  }
  // Form Cancel
  formCancel() {
    this.bodyElem.classList.remove(this.bodyClass3);
    this.actionFlag = false;
    this.submitClicked = false;
    switch (this.actionForm) {
      case 'tech':
        this.serviceError = false;
        this.serviceErrorMsg = '';
        this.emptyPhoneData();
        this.serviceTechSubmit = false;
        this.serviceTechForm.reset();
      break;
      case 'contact':
      case 'billingContact':
      case 'techContact':
        this.emptyPhoneData();
        this.contactExist = false;
        this.existError = '';
        this.serviceContactSubmit = false;
        this.serviceContactForm.patchValue({customerRole: []});
        this.serviceContactForm.reset();
      break;
      case 'shop':
        this.shopExist = false;
        this.existError = '';
        this.serviceShopSubmit = false;
        this.serviceShopForm.reset();
        break;
    }
  }

  setupShopAddress(shop, callback = true, type='', iscanFormValues = '', status = 0) {
    if(!this.diagnationDomain) {
      if(!this.editRO) {
        /* this.paymentSectionToggleDisable = false;
        if(this.domainId == 63 || this.domainId == 346 || this.domainId == 397 || this.domainId == 432 || this.domainId == 462) {
          this.paymentSectionFlag = false;
          let paymentToggle: any = 0;
          this.billingInfoSection = false;
          this.paymentMethodSection = false;
          this.serviceForm.patchValue({paymentToggle});
        } */
        //let isPreApproved = 'Yes';
        //this.serviceForm.patchValue({isPreApproved});
      } else {
        //this.paymentSectionToggleDisable = (status > 0 && status < 3) ? false : true;
        this.paymentSectionToggleDisable = false;
      }
    }
    console.log(shop)
    let address = '';
    address = (shop.lat != '0') ? `${shop.addressLine1}, ${shop.addressLine2}, ${shop.city}, ${shop.state} ${shop.zip}` : address;
    let shopId = shop.id;
    this.shopId = shopId;
    this.businessName = shop.name;;
    this.selectedEmail = shop.email;
    if(callback) {
      //this.serviceForm.patchValue({serviceTech: ''});
      this.serviceForm.patchValue({serviceContact: ''});
      if(type == 'edit' || type == 'trigger'){
        shopId = this.shopId;
      }
      let typeAction = (type != 'trigger') ? '' : type;
      this.getContactList(shopId, iscanFormValues, typeAction);
      if(this.diagnationDomain) {
        this.getTechnicianList();
      }
    }
  }

  setupSelectedContacts(item) {
    console.log(item)
    let citem = this.renderContact(item);
    console.log(citem)
    this.selectedContact.push(citem);
    this.selectedContactId.push(item.id);
    console.log(this.selectedContactId)
  }

  setupSelectedBillingContacts(item) {
    console.log(item)
    let citem = this.renderContact(item);
    console.log(citem)
    this.selectedBillingContact.push(citem);
    this.selectedBillingContactId.push(item.id);
    console.log(this.selectedBillingContactId)
  }

  setupSelectedTechs(item,id) {
    if(this.diagnationDomain){
      console.log(item)
      let citem = this.renderContact(item);
      console.log(citem);
      this.selectedTech = [];
      this.selectedTechId = [];
      this.selectedTech.push(citem);
      this.selectedTechId.push(id);
    }
    else{
     this.selectedTechId = [];
     this.selectedTechId.push(id);
    }
  }
  // Render Contact Info
  renderItem(item) {
    let fname = item.firstName;
    let lname = item.lastName;
    let name = (lname != '') ? `${fname} ${lname}` : fname;
    let email = item.email != '' && item.email != undefined && item.email != null ? ', '+item.email : '';
    let dialCode = (item.dialCode == '' || item.dialCode == null || item.dialCode == 'null') ? '' : item.dialCode;
    let phone = (item.phoneNumber == '' || item.phoneNumber == null || item.phoneNumber == 'null') ? '' : item.phoneNumber;
    let phoneNumber = (dialCode != '' && phone != '') ? `${dialCode} ${phone}` : phone;
    let val = `${name}`;
    val = (email != '') ? `${val} ${email}` : val;
    val = (phoneNumber != '') ? `${val}, ${phoneNumber}` : val;
    return val;
  }
  emptyPhoneData(ph=''){
    this.icountryName = '';
    this.icountryCode = 'us';
    this.idialCode = '+1';
    this.iphoneNumber = ph;
    this.serviceContactForm.patchValue({
      countryName: this.icountryName,
      countryCode: this.icountryCode,
      dialCode: this.idialCode,
      phoneNumber: this.iphoneNumber
    });
    this.serviceTechForm.patchValue({
      countryName: this.icountryName,
      countryCode: this.icountryCode,
      dialCode: this.idialCode,
      phoneNumber: this.iphoneNumber
    });
    this.phoneNumberData = {
      countryCode: this.icountryCode,
      phoneNumber: this.iphoneNumber,
      country: this.icountryName,
      dialCode: this.idialCode,
      access: 'phone'
    }
  }

  emptyUserPhoneData(){
    this.userCountryName = '';
    this.userCountryCode = '';
    this.userDialCode = '';
    this.userPhoneNumber = '';
    this.serviceShopForm.patchValue({
      userCountryName: this.userCountryName,
      userCountryCode: this.userCountryCode,
      userDialCode: this.userDialCode,
      userPhoneNumber: this.userPhoneNumber
    });
    this.userPhoneNumberData = {
      userCountryCode: this.userCountryCode,
      userPhoneNumber: this.userPhoneNumber,
      userCountry: this.userCountryName,
      userDialCode: this.userDialCode,
      access: 'userPhone'
    }
  }

  // country & phone number update
  getPhoneNumberData(newValue){
    console.log(newValue)
    this.businessPhoneNumberData = newValue;
    if(newValue != null){
      if(newValue.phoneVal != null){
        if(newValue.access == 'phone'){
          let placeHolderValueTrim = '';
          let placeHolderValueLen = 0 ;
          let placeHolderValue = newValue.placeholderVal;
          placeHolderValueTrim = placeHolderValue.replace(/[^\w]/g, "");
          placeHolderValueTrim = placeHolderValueTrim.replace(/^0+/, '');
          placeHolderValueLen = placeHolderValueTrim.length;

          let currPhValueTrim = '';
          let currPhValueLen = 0 ;
          if(newValue.phoneVal['number'] != ''){
            currPhValueTrim = newValue.phoneVal['number'].replace(/[^\w]/g, "");
            currPhValueTrim = currPhValueTrim.replace(/^0+/, '');
            currPhValueLen = currPhValueTrim.length;
          }

          if(newValue.phoneVal['number'].length>0){
            this.phonenoInputFlag = (newValue.phoneVal['number'].length>0) ? true : false;
            this.invalidNumber = (newValue.errorVal) ? true : false;

            this.phoneNumberValid = true;
            this.emptyPhoneData();
            this.iphoneNumber = newValue.phoneVal.number;

            if(currPhValueLen == placeHolderValueLen){
              this.phoneNumberValid = false;

              let getCode = newValue.phoneVal.countryCode;
              this.icountryName = countries[getCode].name;
              this.icountryCode = newValue.phoneVal.countryCode;
              this.idialCode = newValue.phoneVal.dialCode;
              this.iphoneNumber = newValue.phoneVal.number;
            }
          }
          else{
            this.phonenoInputFlag = false;
            this.iphoneNumber = '';
          }
        }
      }
      else{
        this.phonenoInputFlag = false;
        this.invalidNumber = (newValue.errorVal) ? true : false;
        this.phoneNumberValid = true;
        this.emptyPhoneData();
      }
    }
    else{
      this.phonenoInputFlag = false;
      this.invalidNumber = (newValue.errorVal) ? true : false;
      this.phoneNumberValid = true;
      this.emptyPhoneData();
    }
    setTimeout(() => {
      switch (this.actionForm) {
        case 'tech':
          this.serviceTechForm.patchValue({
            countryName: this.icountryName,
            countryCode: this.icountryCode,
            dialCode: this.idialCode,
            phoneNumber: this.iphoneNumber
          });
          break;
        case 'contact':
          this.serviceContactForm.patchValue({
            countryName: this.icountryName,
            countryCode: this.icountryCode,
            dialCode: this.idialCode,
            phoneNumber: this.iphoneNumber
          });
          break;
        case 'shop':
          this.serviceShopForm.patchValue({
            countryName: this.icountryName,
            countryCode: this.icountryCode,
            dialCode: this.idialCode,
            phone: this.iphoneNumber
          });
          break;
      }

    }, 150);
  }

  // country & phone number update
  getUserPhoneNumberData(newValue){
    console.log(newValue)
    if(newValue != null){
      if(newValue.phoneVal != null){
        if(newValue.access == 'userPhone'){
          let placeHolderValueTrim = '';
          let placeHolderValueLen = 0 ;
          let placeHolderValue = newValue.placeholderVal;
          placeHolderValueTrim = placeHolderValue.replace(/[^\w]/g, "");
          placeHolderValueTrim = placeHolderValueTrim.replace(/^0+/, '');
          placeHolderValueLen = placeHolderValueTrim.length;

          let currPhValueTrim = '';
          let currPhValueLen = 0 ;
          if(newValue.phoneVal['number'] != ''){
            currPhValueTrim = newValue.phoneVal['number'].replace(/[^\w]/g, "");
            currPhValueTrim = currPhValueTrim.replace(/^0+/, '');
            currPhValueLen = currPhValueTrim.length;
          }

          if(newValue.phoneVal['number'].length>0){
            this.userPhonenoInputFlag = (newValue.phoneVal['number'].length>0) ? true : false;
            this.userInvalidNumber = (newValue.errorVal) ? true : false;

            this.userPhoneNumberValid = true;
            this.emptyUserPhoneData();
            this.userPhoneNumber = newValue.phoneVal.number;

            if(currPhValueLen == placeHolderValueLen){
              this.userPhoneNumberValid = false;

              let getCode = newValue.phoneVal.countryCode;
              this.userCountryName = countries[getCode].name;
              this.userCountryCode = newValue.phoneVal.countryCode;
              this.userDialCode = newValue.phoneVal.dialCode;
              this.userPhoneNumber = newValue.phoneVal.number;
            }
          }
          else{
            this.userPhonenoInputFlag = false;
            this.userPhoneNumber = '';
          }
        }
      }
      else{
        this.userPhonenoInputFlag = false;
        this.userInvalidNumber = (newValue.errorVal) ? true : false;
        this.userPhoneNumberValid = true;
        this.emptyUserPhoneData();
      }
    }
    else{
      this.userPhonenoInputFlag = false;
      this.userInvalidNumber = (newValue.errorVal) ? true : false;
      this.userPhoneNumberValid = true;
      this.emptyUserPhoneData();
    }
    setTimeout(() => {
      this.serviceShopForm.patchValue({
        userCountryName: this.userCountryName,
        userCountryCode: this.userCountryCode,
        userDialCode: this.userDialCode,
        userPhone: this.userPhoneNumber
      });
    }, 150);
  }

  shopChanged(action, event, val = 0) {
    console.log(action,event,val)
    let value;
    if(val > 0) {
      value = val;
    } else {
      value = (action == 'change') ? event.value : (event != null) ? event : -1;
    }
    if(action == 'trigger') {
      this.actionFlag = false;
    }
    this.emptyContact();
    console.log(value)
    let address = '';
    let shopId: any = 0;
    let clearShop = (value == null) ? true: false;
    value = (value == null) ? -1 : value;
    this.showClear = false;
    switch(value) {
      case -1:
        clearShop = true;
        this.selectedShop = [];
        break;
      case 0:
        clearShop = true;
        this.serviceAction('new', 'shop');
        break;
      default:
        this.contactDisable = false;
        this.billingContactDisable = false;
        this.showClear = true;
        let selectedShop = this.Shops.filter(
          (element) => element.id == value
        );
        let servicetype = this.serviceForm.value.servicetype;
        if(servicetype != '' && servicetype != undefined && servicetype > 0) {
          this.getAssigneeList();
        }
        console.log(selectedShop);
        this.selectedShop = selectedShop[0];
        this.setupShopAddress(selectedShop[0]);
        this.getPaymentMethods();
        break;
    }
    if(clearShop) {
      this.paymentMethods = [];
      this.contactDisable = clearShop;
      this.billingContactDisable = clearShop;
      this.serviceForm.patchValue({
        shopId: value,
        serviceContact: '',
        billingContact: '',
        serviceTech: '',
        paymentMethod: ''
      });
    }
  }

  // Contact Change
  contactChanged(access, item, recall = false) {
    console.log(item)
    let itemVal = item.value;
    let selectedContact;
    let contacts = this.contacts;
    let isSameContact = this.serviceForm.value.isSameContact;
    let sameFlag = false;
    console.log(itemVal)
    switch (access) {
      case 'contact':
        this.selectedContact = [];
        this.selectedContactId = itemVal;
        selectedContact = this.selectedContact;
        sameFlag = true;
        break;
      case 'billing':
        this.selectedBillingContact = [];
        this.selectedBillingContactId = itemVal;
        selectedContact = this.selectedBillingContact;
        this.serviceForm.patchValue({billingContact: this.selectedBillingContactId});
        if(!recall && isSameContact) {
          this.serviceForm.patchValue({isSameContact: false});
        } else {
          console.log(this.selectedBillingContactId, this.selectedContactId)
          if(this.selectedBillingContactId.sort().toString() == this.selectedContactId.sort().toString()) {
            this.serviceForm.patchValue({isSameContact: true});
          }
        }
        break;
    }
    itemVal.forEach(id => {
      let cindex = contacts.findIndex(option => option.id == id);
      selectedContact.push(contacts[cindex].name);
    });
    if(sameFlag && isSameContact) {
      this.contactChanged('billing', item, sameFlag);
    }
    console.log(this.selectedContactId, this.selectedBillingContactId)
    console.log(this.serviceForm.value)
  }

 // Contact Change
  techChanged(item, action = '') {
    let itemVal = item.value;
    console.log(item, itemVal, this.Technician)
    this.selectedTechId = [];
    this.selectedTech = [];
    this.selectedTechId.push(itemVal);
    this.selectedTechId.forEach(id => {
      let cindex = this.Technician.findIndex(option => option.id == id);
      if(this.diagnationDomain){
        this.selectedTech.push(this.Technician[cindex]);
      }
      else{
        this.selectedTech.push(this.Technician[cindex].name);
      }
    });
    if(action == 'trigger')  {
      this.serviceForm.patchValue({serviceTech: itemVal});
    }
    console.log(this.selectedTech)
    console.log(this.selectedTechId)
    console.log(this.serviceTech, this.serviceForm.value)
  }
  stageChanged(item){
    console.log(item)
    let itemVal = item.value;
    console.log(itemVal)
  }
  assignChanged(event){
    console.log("assignChanged: ", event)
    this.allocatedCount = 1;
  }

  // check email validation
  checkEmailValition(access = ''){
    console.log(456)
    let emailVal = '';
    var emailError;

    switch(this.actionForm){
    case 'shop':
      if(access == '') {
        emailVal = this.serviceShopForm.value.email.trim();
        emailError = this.serviceShopForm.controls.email.errors;
      } else {
        emailVal = this.serviceShopForm.value.userEmail.trim();
        emailError = this.serviceShopForm.controls.userEmail.errors;
      }
      break
    case 'contact':
      emailVal = this.serviceContactForm.value.email.trim();
      emailError = this.serviceContactForm.controls.email.errors;
      break;
    case 'tech':
      emailVal = this.serviceTechForm.value.email.trim();
      emailError = this.serviceTechForm.controls.email.errors;
      break;
    }

    console.log(emailVal)
    if(emailVal.length>0){
      switch(access) {
        case 'userEmail':
          this.userEmailValidationError = false;
          this.userEmailValidationErrorMsg = "";
          if(emailError){
            this.userEmailValidationError = true;
            this.userEmailValidationErrorMsg = "Invalid Email";
          }
          break;
        default:
          this.emailValidationError = false;
          this.emailValidationErrorMsg = "";
          if(emailError){
            this.emailValidationError = true;
            this.emailValidationErrorMsg = "Invalid Email";
          }
          break
      }
    } else {
      switch(access) {
        case 'userEmail':
          if(this.isCustomerEmailInvite == 0) {
            this.updateValidators(this.serviceShopForm, 'userEmail', 'remove');
          } else {
            this.updateValidators(this.serviceShopForm, 'userEmail', 'init', 'userEmail');
          }
          break;
        case 'email':
          if(this.actionForm == 'contact' || this.actionForm == 'billingContact' || this.actionForm == 'techContact') {
            if(this.isContactEmailInvite == 0) {
              let access = this.getContactAccess();
              this.updateValidators(this.serviceContactForm, 'email', 'remove', access);
            }
          }
          break;  
      }
    }
  }

  removeSelection(form, controller, index) {
    console.log(form, controller, index)
    switch(controller) {
      case 'serviceShop':
          this.shopChanged('trigger',-1);
          this.shopId = 0;
          this.serviceForm.patchValue({shopId: ''});
          this.selectedContact = [];
          this.selectedContactId = [];
          this.serviceForm.patchValue({serviceContact: ''});
          this.selectedTech = [];
          this.selectedTechId = [];
          this.serviceForm.patchValue({serviceTech: ''});
        break;
      case 'serviceContact':
        this.selectedContact.splice(index, 1);
        this.selectedContactId.splice(index, 1);
        this.serviceForm.patchValue({serviceContact: this.selectedContactId});
        break;
      case 'serviceBillingContact':
        this.selectedBillingContact.splice(index, 1);
        this.selectedBillingContactId.splice(index, 1);
        this.serviceForm.patchValue({billingContact: this.selectedBillingContactId});
        break;
      case 'techContact':
        this.selectedTech.splice(index, 1);
        this.selectedTechId.splice(index, 1);
        this.serviceForm.patchValue({serviceTech: this.selectedTechId});
        break;
      case 'customerRole':
        let customerRole = this.serviceContactForm.value.customerRole;
        customerRole.splice(index, 1);
        this.serviceContactForm.patchValue({customerRole});
        break;
      case 'serviceJob':
        let jobId = this.selectedJobItemIds[index];
        this.selectedJobItemIds.splice(index, 1);
        this.selectedJobItems.splice(index, 1);
        this.serviceForm.patchValue({jobItems: this.selectedJobItemIds});
        let estData = this.RODetailData.estimationData;
        estData = (Array.isArray(estData)) ? estData[0] : estData;
        let estimateData = estData.estimationArray;
        let estimateInfoData = this.RODetailData.estimateInfoDataJsonArr[0].estimateData;
        let estIndex = estimateData.findIndex(option => parseInt(option.jobId) == parseInt(jobId));
        if(estIndex >= 0) {
          let jobTotal:any = parseFloat(estimateData[estIndex].jobtotal);
          let jobWdTotal:any = parseFloat(estimateData[estIndex].jobWdTotal);
          let estTotal:any = parseFloat(this.RODetailData.estimationDataJsonArr[0].estimationTotal)-jobTotal;
          let wdestTotal:any = parseFloat(this.RODetailData.estimationDataJsonArr[0].wdestimationTotal)-jobWdTotal;
          this.RODetailData.estimationDataJsonArr[0].estimationTotal = Math.abs(estTotal).toFixed(2);
          this.RODetailData.estimationDataJsonArr[0].wdestimationTotal = Math.abs(wdestTotal).toFixed(2);
          this.RODetailData.estJobUploadContentsJsonArr.splice(estIndex, 1);
          estimateData.splice(estIndex, 1);
          estimateInfoData.splice(estIndex, 1);
          if(this.editRO) {
            let estId = 0;
            let estInfo = (this.RODetailData.estimateInfoDataJsonArr && this.RODetailData.estimateInfoDataJsonArr != undefined) ? this.RODetailData.estimateInfoDataJsonArr : [];
            if(estInfo.length > 0) {
              estId = this.RODetailData.estimateInfoDataJsonArr[0].estId;
            }
            let field = 'estimate';
            let fieldValue = JSON.stringify(this.RODetailData.estimationDataJsonArr[0]);
            let isInvoice = 0;
            let isGenerateInvoice = false;
            this.updateWorkOrder(field, fieldValue, estId, isInvoice, isGenerateInvoice);
          }
        }
        break;
    }
  }

  // Create New Options
  serviceAction(action, field, item:any = '') {
    console.log(action, field);
    this.submitClicked = false;
    this.formProcessing = false;
    this.shopExist = false;
    let formTimeout = (action == 'new') ? 0 : 500;
    this.bodyElem.classList.add(this.bodyClass3);
    switch (field) {
      case 'shop':
        this.selectedMarket = '';
        console.log(item)
        this.showClear = false;
        let shopText = 'Business';
        this.actionTitle = (action == 'new') ? `${ManageTitle.actionNew} ${shopText}` : `${ManageTitle.actionEdit} ${shopText}`;
        this.emptyPhoneData();
        let sitem = (action == 'new') ? '' : item;
        //this.emailDisable = (sitem != '' && sitem.isUser == 1) ? true : false;
        this.emailDisable = (sitem != '' && this.businessCount > 1) ? true : false;
        this.createForm('serviceShop', sitem);
        setTimeout(() => {
          this.actionFlag = true;
          this.actionForm = field;
        }, formTimeout);
        break;
      case 'contact':
      case 'billingContact':
      case 'techContact':
        this.actionTitle = (action == 'new') ? 'Add Contact' : 'Edit Contact';
        let contactDisable = (field == 'contact') ? this.contactDisable : this.billingContactDisable;
        console.log(this.contactDisable, this.billingContactDisable, this.shopId)
        this.businessRoleDisable = (action == 'new') ? false : true;
        //this.accountTypeDisable = (action == 'new' || (item != '' && (!this.endUser || (this.endUser && this.user.Email == this.Shops[0].email)))) ? false : true;
        if(!contactDisable && this.shopId > 0 ) {
          if(field == 'contact'){
            this.shopUserEmailFlag = false;
            this.shopUserEmail = '';
            if(action == 'new'){
              this.shopUserEmailFlag = this.contacts.length==0 ? true : false;
              if(this.shopUserEmailFlag){
                let cindex1 = this.Shops.findIndex(option => option.id == this.shopId);
                let email = this.Shops[cindex1].email;
                this.shopUserEmail = email;
              }
              else{
                // existing contacts
                let cindex2 = this.Shops.findIndex(option => option.id == this.shopId);
                let email2 = this.Shops[cindex2].email;
                let checkEmailFlag: boolean = false;
                console.log(this.contacts);
                this.contacts.forEach(citem => {
                  console.log(citem.email +"=="+ email2);
                  if(citem.email == email2) {
                    checkEmailFlag = true;
                    this.shopUserEmail = email2;
                  }
                });
                this.shopUserEmailFlag = false;
              }
            }
            else{
              // edit
              let cindex1 = this.Shops.findIndex(option => option.id == this.shopId);
              let email3 = this.Shops[cindex1].email;

              if(email3 == item.email && this.businessCount > 1){
                //this.shopUserEmailFlag = true;
                this.shopUserEmail = item.email;
              } else {
                //this.shopUserEmailFlag = (item.loginId > 0) ? true : false;
                this.shopUserEmail = item.email;
                this.shopUserEmailFlag = false;
              }
              this.accountTypeDisable = (item == '' || (item != '' && this.user.Email != item.email) && (this.editUserFlag && (email3 != item.email || (!this.endUser && email3 == item.email)))) ? false : true;
            }
          }

          this.emptyPhoneData();
          let citem = (action == 'new') ? '' : item;
          let formAction = (field == 'contact') ? 'serviceContact' : (field == 'billingContact') ? 'serviceBillingContact' : 'serviceTechContact';
          console.log(formAction)
          this.createForm(formAction, citem);
          setTimeout(() => {
            this.actionFlag = true;
            this.actionForm = field;
            console.log(this.actionForm)
          }, formTimeout);
        }
        break;
      case 'tech':
        if(!this.contactDisable && this.shopId>0 ) {
          this.actionTitle = (action == 'new') ? 'Add Technician' : 'Edit Technician';
          let citem1 = (action == 'new') ? '' : item;
          if(action == 'edit'){
            this.emptyPhoneData(item.phoneNumber);
            this.createForm('serviceTech', citem1);
          }
          else{
            this.emptyPhoneData();
            this.createForm('serviceTech', citem1);
          }
          setTimeout(() => {
            this.actionFlag = true;
            this.actionForm = field;
            this.serviceError = false;
            this.serviceErrorMsg = '';
            if(action == 'edit'){}
            else{this.serviceTech.reset();}
          }, formTimeout);
        }
      break;
      case 'toolName':
        this.actionTitle = 'Add Tool Name';
        let toolItem = '';
        this.createForm(field, toolItem);
        setTimeout(() => {
          this.actionFlag = true;
          this.actionForm = field;
        }, formTimeout);
        break;
    }
  }

   // Disable Workstreams Selection
   disableWSSelection(id){
    let workstreamOptions = [];
    let wsOptionLength = this.workstreamItems?.length;
    this.workstreamItems.forEach(wsItem => {
      workstreamOptions.push(wsItem);
    });
    
    for (let wss in this.workstreamSelection ) {
      if(id == this.workstreamSelection[wss].id){
        this.workstreamSelection.splice(wss, 1);
        this.workstreamId.splice(wss, 1);
      }
    }
    if(!this.diagnationDomain) {
      this.threadCategory = (this.workstreamId.length == 0) ? 0 : 1;
      this.supportTypeOptions = (this.workstreamId.length == 0) ? [] : this.supportTypeOptions;
      let emptyVal = '';
      this.toolType = emptyVal;
      this.toolName = emptyVal;
      this.toolTypeOptions = [];
      this.toolNameOptions = [];
      this.serviceForm.patchValue({serialNumber: emptyVal, toolType: this.toolType, toolName: this.toolName, scanVersion: emptyVal});
      if(this.workstreamId.length > 0) {
        this.getCategoryData();
      }
    }
    this.serviceForm.patchValue({workstream: this.workstreamSelection});  
    if(wsOptionLength == 1) {
      this.workstreamItems = workstreamOptions;
    }    
  }

  loadCountryStateData() {
    this.threadApi.countryMasterData().subscribe((response: any) => {
      if (response.status == "Success") {
        this.countryDropdownData = response.data.countryData;
        this.stateDropdownData = response.data.stateData;
        this.companyStateDropdownData = [];
        response.data?.countryData.forEach((country: any) => {
          let companyObject: any = {
            id: country.name,
            name: country.name,
            items: [],
          }
          response.data?.stateData?.forEach((state: any) => {
              let stateObject: any = {};
              if (state.country_id == country.id) {
                stateObject.id = state.name;
                stateObject.name = state.name;
                companyObject?.items.push(stateObject);
              }
          });
          this.companyStateDropdownData.push(companyObject);
        });
      }
      else {

      }
    }, (error: any) => {
    });

    console.log(this.companyStateDropdownData)
  }

  // Get Workstream Lists
  getWorkstreamLists() {
    let type: any = "1";
    let contentTypeId: any = "50";
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('type', type);
    apiFormData.append('contentTypeId', contentTypeId);
    this.LandingpagewidgetsAPI.getWorkstreamLists(apiFormData).subscribe(
      (response) => {
        let resultData = response.workstreamList;
        this.workstreamItems= [];
        for (let ws of resultData) {
          this.workstreamItems.push({
            id: ws.id,
            name: ws.name,
          });
          if(resultData.length == 1) {
            if(this.workOrderType == "new"){
              setTimeout(() => {
                if(!this.diagnationDomain) {
                  this.workstreamId = [];
                  this.workstreamSelection = this.workstreamItems;
                  for (let cs of this.workstreamItems) {
                    this.workstreamId.push(cs.id);
                  }
                  let emptyVal = '';
                  this.toolType = emptyVal;
                  this.toolName = emptyVal;
                  this.toolTypeOptions = [];
                  this.toolNameOptions = [];
                  this.serviceForm.patchValue({workstream: this.workstreamSelection});
                  this.getCategoryData();
                }
              }, 100);
            }
          }
        }        
      }
    );
  }

  // Get Subscription workstreams
  getSubscriptionWorkstreamLists() {
    let type: any = "1";
    let contentTypeId: any = "50";
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('userId', this.userId);
    this.LandingpagewidgetsAPI.getSubscriptionWorkstreamLists(apiFormData).subscribe(
      (response) => {
        let resultData = response.data;
        this.workstreamItems = [];
        for (let ws of resultData) {          
          this.workstreamItems.push({
            id: ws.id,
            name: ws.name,
          });
          if(resultData.length == 1) {
            if(this.workOrderType == "new"){
              setTimeout(() => {
                if(!this.diagnationDomain) {
                  this.workstreamId = [];
                  this.workstreamSelection = this.workstreamItems;
                  for (let cs of this.workstreamItems) {
                    this.workstreamId.push(cs.id);
                  }
                  let emptyVal = '';
                  this.toolType = emptyVal;
                  this.toolName = emptyVal;
                  this.toolTypeOptions = [];
                  this.toolNameOptions = [];
                  this.serviceForm.patchValue({workstream: this.workstreamSelection});
                  this.getCategoryData();
                }
              }, 100);
            }
          }
        }        
      }
    );
  }

  selectedItems(event,type){
    console.log(event) ;
    //switch(type){
      //case 'workstream':
        let currentSelection = (type == 'auto-workstream') ? event : event.value;
        this.workstreamId = [];
        this.workstreamSelection = [];
        this.workstreamSelection = currentSelection;
        for (let cs of currentSelection) {
          this.workstreamId.push(cs.id);
        }
        let emptyVal = '';
        this.makeList = [];
        this.Models = [];
        this.toolType = emptyVal;
        this.toolName = emptyVal;
        if(!this.diagnationDomain) {
          this.threadCategory = 1;          
          this.toolTypeOptions = [];
          this.toolNameOptions = [];
          this.serviceForm.patchValue({vin: emptyVal, make:emptyVal, model:emptyVal, year: emptyVal, serialNumber: emptyVal, toolType: this.toolType, toolName: this.toolName, scanVersion: emptyVal});
          if(this.workstreamId.length > 0) {
            this.getCategoryData();
          }
        } else {
          this.serviceForm.patchValue({vin: emptyVal, make:emptyVal, model:emptyVal, year: emptyVal, serialNumber: emptyVal, toolType: this.toolType, toolName: this.toolName, scanVersion: emptyVal});
        }

        /* this.serviceForm.value.make = "";
        this.make = '';
        this.serviceForm.value.model = "";
        this.modelName = [];
        this.serviceForm.value.year = "";

        this.year = '';
        this.onChange();
        this.getProdTypes(); */
    //}
  }

  getProductMakeList() {
    let threadCategoryId = (this.dmaDomain && this.threadCategory == 10) ? 1 : this.threadCategory;
    let wsList: any = this.workstreamId;
    let threadCategory:any = [];
    threadCategory.push(threadCategoryId);
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('workstreamsList', JSON.stringify(wsList))
    apiFormData.append('threadCategoryId', JSON.stringify(threadCategory));
    this.LandingpagewidgetsAPI.getProductMakeListsAPI(apiFormData).subscribe(
      (response) => {
        if (response.status == 'Success') {
          const resultData = response.modelData;
          this.makeList = resultData;
        }
      }
    );
  }

  getYearsList() {
    const year = parseInt(this.currYear)+2;
    for (let y = year; y >= this.initYear; y--) {
      this.Years.push({
        id: y,
        name: y.toString(),
      });
    }
  }



  attachments(items) {
    this.uploadedItems = items;
  }
  attachmentPopup(val = 0,type) {
    let postId = val;
    if(type=='new'){
      postId = 0;
    }
    //(this.uploadedItems);
    let fitem = [];
    let mitem = [];
    let eitem = [];
    let ditem = [];
    let obj = {};
    this.postApiData = {
      action: 'new',
      access: 'workorder-page',
      pageAccess: 'workorder-page',
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      countryId: '',
      userId: this.userId,
      threadId: '',
      postId: postId,
      contentType: this.contentType,
      displayOrder: this.displayOrder,
      roPushApiFlag: false,
      shopId: 0,
      assignTech: [],
      uploadedItems: [],
      attachments: [],
      attachmentItems: [],
      updatedAttachments: [],
      deletedFileIds: [],
      removeFileIds: [],
      pushData: obj
    };

    if(this.uploadedItems != '') {
      if(this.uploadedItems.items.length>0){
        fitem = this.uploadedItems;
        this.postApiData['uploadedItems'] = this.uploadedItems.items;
        this.postApiData['attachments'] = this.uploadedItems.attachsments;
      }
    }
    mitem = this.attachmentsData;
    eitem = this.updatedAttachments;
    ditem = this.deletedFileIds;

    console.log(mitem);
    const modalRef = this.modalService.open(MediaUploadComponent, this.mediaConfig);
    modalRef.componentInstance.access = 'post';
    modalRef.componentInstance.fileAttachmentEnable = true;
    modalRef.componentInstance.mediaAttachments = true;
    modalRef.componentInstance.apiData = this.postApiData;
    modalRef.componentInstance.uploadedItems = fitem;
    modalRef.componentInstance.presetAttchmentItems = mitem;
    modalRef.componentInstance.updatedAttachments = eitem;
    modalRef.componentInstance.deletedFileIds = ditem;
    modalRef.componentInstance.uploadAttachmentAction.subscribe((receivedService) => {

      console.log(receivedService);
      //(receivedService.uploadedItems);
      if(receivedService){
        this.uploadedItems = receivedService.uploadedItems;
        this.attachmentsData = receivedService.editAttachments;
        this.deletedFileIds  = receivedService.deletedFileIds;
        this.updatedAttachments = receivedService.updatedAttachments;

        if(this.uploadedItems != '') {
          if(this.uploadedItems.items.length>0){
            this.commentUploadedItemsLength = this.uploadedItems.items.length;
            this.commentUploadedItemsFlag = true;
          }
          else{
            this.commentUploadedItemsLength = 0;
            this.commentUploadedItemsFlag = false;
          }
        }
        else{
          this.commentUploadedItemsLength = 0;
          this.commentUploadedItemsFlag = false;
        }
        if(this.attachmentsData != '') {
          if(this.attachmentsData && this.attachmentsData.length>0){
            this.commentUploadedItemsLength = this.commentUploadedItemsLength+this.attachmentsData.length;
            this.commentUploadedItemsFlag = true;
          }
        }
      }
      else{
        if(this.uploadedItems.items.length>0){
          this.commentUploadedItemsLength = this.uploadedItems.items.length;
          this.commentUploadedItemsFlag = true;
        }
        else{
          this.commentUploadedItemsLength = 0;
          this.commentUploadedItemsFlag = false;
        }

        if(this.attachmentsData != '') {
          if(this.attachmentsData && this.attachmentsData.length>0){
            this.commentUploadedItemsLength = this.commentUploadedItemsLength+this.attachmentsData.length;
            this.commentUploadedItemsFlag = true;
          }
        }

      }
     // this.apiUrl.attachmentNewPOPUP = false;
      modalRef.dismiss('Cross click');

    });
  }
  // Allow only numeric
  restrictNumeric(e) {
    let res = this.commonApi.restrictNumeric(e);
    return res;
  }


  defaultData() {
    setTimeout(() => {
      if(this.workOrderType == "new"){
        this.newRepairOrderDetail();
      }
      else{
        setTimeout(() => {
          this.getRoData();  
        }, 750); 
      }
    }, 1);
  }

  getRoData() {
    this.editRepairOrderDetail();
  }

  getPaymentMethods() {
    this.paymentMethodSection = false;
    this.creditCardCount = 0;
    console.log("paymetho shop id"+this.ROViewData['shopIdInt'])
    //let shopId = (this.editRO) ? this.ROViewData['shopIdInt'] : this.shopId;
    let shopId = this.shopId;
    const apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      shopId
    };
    let paymentMethodId = (this.editRO) ? this.ROViewData['paymentMethodInt'] : '';
    this.LandingpagewidgetsAPI.apiWorkOrderPaymentMethods(apiInfo).subscribe((response) => {
      this.paymentMethodSection = true;
      this.paymentMethods = [];
      let responseData = response.data;
      let paymentMehods = responseData.items;
      console.log(paymentMehods)
      paymentMehods.forEach(pitem => {
        let itemData: any;
        let pmtId = pitem.id;
        let selected = (this.editRO && paymentMethodId == pmtId) ? true : false;
        this.paymentMethods.push({id: pitem.id, name: pitem.name, itemData: pitem.itemData, checked: pitem.checked, selected});
        switch(pitem.id) {
          case 1:
            itemData = pitem.itemData;
            if(!Array.isArray(itemData)) {
              this.creditCardCount = itemData.cards.length;
            }
            break;
        }
      });
    });
  }

  getMarketDataList() {
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      action: 'list'
    };
    this.LandingpagewidgetsAPI.apiManageMarketData(apiInfo).subscribe((response) => {
      this.marketDataOptions = [];
      let responseData = response.data;
      let marketDataOptions = this.sortBy(responseData.items, 'name');
      marketDataOptions.forEach(mitem => {
        let id = mitem.id;
        let name = mitem.name;
        this.marketDataOptions.push({id, name});
      });
      this.marketDataOptions.splice(0, 0, { id: -1, name: 'NEW' });
      this.marketFlag = (this.marketDataOptions.length > 0) ? true : false;
    });
  }

  getSalesRepList() {
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
    };
    this.LandingpagewidgetsAPI.apiSalesRepList(apiInfo).subscribe((response) => {
      console.log(response);
      let responseData = response.data;
      this.salesRepOptions = responseData.items;
    });
  }

  getWorkOrderTypes() {
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId
    };
    if(this.editRO) {
      apiInfo['action'] = 'list';
      apiInfo['typeId'] = this.ROViewData['requestTypeIdInt'];
    }
    this.LandingpagewidgetsAPI.apiWorkOrderTypeList(apiInfo).subscribe((response) => {
      let responseData = response.data;
      console.log(responseData.items)
      let woType = [];
      let orderType = [];
      responseData.items.forEach(type => {
        let pushFlag = true;
        if(this.workOrderId == 0) {
          //pushFlag = (type.id == 1) ? true : false;
        }
        let isDisabled = (type.isActive == 1) ? false : true;
        if(pushFlag) {
          woType.push({id: type.id, name: type.name, isDisabled});
        }
      });
      this.servicetypeOptions = woType;
      if(this.gbbDomain){
        if(responseData.orderTypes && responseData.orderTypes.length>0){
          responseData.orderTypes.forEach(type => {
            let isDisabled = (type.isActive == 1) ? false : true;
            orderType.push({id: type.id, name: type.name, isDisabled});
          });
          this.ordertypeOptions = orderType;
        }
      }
      if(woType.length == 1) {
        this.servicetype = woType[0].id;
        this.getAssigneeList();
      }
    });
  }

  getAssigneeList() {
    this.techLoading = true;
    let rawDate = this.selectedAppointmentOptionId == 1 ? this.serviceForm?.value?.appointmentDate : this.selectedAppointmentOptionId == 3 ? this.serviceForm?.value?.dueDate : '';
    const availabilityDate = moment(rawDate).isValid() ? moment(rawDate).format('YYYY-MM-DD'): '';
    let marketId: any = (this.marketId == 0) ? [] : [this.marketId];
    const searchText = '';
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('searchText', searchText);
    apiFormData.append('availabilityDate', availabilityDate);
    if(this.isTechMarketMap) {
      apiFormData.append('marketId', JSON.stringify(marketId));
    }
    let assignedTechId:any = parseInt(this.ROViewData['assignTechnicianIdInfoStr']);
    if(this.shopId > 0) {
      //apiFormData.append('fromRo', '1');
    }
    if(this.editRO && assignedTechId > 0) {
      //apiFormData.append('techId', assignedTechId);
    }
    switch (this.servicetype) {
      case 1:
        apiFormData.append('techSupport', '1');
        break;
      case 2:
        apiFormData.append('isDispatch', '1');
        break;
    }
    this.LandingpagewidgetsAPI.getAlldomainUsers(apiFormData).subscribe(
      (response) => {
        this.techLoading = false;
        console.log(response)
        this.technicians = response?.dataInfo;
        if (this.technicians && this.technicians.length > 0) {
          this.technicianToggle();
        }
      }
    );
  }

  technicianToggle() {
    this.technicians.map((res) => {
      res['disabled'] = false;
      if (res?.availabilityStatus?.availableStatus) {
        if (['0', '2'].includes(res?.availabilityStatus?.availableStatus)) {
          if (res?.availabilityStatus?.availableStatus == '0') {
            res['disabled'] = true;
          } else {
            if (res?.availabilityStatus?.isAllDay == '0') {
              const format = 'HH:mm:ss';
              const formatWithMeridiem = 'hh:mm A';

              const timeStr = this.serviceForm?.value?.appointmentTime; // e.g. "03:35 PM"
              const startStr = res?.availabilityStatus?.startTime;      // e.g. "15:00:36"
              const endStr = res?.availabilityStatus?.endTime;          // e.g. "16:10:40"
              const statusTimezone = this.tzMap[res?.availabilityStatus?.timezone];
              const appointmentTimeZone = this.tzMap[this.serviceForm.value.appointmentTimeZone];

              // detect user's timezone (browser/device timezone)
              const userZone = appointmentTimeZone ?? moment.tz.guess();

              // parse appointment time in user's timezone, then convert to UTC
              const timeUtc = moment.tz(timeStr, formatWithMeridiem, true, userZone).utc();
              console.log(timeUtc.toString());

              // parse start & end (assuming backend times are local or in a known zone)
              const startUtc = moment.tz(startStr, format, true, statusTimezone).utc();
              console.log(startUtc.toString());
              const endUtc   = moment.tz(endStr, format, true, statusTimezone).utc();
              console.log(endUtc.toString());

              if (!timeUtc.isValid() || !startUtc.isValid() || !endUtc.isValid()) {
                console.warn('Invalid time(s)');
              } else {
                // compare in UTC
                const isInclusiveUsingBetween = timeUtc.isBetween(startUtc, endUtc, undefined, '[]');
                res['disabled'] = isInclusiveUsingBetween;

                if (isInclusiveUsingBetween) {
                  if (this.serviceForm?.value?.assignTechnicianId == res?.userId) {
                    this.serviceForm.get('assignTechnicianId').setValue('');
                  }
                }
              }
            } else {
              res['disabled'] = true;
            }
          }
        }
      }
    })
  }

  getShopList(bshopId:any = 0, changeFlag = false) {
    let businessId:any = localStorage.getItem('businessId');
    let businessCount:any = localStorage.getItem('businessCount');
    let shopId = bshopId;
    shopId = (this.endUser && shopId == 0) ? businessId : shopId;
    const apiInfo = {
      apikey: Constant.ApiKey,
      countryId: this.countryId,
      domainId: this.domainId,
      userId: this.userId,
      shopId,
      contentTypeId: ContentTypeValues.RepairOrder
    };
    this.LandingpagewidgetsAPI.shopListAPI(apiInfo).subscribe((response) => {
      if(!this.diagnationDomain && (((this.endUser && businessCount < 2) || (!this.endUser && this.editRO)))) {
        this.showClear = false;
        let shops = response?.data;
        let checkShopId = (this.endUser) ? businessId : shopId;
        shops.forEach(sitem => {
          //if(sitem.id == checkShopId) {
            this.Shops.push(sitem);
            this.businessName = sitem.name;
            this.selectedShop = sitem;
            this.shopId = sitem.id;
          //}
        });
      } else {
        this.Shops = response?.data;
      }
      console.log(this.Shops);
      for (let itemws in this.Shops) {
        let name = this.Shops[itemws].name+" ID#"+this.Shops[itemws].id;
        let addressLine1 = (this.Shops[itemws].addressLine1 == '' || this.Shops[itemws].addressLine1 == null) ? '' : ", "+this.Shops[itemws].addressLine1;
        let addressLine2 = (this.Shops[itemws].addressLine2 == '' || this.Shops[itemws].addressLine2 == null) ? '' : ", "+this.Shops[itemws].addressLine2;
        let city = (this.Shops[itemws].city == '' || this.Shops[itemws].city == null) ? '' :  ", "+this.Shops[itemws].city;
        let state = (this.Shops[itemws].state == '' || this.Shops[itemws].state == null) ? '' : ", "+this.Shops[itemws].state;
        let zip = (this.Shops[itemws].zip == '' || this.Shops[itemws].zip == null) ? '' : " "+this.Shops[itemws].zip;
        let email = (this.Shops[itemws].email == '' || this.Shops[itemws].email == null) ? '' : this.Shops[itemws].email;
        let dialCode = (this.Shops[itemws].dialCode == '' || this.Shops[itemws].dialCode == null) ? '' : this.Shops[itemws].dialCode+" ";
        let phone = (this.Shops[itemws].phone == '' || this.Shops[itemws].phone == null) ? '' : ", "+dialCode+this.Shops[itemws].phone;
        let timeZone = (this.Shops[itemws].timeZone && this.Shops[itemws].timeZone != undefined) ? this.Shops[itemws].timeZone : '';
        let splitEmail = email.split(this.maskEmail);
        email = (splitEmail.length > 1) ? '' : email;
        email = (email == '' || email == null) ? '' : ", "+email;
        this.Shops[itemws].showval = name+addressLine1+addressLine2+city+state+zip+email+phone;
        if(this.Shops[itemws].id == shopId) {
          this.businessCount = this.Shops[itemws].businessCount;          
          if(timeZone != '') {
            this.timeZoneList.push({id: timeZone, name: timeZone});
            this.serviceForm.patchValue({appointmentTimeZone: timeZone});
          }
        }
      }
      if(changeFlag || (this.endUser && businessId && businessCount < 2)) {
        this.shopId = shopId;
        this.shopChanged('change', '', this.shopId);
      }
    });
    //console.log(this.Shops);
  }


  getContactList(shopId, setupIscanForm:any = '', action = '') {
    this.contacts = [];
    this.selectedContact = [];
    this.selectedContactId = [];
    this.selectedBillingContact = [];
    this.selectedBillingContactId = [];
    shopId = (this.editRO && (shopId == undefined || shopId == 'undefined')) ? this.ROViewData['shopIdInt'] : shopId;
    let contactId = this.ROViewData['contactInfoStr'] && this.ROViewData['contactInfoStr'] != '' ?  JSON.parse(this.ROViewData['contactInfoStr']) : '';
    let billingContactId = this.ROViewData['billingContactInfoStr'] && this.ROViewData['billingContactInfoStr'] != '' ?  JSON.parse(this.ROViewData['billingContactInfoStr']) : '';
    let contactList = (this.editRO) ? [...contactId, ...billingContactId].toString() : [];
    console.log(contactList);
    const apiInfo = {
      apikey: Constant.ApiKey,
      countryId: this.countryId,
      domainId: this.domainId,
      userId: this.userId,
      shopId: shopId,
      contactList
    };
    this.LandingpagewidgetsAPI.serviceContactListAPI(apiInfo).subscribe((response) => {
      let contacts = response?.data;
      contacts.forEach(item => {
        let id = item.id;
        let itemVal = this.renderContact(item);
        let isActive = (item.isActive) ? parseInt(item.isActive) : 1;
        let isDisabled = (item.isActive == 0) ? true : false;
        let cphone = (item.phoneNumber == '' || item.phoneNumber == null || item.phoneNumber == 'null') ? '' : ", "+item.phoneNumber;
        let contactData = {
          id: id,
          name: itemVal,
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          countryName: item.countryName,
          countryCode: item.countryCode,
          dialCode: item.dialCode,
          phoneNumber: cphone,
          loginId: item.loginId,
          customerRole: JSON.parse(item.customerRole),
          businessRole: item.businessRole,
          isActive,
          emailFlag: item.emailFlag,
          isDisabled
        };
        this.contacts.push(contactData);
        let customerRole:any = JSON.parse(item.customerRole);
        if(!this.diagnationDomain) {
          customerRole.forEach(citem => {
            switch(parseInt(citem)) {
              case 3:
                let uname;
                let email = item.email != '' && item.email != undefined ? ', '+item.email : '';
                let splitEmail = email.split(this.maskEmail);
                email = (splitEmail.length > 1) ? '' : email;
                let firstName = item.firstName != '' && item.firstName != undefined ? ''+item.firstName : '';
                let lastName = item.lastName != '' && item.lastName != undefined ? ' '+item.lastName : '';
                let sdialCode = (item.dialCode == '' || item.dialCode == undefined || item.dialCode == null || item.dialCode == 'null') ? '' : item.dialCode+" ";
                let phone = (item.phoneNumber == '' || item.phoneNumber == null || item.phoneNumber == 'null') ? '' : ", "+`${sdialCode}${item.phoneNumber}`;
                uname = firstName+lastName+email+phone;
                this.Technician.push({
                  id:item.loginId,
                  name:uname,
                  label:uname,
                  view:'1',
                  isDisabled
                });
                break;
            }
          });
        }
        /*if(this.serviceId == 0) {
          setTimeout(() => {
            this.selectedContact = [];
            this.selectedContactId = [];
          }, 150);
        }*/
        if(setupIscanForm != '') {
          this.contactDisable = false;
          setTimeout(() => {
            this.setupIscanFormData(setupIscanForm);
          }, 1000);
          this.step2 = true;
        }
      });
      setTimeout(() => {
        if((!this.editRO || (this.editRO && action != 'trigger')) && setupIscanForm == '') {
          let setupflag = false;
          let setupIndex:any = -1;
          if(this.contacts.length == 1) {
            setupIndex = 0;
            setupflag = true;
          } else {
            if(this.endUser && !this.editRO) {
              setupIndex = this.contacts.findIndex(option => option.loginId = this.userId && option.email == this.user.Email);
              setupflag = (setupIndex < 0) ? false : true;
              if(setupIndex >= 0) {
                //this.contacts[setupIndex].isDisabled = true;
              }
            }
            if(!this.endUser && !this.editRO) {
              setupIndex = this.contacts.findIndex(option => option.loginId = this.userId && option.isPrimary == 1);
              setupflag = (setupIndex < 0) ? false : true;
            }
          }
          if(setupflag && setupIndex > -1) {
            this.setupSelectedContacts(this.contacts[setupIndex]);
            setTimeout(() => {
              this.serviceForm.patchValue({serviceContact: this.selectedContactId});
            }, 100);
          }
        }
      }, 100);
    });
  }

  getTechnicianList() {
    this.Technician = [];
    this.selectedTech = [];
    this.selectedTechId = [];
    let shopId:any = this.shopId;
    const searchText = '';
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    //apiFormData.append('countryId', this.countryId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('isRepairOrder', '1');
    apiFormData.append('businessName', this.businessName);
    apiFormData.append('businessId', shopId);
    //apiFormData.append('limit', '20');
    //apiFormData.append('offset', '0');
    apiFormData.append('searchText', searchText);
    this.LandingpagewidgetsAPI.getAlldomainUsers(apiFormData).subscribe(
      (response) => {
        let technician = response?.dataInfo;
        let emptyTech = (technician.length == 0) ? true : false;
        //const view:any = 0;
        if(emptyTech) {
          this.Technician = [];
        }
        if(technician.length > 0) {
          technician.forEach(item => {
            let phone = (item.phoneNo!='')? ", "+item.phoneNo : '';
            let uname;
            let email = item.email != '' && item.email != undefined ? ', '+item.email : '';
            uname = item.firstLastName+email+phone;
            let fname = item.firstName;
            let lname = item.lastName;
            this.Technician.push({
              id:item.userId,
              name:uname,
              label:uname,
              view:'1',
              firstName: fname,
              lastName: lname,
              email: item.email != '' && item.email != undefined ? item.email : '',
              phoneNumber: item.phoneNo != '' && item.phoneNo != undefined ? item.phoneNo : ''
            });
          });
        }
        console.log(this.Technician)
       }
    );
  }

  // Form Submit
  saveService(action = '') {
    if(this.formProcessing) {
      return false;
    }
    if(action != '') {
      this.roViewEstActionFlag = true;
    }
    if(this.defaultWorkstreamFlag || (this.endUser && !this.editRO)) {
      let wsId:any = localStorage.getItem('defaultWorkstream');
      let wsFlag = true;
      switch(this.domainId) {
        case 411:
          wsId = "770";
          break;
        case 395:
          wsId = "788";
          if(this.endUser) {
            if((this.workstreamId.length > 0)) {
              wsId = this.workstreamId[0];   
            } else {
              wsFlag = false;
            }
          }
          break;
      }
      if(wsFlag) {
        let wsIndex = this.workstreamItems.findIndex(option => option.id == parseInt(wsId));
        if(wsIndex >= 0) {
          let ws = this.workstreamItems[wsIndex];
          let wsi = this.workstreamSelection.findIndex(option => option.id = parseInt(wsId));
          if(wsi < 0) {
            this.workstreamSelection.push({
              id: ws.id,
              name: ws.name
            });
          }
          this.serviceForm.patchValue({workstream: this.workstreamSelection})
          let wtsId: any = [];
          wtsId.push(this.workstreamSelection[0].id);
          console.log(wtsId)
          this.workstreamId = (this.defaultWorkstreamFlag) ? wtsId : this.workstreamId;
        }
      }
      console.log(this.workstreamSelection, this.workstreamId)
    }

    this.serviceSubmit = true;
    console.log(this.serviceForm,this.serviceForm.valid)
    let formValid = true;
    let formValue = this.serviceForm.value;
    switch(this.threadCategory) {
      case 1:
        /* let makeVal = formValue.make;
        this.makeValid = (makeVal == '' || makeVal == 'Unknown'  || makeVal == 'unknown') ? false : true;
        let modelVal = formValue.model;
        this.modelValid = (modelVal == '' || modelVal == 'Unknown'  || modelVal == 'unknown') ? false : true;
        let yearVal = formValue.make;
        this.yearValid = (yearVal == '') ? false : true;
        formValid = (this.makeValid && this.modelValid && this.yearValid) ? formValid : false; */
        break;
      case 2:
      case 10:
        let serialNumberVal = formValue.serialNumber;
        //this.serialNumberValid = true;
        let toolTypeVal = formValue.toolType;
        //this.toolTypeValid = (toolTypeVal == '' || toolTypeVal == 'Unknown'  || toolTypeVal == 'unknown') ? false : true;
        let toolNameVal = formValue.toolName;
        //this.toolNameValid = (toolNameVal == '' || toolNameVal == 'Unknown'  || toolNameVal == 'unknown') ? false : true;
        let scanVersionVal = formValue.scanVersion;
        //this.scanVersionValid = (this.threadCategory == 2 && scanVersionVal == '') ? false : true;
        //formValid = (this.serialNumberValid && this.toolTypeValid && this.toolNameValid && this.scanVersionValid) ? formValid : false;
        //formValid = (this.toolTypeValid && this.toolNameValid) ? formValid : false;
        break;
    }
    if(this.serviceForm.valid && formValue){
      this.requiredFlag = false;
      this.requiredFields = [];
      this.serviceSubmit = false;
      console.log('form values', this.odo, this.unit, formValue)
      //this.errroMsgFlag = false;
      //this.odometerFlag = false;
      //this.problemDescFlag = false;
      this.formProcessing = true;

      let uploadCount = 0;
      this.mediaUploadItems=[];
      if(Object.keys(this.uploadedItems).length > 0 && this.uploadedItems.attachments.length > 0) {
        this.uploadedItems.attachments.forEach(item => {
          //console.log(item)
          if(item.accessType == 'media') {
            this.mediaUploadItems.push({fileId: item.fileId.toString()});
          } else {
            uploadCount++;
          }
        });
    }

    this.bodyElem.classList.add(this.bodyClass2);
    if(!this.editRO) {
      this.submitModal = true;
    }
    const apiFormData = new FormData();
    let workArr = this.workstreamId?.length != 0 ? JSON.stringify(this.workstreamId) : '';
    let contactArr = this.selectedContactId?.length != 0 ? JSON.stringify(this.selectedContactId) : '';
    let billingContactArr = this.selectedBillingContactId.length != 0 ? JSON.stringify(this.selectedBillingContactId) : '';
    let jobItemsArr = this.selectedJobItemIds?.length > 0 ? JSON.stringify(this.selectedJobItemIds) : '[]';
    console.log(this.selectedContactId)
    if(this.regContactId?.length != 0 ){
      //this.selectedTechId.push(this.regContactId);
      this.regContactId.forEach(item => {
        this.selectedTechId.push(item);
      });
    }
    let shopId: any = this.shopId;
    let techArr = this.selectedTechId?.length != 0 ? JSON.stringify(this.selectedTechId) : '';
    let assignTech = this.serviceForm.value.assignTechnicianId;
    assignTech = (assignTech == '' || parseInt(assignTech) == 0) ? [] : [assignTech];
    console.log(this.servicetype, this.servicetypeOptions)
    let isPreApproved: any = (this.serviceForm.value.isPreApproved == 'Yes') ? 1 : 0;
    isPreApproved = (this.isEstimateApprove > 0) ? 0 : isPreApproved;
    let requestTypeIndex = this.servicetypeOptions.findIndex(option => option.id == this.servicetype);
    let requestType = '';
    if(requestTypeIndex < 0) {
      requestType = this.ROViewData['requestTypeStr'];
      this.servicetype = this.ROViewData['requestTypeIdInt'];
    } else {
      requestType = this.servicetypeOptions[requestTypeIndex].name;
    }
    let orderType = '';
    if(this.gbbDomain){
      let orderTypeIndex = this.ordertypeOptions.findIndex(option => option.id == this.ordertype);      
      if(orderTypeIndex < 0) {
        orderType = this.ROViewData['orderTypeStr'];
        this.ordertype = this.ROViewData['orderTypeIdInt'];
      } else {
        orderType = this.ordertypeOptions[requestTypeIndex].name;
      }
    }
    if(!this.diagnationDomain && !this.paymentSectionFlag) {
      billingContactArr = '';
      //isPreApproved = 1;
    }
    let defMakeVal = 'General Make';
    let defModelVal = 'General Model';
    let vin = (this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) ? this.serviceForm.value.vin : '';
    let makeVal = this.serviceForm.value.make;
    makeVal = (makeVal != undefined) ? makeVal : defMakeVal;
    let make = (this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) ? makeVal : defMakeVal;
    let modelVal = this.serviceForm.value.model;
    modelVal = (modelVal != undefined) ? modelVal : defModelVal;
    let model = (this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) ? modelVal : defModelVal;
    let year = (this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) ? this.serviceForm.value.year : '';
    this.odo = (this.odo == undefined || this.odo == 'undefined') ? '' : this.odo;
    this.odo = (this.threadCategory == 1) ? this.odo : '';
    let marketId = this.serviceForm.value.marketId;
    let salesRepId = this.serviceForm.value.salesRepId;
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('worksteamId', workArr);
    apiFormData.append('shopId', shopId);
    apiFormData.append('contactInfo', contactArr);
    apiFormData.append('technicianId', techArr);
    apiFormData.append('createdBy', this.userId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('requestType', requestType);
    apiFormData.append('requestTypeId', this.servicetype);
    apiFormData.append('businessName', this.businessName);
    apiFormData.append('vin', vin);
    apiFormData.append('marketId', marketId);
    apiFormData.append('salesRepId', salesRepId);
    apiFormData.append('jobItems', jobItemsArr);
    apiFormData.append('platform', "3");
    if(!this.diagnationDomain && this.servicetype == 2) {
      let jobType = this.serviceForm.value.jobType;
      apiFormData.append('jobType', jobType);
    }
    if(this.diagnationDomain || this.threadCategory != 2 || (this.threadCategory == 10 && this.dmaDomain)) {
      apiFormData.append('make', make);
      apiFormData.append('model', model);
      apiFormData.append('year', year);
    }
    apiFormData.append('odometer', this.odo);
    apiFormData.append('unit', this.unit);
    apiFormData.append('dispatchId', this.dispatchId);
    if(this.editThreadId != ''){
      apiFormData.append('threadId', this.editThreadId);
    }
    apiFormData.append('description', this.description);
    apiFormData.append('mediaCloudAttachments', JSON.stringify(this.mediaUploadItems));
    apiFormData.append('insuranceCompanyId', this.insuranceCompanyId);

    let estimateCreatedOn = moment(this.serviceForm.value.estimateCreatedOn).format('YYYY-MM-DD');
    apiFormData.append('estimateCreatedOn', estimateCreatedOn);

    if(this.dmaDomain) {
      apiFormData.append('partNumberStr', this.partNumberStr);
      apiFormData.append('partBatteryTypeStr', this.partBatteryTypeStr);
      apiFormData.append('partDescriptionStr', this.partDescriptionStr);
    }

    if(this.gbbDomain){
      apiFormData.append('partNumberStr', this.partNumberStr);
      apiFormData.append('partBatteryTypeStr', this.partBatteryTypeStr);
      apiFormData.append('partDescriptionStr', this.partDescriptionStr);
      apiFormData.append('inventorySource', String(this.inventorySource || 1));
      apiFormData.append('customerSyteLine', this.serviceForm.value.customerSyteLine);
      apiFormData.append('customerPO', this.serviceForm.value.customerPO);      
      //apiFormData.append('orderType', orderType);
      apiFormData.append('orderTypeId', this.ordertype);
      let orderCreatedOn = this.serviceForm.value.orderCreatedOn != '' && this.serviceForm.value.orderCreatedOn != undefined ? moment(this.serviceForm.value.orderCreatedOn).format('YYYY-MM-DD') : '';
      apiFormData.append('orderDate', orderCreatedOn);
      let verificationCreatedOn = this.serviceForm.value.verificationCreatedOn != '' && this.serviceForm.value.verificationCreatedOn != undefined ? moment(this.serviceForm.value.verificationCreatedOn).format('YYYY-MM-DD') : '';
      apiFormData.append('verificationDate', verificationCreatedOn);
    }
 
    let threadCategory:any = [];
    threadCategory.push(this.threadCategory.toLocaleString());
    apiFormData.append('threadCategory', JSON.stringify(threadCategory));
    if(!this.diagnationDomain && this.threadCategory == 1) {
      if((make == defMakeVal && model == defModelVal && year == '') || (make == '' && model == '' && year == '')) {
        let threadCategoryVal = 7;
        threadCategory = [];
        threadCategory.push(threadCategoryVal.toLocaleString());
        apiFormData.delete('threadCategory');
        apiFormData.append('threadCategory', JSON.stringify(threadCategory));
      }
    }

    if(this.editThreadId != ''){
      apiFormData.append('threadId', this.editThreadId);
    }

    if(this.errorCodes && this.errorCodes.length>0){
      apiFormData.append('trouble_code', JSON.stringify(this.trouble_code));
      apiFormData.append('errorCodes', JSON.stringify(this.errorCodes));
    }
    else{
      apiFormData.append('trouble_code', '');
      apiFormData.append('errorCodes', '');
    }

    if(this.diagnationDomain){
      apiFormData.append('orderNumber',  this.serviceForm.value.ordernumber);
      //apiFormData.append('productService',  this.serviceForm.value.productservices);
      apiFormData.append('dnInvoice',  this.serviceForm.value.dninvoice);
      apiFormData.append('billingFirstName', this.serviceForm.value.billingfirstname);
      apiFormData.append('billingLastName', this.serviceForm.value.billinglastname);
      apiFormData.append('initComplaint', this.initcomplaint);
    } else {
      let licensePlate = (this.serviceForm.value.licensePlate == undefined || this.serviceForm.value.licensePlate == 'undefined') ? '' : this.serviceForm.value.licensePlate;
      let assetTag = (this.serviceForm.value.assetTag == undefined || this.serviceForm.value.assetTag == 'undefined') ? '' : this.serviceForm.value.assetTag;
      let isFlexible:any = this.serviceForm.value.isFlexible ? 1 : 0;
      let isParkingLot:any = this.serviceForm.value.isParkingLot ? 1 : 0;
      let isAsap:any = this.serviceForm.value.isAsap ? 1 : 0;
      let isSameContact: any = this.serviceForm.value.isSameContact ? 1 : 0;
      let isPaymentSection: any = this.serviceForm.value.paymentToggle ? 1 : 0;
      let paymentMehod: any = (this.paymentSectionFlag) ? this.serviceForm.value.paymentMethod : '';
      let appointmentDate = this.serviceForm.value.appointmentDate;
      appointmentDate = (appointmentDate && appointmentDate != undefined && appointmentDate != '') ? moment(this.serviceForm.value.appointmentDate).format('YYYY-MM-DD') : '';
      let dueDate = moment(this.serviceForm.value.dueDate).format('YYYY-MM-DD');
      let durationDays = (this.serviceForm.value.durationDays == '0') ? '' : this.serviceForm.value.durationDays;
      durationDays = (durationDays == undefined || durationDays == 'undefined') ? '' : durationDays;
      let durationHours = (this.serviceForm.value.durationHours == '0') ? '' : this.serviceForm.value.durationHours;
      let durationMinutes = (this.serviceForm.value.durationMinutes == '0') ? '' : this.serviceForm.value.durationMinutes;
      durationMinutes = (durationMinutes == undefined || durationMinutes == 'undefined') ? '' : durationMinutes;
      apiFormData.append('isAsap', isAsap);
      apiFormData.append('isSameContact', isSameContact);
      apiFormData.append('billingContactInfo', billingContactArr);
      apiFormData.append('isPaymentSection', isPaymentSection);
      apiFormData.append('isPreApproved', isPreApproved);
      apiFormData.append('paymentMethod', paymentMehod);
      apiFormData.append('appointmentDate', appointmentDate);
      apiFormData.append('appointmentTime', this.serviceForm.value.appointmentTime);
      apiFormData.append('appointmentTimeZone', this.serviceForm.value.appointmentTimeZone);
      apiFormData.append('dueDate', dueDate);
      apiFormData.append('dueTime', this.serviceForm.value.dueTime);
      apiFormData.append('durationDays', durationDays);
      apiFormData.append('durationHours', durationHours);
      apiFormData.append('durationMinutes', durationMinutes);
      apiFormData.append('isFlexible', isFlexible);
      apiFormData.append('isParkingLot', isParkingLot);
      apiFormData.append('assignTechnicianId', JSON.stringify(assignTech));
      apiFormData.append('internalNotes', this.internalNotes);
      if(this.iscanDomain) {
        apiFormData.append('licensePlate', licensePlate);
        apiFormData.append('assetTag', assetTag);
        if(!this.editRO && this.endUser) {
          apiFormData.append('iscanSn', this.iscanPageRef.iscanFormData.iscanSn);
        }
      }
      if(this.threadCategory == 2 || (this.threadCategory == 10 && !this.dmaDomain)) {
        apiFormData.append('serialNumber', this.serviceForm.value.serialNumber);
        apiFormData.append('make', this.serviceForm.value.toolType);
        apiFormData.append('model', this.serviceForm.value.toolName);
        apiFormData.append('year', year);
        apiFormData.append('scanVersion', this.serviceForm.value.scanVersion);
      }
    }
    let jobcodeJSON = ''
    if(this.jobcodeArr && this.jobcodeArr.length>0){
      jobcodeJSON = JSON.stringify(this.jobcodeArr)
    }
    //console.log(this.serviceForm.value)
    apiFormData.append('jobcodeJSON', jobcodeJSON);
    apiFormData.append('referenceShopRO', this.serviceForm.value.referenceShopRO);
    if(!this.editRO){
      apiFormData.append('approved', "0");
      apiFormData.append('fromPublic', this.fromPublic);
      apiFormData.append('id', "0");
      let estFlag = false;
      if(!this.editRO && this.selectedJobItems?.length > 0) {
        estFlag = true;
        let estimateData = this.setupJobEstimateData();
        apiFormData.append('estimationParams', JSON.stringify(estimateData));
      }
      if(!estFlag) {
          if(this.escalationMatrix_array){
            apiFormData.append('estimationParams', JSON.stringify(this.escalationMatrix_array));
          }
          else{
            apiFormData.append('estimationParams', '');
          }
      }
    }
    else{
      apiFormData.append('updatedAttachments',  JSON.stringify(this.updatedAttachments));
      apiFormData.append('deletedFileIds',  JSON.stringify(this.deletedFileIds));

      apiFormData.append('editFlag', "1");
      if(this.approvedFlag==1) {
        apiFormData.append('approved', "1");
      } else {
        apiFormData.append('approved', "0");
      }

      apiFormData.append('fromPublic', "0");
      apiFormData.append('id', "0");
      apiFormData.append('workOrderId', this.workOrderId);
      let estFlag = false;
      if((this.escalationMatrix_array)){
        if((this.escalationMatrix_array['estimationArray']?.length>0)){
          apiFormData.append('estimationParams', JSON.stringify(this.escalationMatrix_array));
        }
        else{
          apiFormData.append('estimationParams', '');
        }
      }
      else{
        apiFormData.append('estimationParams', '');
      }
    }
    let adasReportId = (this.editRO) ? this.ROViewData['adasReportIdInt'] : 0;

    if(!this.editRO) {
      apiFormData.append('adasThirdPartyReportId', this.serviceForm.value.adasThirdPartyReportId);      
    }

    if (this.createParamReportId && this.createParamReportId != '' && this.createParamReportId != undefined) {
      console.log(this.threadCategory, vin, make)
      apiFormData.append('adasReportId', this.createParamReportId);
      if(vin == '' && (make == '' || make == 'General Make')) {
        let calproAdasData = this.calproAdasData[0];
        let adasDataItem = calproAdasData.itemsData.result;
        let vin = calproAdasData.vinNo;
        let make = adasDataItem.make;
        let model = adasDataItem.model;
        let year = adasDataItem.year;
        apiFormData.delete('vin');
        apiFormData.delete('make');
        apiFormData.delete('model');
        apiFormData.delete('year');

        apiFormData.append('vin', vin);
        apiFormData.append('make', make);
        apiFormData.append('model', model);
        apiFormData.append('year', year);
        console.log(this.calproAdasData);
        let cthreadCategory = ["1"];
        apiFormData.delete('threadCategory');
        apiFormData.append('threadCategory', JSON.stringify(cthreadCategory));
      } 
    }

    if(this.timeZoneInfo != '' && this.timeZoneInfo != undefined) {
      apiFormData.append('timeZoneInfo', JSON.stringify(this.timeZoneInfo));
    }

    //new Response(apiFormData).text().then(console.log)
    apiFormData.forEach((value,key) => {
      console.log(key+":"+value)
      return false;
    });

    this.repairOrderApi.updateSupportTicketsList(apiFormData).subscribe(res => {
      //console.log(res)
      if(!this.roViewEstActionFlag) {
        this.submitModal = false;
      }
      this.bodyElem.classList.remove(this.bodyClass2);
      if(res.status=='Success'){
        let resData = res.data;
        //this.errroMsgFlag = true;
        let postId= resData.postId;
        let threadId= resData.threadId;
        let dispatchId = resData.serviceId;
        let workOrderId = resData.workOrderId;
        this.workOrderId = resData.workOrderId;
        let shopId = resData.shopId;
        let teamId = (resData.teamId) ? resData.teamId : 0;
        let assignFlag = (resData.assignFlag) ? resData.assignFlag : false;
        let roPushApiFlag = (!this.diagnationDomain && !this.editRO && threadId >= 0) ? true : false;
        if(adasReportId > 0) {
          let saction = 'update';
          let sactionType = SolrContentTypeValues.ADASrecentVINs;
          this.updateSolr(saction, sactionType, adasReportId, postId);
          setTimeout(() => {
            this.calproPushApi(adasReportId);
          }, 200);
        }
        if(Object.keys(this.uploadedItems).length > 0 && this.uploadedItems.items.length > 0 && uploadCount > 0) {
          this.approvedFlag = (threadId > 0) ? 1 : 0;
          this.postApiData['uploadedItems'] = this.uploadedItems.items;
          this.postApiData['attachments'] = this.uploadedItems.attachments;
          this.postApiData['message'] = res.result;
          this.postApiData['workOrderId'] = workOrderId;
          this.postApiData['dataId'] = (threadId > 0) ? postId : workOrderId;
          this.postApiData['editRO'] = this.editRO;
          this.postApiData['roPushApiFlag'] = roPushApiFlag;
          this.postApiData['assignFlag'] = assignFlag;
          this.postApiData['dispatchId'] = dispatchId;
          this.postApiData['roViewEstActionFlag'] = this.roViewEstActionFlag;
          this.postApiData['shopId'] = (roPushApiFlag) ? shopId : this.postApiData['shopId'];
          this.postApiData['assignTech'] = (roPushApiFlag) ? assignTech : this.postApiData['assignTech'];
          if(this.editRO || threadId > 0){
            this.postApiData['postId'] = postId;
            this.postApiData['threadId'] = threadId;
            this.postApiData['approvedFlag'] = this.approvedFlag.toString();
          }

          this.manageAction = 'uploading';
          let requestTypeId = this.servicetype;
          let threadSolrFlag = (isPreApproved == 1) ? true : false;
          if(assignFlag) {
            switch(requestTypeId) {
              case 1:
                threadSolrFlag = true;
                break;
              case 2:
                this.pushApi(resData);
                break;
            }
          }
          this.submitModal = false;

          if(threadSolrFlag) {
            let taction = 'update';
            let tactionType = SolrContentTypeValues.Thread;
            this.updateSolr(taction, tactionType, threadId, postId);
            setTimeout(() => {
              if(roPushApiFlag) {
                this.roPushApi(workOrderId, shopId, threadId, postId, assignTech);
              }
              if(assignTech.length > 0) {
                this.sendPushMobile(threadId, teamId, assignTech[0]);
              }
            }, 2500);            
          }

          this.postUpload = false;
          setTimeout(() => {
            this.postUploadActionTrue = true;
            this.postUpload = true;
            setTimeout(() => {
              this.formProcessing = false;
            }, 1000);
          }, 100);
        }
        else{
          if(!this.roViewEstActionFlag) {
            const msgModalRef = this.modalService.open(SuccessModalComponent, this.modalConfig);
            if(this.editRO){
              msgModalRef.componentInstance.successMessage = "RO Updated Successfully";
            }
            else{
              msgModalRef.componentInstance.successMessage = "RO Created Successfully";
            }
            setTimeout(() => {
              msgModalRef.dismiss('Cross click');
            }, 2000);
          }

          setTimeout(() => {
            if(this.roViewEstActionFlag) {
              if(this.editRO) {
                setTimeout(() => {
                  this.roViewEstActionFlag = false;
                  this.formProcessing = false;
                }, 100);
                this.viewEstimate();
              } else {
                setTimeout(() => {
                  this.workOrderId = workOrderId;
                  this.workOrderType = 'edit';
                  this.editRO = true;
                  this.formProcessing = false;
                  this.manageTitle = `Edit ${this.title} ID# ${this.workOrderId}`;
                  this.createRO = `Update ${this.shortTitle}`;
                  this.editRepairOrderDetail();
                }, 2500);
              }
            }

            let data = {
              id: workOrderId,
              action: 'update',
              closeFlag: !this.roViewEstActionFlag,
              roAction: (this.editRO) ? 'edit' : 'new',
              assignFlag,
              dispatchId
            };
            this.ROManageService.emit(data);
          }, 2500);

          let solrTimeout = (this.diagnationDomain) ? 0 : 1000;
          setTimeout(() => {
            let raction = (this.editRO) ? 'update' : 'create';
            let ractionType = SolrContentTypeValues.repairOrder;
            this.updateSolr(raction, ractionType, this.workOrderId, postId);
            setTimeout(() => {
              if(roPushApiFlag) {
                this.roPushApi(workOrderId, shopId, threadId, postId, assignTech);
              }
            }, 2000);

            let requestTypeId = this.servicetype;
            console.log(requestTypeId, isPreApproved)
            let threadSolrFlag = (isPreApproved == 1) ? true : false;
            if(this.approvedFlag == 1 || assignFlag) {
              switch(requestTypeId) {
                case 1:
                  threadSolrFlag = true;
                  break;
                case 2:
                  this.pushApi(resData);
                  break;
              }
            }
            if(threadSolrFlag) {
              let taction = ((assignFlag && (this.editRO || isPreApproved == 1)) || (!assignFlag && isPreApproved == 1)) ? 'update' : 'create';
              let tactionType = SolrContentTypeValues.Thread;
              this.updateSolr(taction, tactionType, threadId, postId);
              if(assignTech.length > 0) {
                this.sendPushMobile(threadId, teamId, assignTech[0]);
              }
            }
          }, solrTimeout);
          setTimeout(() => {
            this.successFlag = true;
          }, 2500);
        }
      }
      else{
        this.errroMsgFlag = true;
        this.formProcessing = false;
      }
    },
    (error => {
      this.errroMsgFlag = true;
      this.formProcessing = false;
    })
    );
  }
    else{
    this.getFormValues(this.serviceForm);
    if(((!this.editRO && this.diagnationDomain && (this.description == '' || this.description == null)) || (!this.diagnationDomain && (this.description == '' || this.description == null))) ){
      this.problemDescFlag = true;
    }
    this.problemDescFlag = (this.diagnationDomain) ? this.problemDescFlag : false;
    this.errroMsgFlag = true;
  }
  }

  getFormValues(form: UntypedFormGroup): void {
    let requireFields = [];
    Object.keys(form.controls).forEach((key: string) => {
      const abstractControl = form.get(key);
      if(abstractControl instanceof UntypedFormGroup) {
        this.getFormValues(abstractControl);
      } else {
        console.log(key+'::'+abstractControl.status);
        let invalid = (abstractControl.status == 'INVALID') ? true: false;
        switch(key) {
          case 'shopId':
            invalid = (abstractControl.value == -1) ? true : invalid;
            break;
          case 'make':
            //invalid = (this.threadCategory == 1 && !this.makeValid) ? true : invalid;
            break;
          case 'model':
            //invalid = (this.threadCategory == 1 && !this.modelValid) ? true : invalid;
            break;
          case 'year':
            //invalid = (this.threadCategory == 1 && !this.yearValid) ? true : invalid;
            break;
          case 'toolType':
            invalid = (this.threadCategory == 2 && !this.toolType) ? true : invalid;
            break;
          case 'toolName':
            invalid = (this.threadCategory == 2 && !this.toolName) ? true : invalid;
            break;
        }

        if(invalid) {
          switch(key) {
            case 'workstream':
              requireFields.push('Workstream');
              break;
            case 'servicetype':
              requireFields.push('Service Type');
              break;
            case 'shopId':
              requireFields.push('Customer Details');
              break;
            case 'serviceContact':
              requireFields.push('Service Contact');
              break;
            case 'description':
              let desc = (this.diagnationDomain) ? 'Customer Complaint' : 'Customer Concern';
              requireFields.push(desc);
              break;
            case 'make':
              requireFields.push('Make');
              break;
            case 'model':
              requireFields.push('Model');
              break;
            case 'year':
              requireFields.push('Year');
              break;
            case 'toolType':
              requireFields.push('Tool Type');
              break;
            case 'toolName':
              requireFields.push('Tool Name');
              break;
          }
          this.requiredFields = requireFields;
          this.requiredFlag = true;
        }
      }
    });
  }

   resetServiceFormData(){
    this.shopId = 0;
    this.workstreamId = [];
    this.workstreamSelection = [];
    this.selectedShop = [];
    this.selectedCustomer = [];
    this.selectedCustomerId = [];
    this.selectedContact = [];
    this.selectedContactId = [];
    this.selectedTech = [];
    this.selectedTechId = [];
    this.selectedJobItemIds = [];
    this.selectedJobItems = [];
    this.regContactId= [];
    this.serviceSubmit = false;
    this.serviceFormValid = false;
    this.unit = "MI";
    this.unitOptions = ["MI" ,"KM"];
    this.servicetype = (this.diagnationDomain) ? 1 : this.servicetype;
    this.editRO = (this.workOrderType == 'new') ? false : true;
    if(this.endUser && this.lmvDomain) {
      this.getSubscriptionWorkstreamLists();
    } else {
      this.getWorkstreamLists();
    }
    
    if(!this.editRO){
      this.getWorkOrderTypes();
    }
    if((!this.diagnationDomain && !this.editRO && this.endUser)) {
      this.getShopList();
    }
    if(this.diagnationDomain) {
      this.getProductMakeList();
    }
    //this.loadCountryStateData();
    this.getYearsList();
    this.getMarketDataList();
    if(this.salesRepFlag) {
      this.getSalesRepList();
    }

    if(this.workOrderType == 'new'){
      this.loading = false;
      this.createRO = `Create ${this.shortTitle}`;
      this.manageTitle = `New ${this.title}`;
      this.billingInfoSection = (!this.diagnationDomain) ? this.paymentSectionFlag : false;
      //this.step2 = (this.iscanDomain) ? true : this.step2;
      //console.log(this.iscanDomain,this.step2)
      let validFlag = (this.diagnationDomain) ? false : true;
      this.makeValid = validFlag;
      this.modelValid = validFlag;
      this.yearValid = validFlag;
    }
    else{
      this.manageTitle = `Edit ${this.title} ID# ${this.workOrderId}`;
      this.createRO = `Update ${this.shortTitle}`;
      this.step2 = true;
    }

    this.createForm('service');
    this.createForm('serviceTech');
    this.createForm('serviceContact');
    let formTimeout = (this.editRO) ? 1000 : 750;
    setTimeout(() => {
      this.defaultData();
    }, formTimeout);
    setTimeout(() => {
      if(this.workOrderType == 'new' && this.autoSelectedWorkstream.length > 0) {
        let workstream = this.autoSelectedWorkstream;
        this.selectedItems(workstream, 'auto-workstream');
      }
    }, 1500);
  }
  
  // Manage Shop
  manageShop(apiData) {
    console.log(apiData)
    this.LandingpagewidgetsAPI.manageServiceShopAPI(apiData).subscribe((response) => {
      this.formProcessing = false;
      let error = response.error;
      if(!error) {
        this.bodyElem.classList.remove(this.bodyClass3);
        this.actionTitle = '';
        this.serviceShopSubmit = false;
        this.actionFlag = false;
        const serviceShop = response.data[0];
        console.log(serviceShop);
        let name = serviceShop.name+" ID#"+serviceShop.id;
        let addressLine1 = (serviceShop.addressLine1 == '' || serviceShop.addressLine1 == null) ? '' : ", "+serviceShop.addressLine1;
        let addressLine2 = (serviceShop.addressLine2 == '' || serviceShop.addressLine2 == null) ? '' : ", "+serviceShop.addressLine2;
        let city = (serviceShop.city == '' || serviceShop.city == null) ? '' :  ", "+serviceShop.city;
        let state = (serviceShop.state == '' || serviceShop.state == null) ? '' : ", "+serviceShop.state;
        let zip = (serviceShop.zip == '' || serviceShop.zip == null) ? '' : " "+serviceShop.zip;
        let email = serviceShop.email;
        let splitEmail = email.split(this.maskEmail);
        serviceShop['isMaskCustomer'] = (splitEmail.length > 1) ? 1 : 0;
        email = (splitEmail.length > 1) ? '' : email;
        email = (email == '' || email == null) ? '' : ", "+email;
        let dialCode = (serviceShop.dialCode == '' || serviceShop.dialCode == null) ? '' : serviceShop.dialCode;      
        let phone = (serviceShop.phone == '' || serviceShop.phone == null) ? '' : ", "+dialCode+" "+serviceShop.phone;
        serviceShop['showval'] = name+addressLine1+addressLine2+city+state+zip+email+phone;
        let timeZone = (serviceShop.timeZone && serviceShop.timeZone != undefined) ? serviceShop.timeZone : '';
        if(timeZone != '') {
          this.timeZoneList.push({id: timeZone, name: timeZone});
          this.serviceForm.patchValue({appointmentTimeZone: timeZone});
        }
        console.log(serviceShop, email);
        let marketId = serviceShop.marketId;
        this.marketId = marketId;
        console.log(this.marketId, this.marketDataOptions)
        let marketIndex = this.marketDataOptions.findIndex(option => option.id == marketId);
        if(marketIndex > 0) {
          this.marketName = this.marketDataOptions[marketIndex].name;
        }
        if(apiData.action == 'new') {
          this.businessName =  serviceShop.name;
          this.Shops.splice(0, 1, serviceShop);
          //this.Shops.splice(0, 0, { id: 0, label: `${ManageTitle.actionNew} ${DispatchText.customer}` });
          this.shopChanged('trigger', serviceShop.id);
          setTimeout(() => {
            this.serviceForm.patchValue({shopId: serviceShop.id});
          }, 10);
        } else {
          console.log(this.Shops)
          let shopIndex = this.Shops.findIndex(option => option.id == serviceShop.id);
          let checkShopId = this.Shops[shopIndex].id;
          console.log(shopIndex)
          let servicetype = this.serviceForm.value.servicetype;
          if(servicetype != '' && servicetype != undefined && servicetype > 0) {
            this.getAssigneeList();
          }
          this.Shops[shopIndex] = serviceShop;
          
          if(checkShopId == serviceShop.id) {
            this.businessName =  serviceShop.name;
            this.selectedShop = serviceShop;
            this.serviceForm.patchValue({shopId: serviceShop.id});
          }
          let roList = response.data['roList'];
          if(roList?.length > 0) {
            this.updateBulkSolr(roList);
          }
          let prevEmail = response.data['prevEmail'];;
          let email = serviceShop.email;
          if(prevEmail != email) {
            let cindex = this.contacts.findIndex(option => option.email == prevEmail);
            if(cindex >= 0) {
              this.contacts[cindex].email = email;
              let itemVal = this.renderContact(this.contacts[cindex]);
              this.contacts[cindex].name = itemVal;
              let cid = this.contacts[cindex].id;
              let loginId = this.contacts[cindex].loginId;
              let sindex = this.selectedContactId.findIndex(option => option == cid);
              if(sindex >= 0) {
                this.selectedContact[sindex] = itemVal;
              }
              let sbindex = this.selectedBillingContactId.findIndex(option => option == cid);
              if(sbindex >= 0) {
                this.selectedBillingContact[sbindex] = itemVal;
              }

              let tindex = this.Technician.findIndex(option => option == loginId);
              if(tindex >= 0) {
                let stindex = this.selectedTechId.findIndex(option => option == loginId);
                let item = this.contacts[cindex];
                let phone = (item.phoneNumber == '' || item.phoneNumber == null || item.phoneNumber == 'null') ? '' : ", "+item.phoneNumber;
                let uname;
                email = item.email != '' && item.email != undefined ? ', '+item.email : '';
                let firstName = item.firstName != '' && item.firstName != undefined ? ''+item.firstName : '';
                let lastName = item.lastName != '' && item.lastName != undefined ? ' '+item.lastName : '';
                uname = firstName+lastName+email+phone;
                this.Technician[tindex].name = uname;
                this.Technician[tindex].label = uname;
                if(stindex >= 0) {
                  this.selectedTech[stindex] = uname;
                }
              }
            }
          }
        }
        this.shopExist = false;
        this.existError = '';
        this.actionForm = '';
        this.serviceShopForm.reset();
      } else {
        this.shopExist = true;
        this.existError = response.message;
      }
    });
  }

  bussinessContactInfo(obj){
    const signupData = new FormData();
    signupData.append('api_key', Constant.ApiKey);
    signupData.append('firstname', obj.firstName);
    signupData.append('lastname', obj.lastName);
    signupData.append('email', obj.email);
    signupData.append('password', '@Password123');
    signupData.append('phoneNumber', obj.phoneNumber);
    signupData.append('countryName', obj.countryName);
    signupData.append('countryCode', obj.countryCode);
    signupData.append('dialCode', obj.dialCode);
    signupData.append('step', '3');
    signupData.append('subdomainName', this.businessName );
    signupData.append('subdomainId', this.domainId );
    signupData.append('version', '2');
    signupData.append('fromTechnician', '2');
    signupData.append('roleId', '4');
    signupData.append('businessName', this.businessName);
    signupData.append('businessId', this.shopId.toString());
    //new Response(signupData).text().then(console.log)
    //return false;

    this.authenticationService.signup(signupData).subscribe((response) => {
      let id = response.Userid;
      if(id!= ''){
        let cindex1 = this.regContactId.findIndex(option => option == id);
        if(cindex1 == '-1'){
          this.regContactId.push(id);
        }
      }
    });

  }

  // Render Contact Info
  renderContact(item) {
    let fname = item.firstName;
    let lname = item.lastName;
    let name = (lname != '') ? `${fname} ${lname}` : fname;
    let email = item.email;
    let splitEmail = email.split(this.maskEmail);
    email = (splitEmail.length > 1) ? '' : email;
    let dialCode = (item.dialCode == '' || item.dialCode == null || item.dialCode == 'null') ? '' : item.dialCode+" ";
    let phoneNumber = (item.phoneNumber == '' || item.phoneNumber == null || item.phoneNumber == 'null') ? '' : ", "+`${dialCode} ${item.phoneNumber}`;
    let val = `${name}`;
    val = (email != '') ? `${val}, ${email}` : val;
    val = (phoneNumber != '') ? `${val} ${phoneNumber}` : val;
    return val;
  }

  onToggleChange(event) {
    let checked = event.checked;
    this.billingInfoSection = checked;
    this.paymentMethodSection = checked;
    //let isPreApproved = (!checked) ? 'Yes' : 'No';
    //this.assignTechDisable = (checked) ? true : false;
    //let isPreApproved = 'Yes';
    //this.serviceForm.patchValue({isPreApproved});
    console.log(this.serviceForm)
  }

  onChange(type){
    switch(type){
      case 'odo':
        if(this.odo == ''){
          //this.odometerFlag = true;
        }
        else{
          //this.odometerFlag = false;
          this.odo = this.commonApi.removeCommaNum(this.odo);
          this.odo = this.commonApi.numberWithCommasThreeDigit(this.odo);
        }
        break;
        case 'desc':
          if(this.description == '' && !this.editRO){
            this.problemDescFlag = true;
          }
          else{
            if(this.description){
              this.problemDescFlag = this.description.trim() == '' && !this.editRO ? true : false;
            }
            else{
              this.problemDescFlag = (this.diagnationDomain) ? this.problemDescFlag : false;
            }
          }
        break;
    }
  }

  timeChange(field, val, action = '') {
    console.log(val)
    const time = moment(val).format('hh:mm A');
    switch(field) {
      case 'appointmentTime':
        this.serviceForm.patchValue({appointmentTime: time}); 
        if(action == 'change') {
          this.setupTimeZone();
        }
        if (this.technicians && this.technicians.length > 0) {
          this.technicianToggle();
        }
        break;
      case 'dueTime':
        this.serviceForm.patchValue({dueTime: time});
        if (this.technicians && this.technicians.length > 0) {
          this.technicianToggle();
        }
        break;
    }    
  }

  timeEventChange1(field, event) {
    let val = event.target.value;
    let key = event.key;
    if(key == 'Enter') {
      let timeSplit = val.split(' ');
      console.log(timeSplit.length)
      if(timeSplit.length == 2) {
        let timeSplitVal = timeSplit[0].split(':');
        if(timeSplitVal.length == 2) {
          switch(field) {
            case 'appointmentTime':
              this.serviceForm.patchValue({appointmentTime: val});
              break;
            case 'dueTime':
              this.serviceForm.patchValue({dueTime: val});
              break;
          }
        }
      } else {
        let timeSplitVal = timeSplit[0].split(':');
        let format = 'AM';
        if(timeSplitVal.length == 2) {
          let hour = timeSplitVal[0];
          format = (hour > 7 && hour < 12) ? 'AM' : 'PM';
        }
        val = `${val} ${format}`;
        switch(field) {
          case 'appointmentTime':
            this.serviceForm.patchValue({appointmentTime: val});
            break;
          case 'dueTime':
            this.serviceForm.patchValue({dueTime: val});
            break;
        }
      }
    }
  }

  /** Handle manual typing and auto-format */
  timeEventChange(controlName: string, event: any) {
    const ctrl = this.serviceForm.get(controlName);
    let value = event.target.value.trim();

    if (!value) {
      ctrl?.setErrors(null);
      return;
    }

    const formatted = this.autoFormatTime(value);

    if (formatted) {
      ctrl?.setValue(formatted, { emitEvent: false });
      ctrl?.setErrors(null);
      if(controlName == 'appointmentTime') {
        this.setupTimeZone();
      }
    } else {
      const empty = '';
      ctrl?.setValue(empty, { emitEvent: false });
      ctrl?.setErrors({ invalidTime: true });
    }
  }

  /** Auto-format and validate 12-hour time string */
  private autoFormatTime(input: string): string | null {
    if (!input) return null;

    // Normalize spacing and case
    input = input.replace(/\s+/g, '').toUpperCase();

    // Match patterns: 4PM, 04PM, 4:00PM, 04:30PM
    const regex = /^(\d{1,2})(?::?(\d{2}))?(AM|PM)?$/i;
    const match = input.match(regex);
    if (!match) return null;

    let hour = parseInt(match[1], 10);
    let minute = match[2] ? parseInt(match[2], 10) : 0;
    let ampm = match[3] ? match[3].toUpperCase() : (hour >= 12 ? 'PM' : 'AM');

    // Basic validation
    if (hour < 1 || hour > 12 || minute < 0 || minute > 59) return null;

    // Format properly: hh:mm AM/PM
    const hh = hour.toString().padStart(2, '0');
    const mm = minute.toString().padStart(2, '0');
    return `${hh}:${mm} ${ampm}`;
  }

  setupIscanFormData(item) {
    console.log(item)
    let servicetype:any = parseInt(item.requestTypeId);
    let wsId = localStorage.getItem('defaultWorkstream');
    let workstream = [wsId];
    this.workstreamId = workstream;
    this.workstreamSelection = workstream;
    let contactIndex = this.contacts.findIndex(option => option.email == item.contactPersonEmail);
    console.log(this.contacts, contactIndex)
    let contact = this.contacts[contactIndex];
    let selectedContactIdArr = []
    let contactId = [];
    contactId.push(contact.id);
    console.log(contactId);
    this.selectedContactId=(contactId);
    selectedContactIdArr.forEach(id => {
      let cindex = this.contacts.findIndex(option => option.id == id);
      if(cindex != '-1'){
        if(this.contacts[cindex].name!=''){
          this.selectedContact.push(this.contacts[cindex].name);
        }
      }
    });
    if(item.make && item.make != '') {
      this.getMakeModelsList(item.make, item.vin);
      this.modelPlaceHoder = (item.model != '') ? item.model : 'Model';
    }
    this.internalNotes = item.internalNotes;
    this.serviceForm.patchValue({
      workstream,
      servicetype,
      emailAddress: item.emailAddress,
      serviceContact: contactId,
      vin: item.vin,
      make: item.make,
      model: item.model,
      odo: item.odo,
      year: item.year,
      isAsap: item.isAsap,
      description: item.description,
      internalNotes: item.internalNotes,
    });
  }

  editServiceData(item) {
    this.workOrderId = item.roIdInt;
    this.diagnationDomain = this.diagnationDomain ? true : this.workOrderId == 4078 ? true : false;
    console.log(item);
    this.selectedShop = [];
    this.selectedContact = [];
    this.selectedContactId = [];
    this.selectedBillingContact = [];
    this.selectedBillingContactId = [];
    this.selectedJobItemIds = [];
    this.selectedJobItems = [];
    //this.serviceId = item.serviceId;
    this.vinIsValid = true;
    this.vinVerfied = true;
    this.vinValid = true;
    this.showClear = true;
    this.contactDisable = false;
    this.billingContactDisable = false;
    this.serviceSubmit = false;
    this.shopId = item.shopIdInt;
    this.dispatchId = item.dispatchIdInt;
    this.servicetype = item.requestTypeIdInt;
    let workOrderStatus = (item.workOrderStatusStr != null || item.workOrderStatusStr != undefined || item.workOrderStatusStr != '') ? parseInt(item.workOrderStatusStr) : 0;
    let threadId = (item.threadIdInt != '' && item.threadIdInt != '0') ? item.threadIdInt : 0;
    //this.requestTypeDisable = (this.endUser || this.diagnationDomain || workOrderStatus == 4 || workOrderStatus == 7 || workOrderStatus == 12 || workOrderStatus == 13 || workOrderStatus == 15 || workOrderStatus == 17) ? true : false;
    this.requestTypeDisable = (this.endUser || this.diagnationDomain || threadId > 0) ? true : false;
    let vin = (item.vinStr && item.vinStr != '') ? 'vin' : '';
    let marketId = (item.marketIdInt && item.marketIdInt != undefined) ? item.marketIdInt : 0;
    let salesRepId = (item.salesRepIdInt && item.salesRepIdInt != undefined) ? item.salesRepIdInt : 0;
    let isPreApproved = (item.isPreApprovedInt && item.isPreApprovedInt != '') ? item.isPreApprovedInt : 0;
    this.marketId = marketId;
    console.log(this.marketId, this.marketDataOptions)
    let marketIndex = this.marketDataOptions.findIndex(option => option.id == marketId);
    if(marketIndex > 0) {
      this.marketName = this.marketDataOptions[marketIndex].name;
    }
    this.assignTechDisable = (isPreApproved == 1) ? false : true;
    setTimeout(() => {
      this.getAssigneeList();
    }, 4000);
    console.log(marketId, salesRepId, workOrderStatus, threadId)
    if(threadId > 0) {
      switch(workOrderStatus) {
        case 3:
        case 4:
        case 8:
        case 15:
          this.workstreamDisable = (!this.diagnationDomain) ? true : false;
          this.assignTechDisable = false;
          break;
        case 1:
        case 2:
        case 14:
          this.assignTechDisable = (isPreApproved == 1) ? false : this.assignTechDisable;
          break;
      }
    }
    if(this.diagnationDomain && item.make && item.make != '') {
      console.log(this.makeList)
      let makeIndex = this.makeList.findIndex(option => option.makeName.toLowerCase() == item.make.toLowerCase());
      if(makeIndex >= 0) {
        item.make = this.makeList[makeIndex].makeName;
      }
      this.getMakeModelsList(item.make, vin);
      this.modelPlaceHoder = (item.model != '') ? item.model : 'Model';
    }
    this.attachmentsData = (item.uploadContents && item.uploadContents != undefined) ? item.uploadContents : '';
    if(this.attachmentsData != ''){
      this.attachmentLoading = (item.uploadContents.length>0) ? false : true;

      if(item.uploadContents && item.uploadContents?.length>0){
        this.commentUploadedItemsLength = item.uploadContents.length;
        this.commentUploadedItemsFlag = true;
      }
    }
    else{
      this.attachmentLoading = false;
    }

    this.billingInfoSection = (item.billingSectionInt && item.billingSectionInt != undefined) ? true : false;
    if(item.isPaymentSectionInt && item.isPaymentSectionInt != undefined) {
      this.paymentSectionFlag = (item.isPaymentSectionInt == 0) ? false : true;
    }
    let paymentToggle: any = this.paymentSectionFlag ? 1 : 0;

    this.getCategoryData(item);

    this.workstreamSelection = [];
    this.workstreamSelection = item.workstreamsJsonArr && item.workstreamsJsonArr != undefined ? item.workstreamsJsonArr : '' ;

    console.log(this.Shops);
    console.log(this.ROViewData);

    for (let ws of this.Shops) {
      if(ws.id == item.shopIdInt){
        this.businessName = ws.name;
        console.log(ws);
        this.selectedShop = ws;
      }
    }

    console.log(this.selectedShop, this.ROViewData);
    this.setupShopAddress(this.selectedShop,true,'trigger','',workOrderStatus);

    item.approvedDate = (item.approvedDateStr && item.approvedDateStr != null && item.approvedDateStr != undefined && item.approvedDateStr != '') ? (item.approvedDateStr) : '';
    console.log(item.approvedDate)
    let approveDate = item.approvedDate;
    if(approveDate != '') {
      approveDate = moment.utc(approveDate).toDate();
      approveDate = moment(approveDate).local().format('MMM DD, YYYY h:mm A');
      item.approveDate = approveDate;
    } else {
      item.approveDate = "-";
    }
    item.approvedBy = (item.approvedByInt > 0 && item.approvedByInfoJsonArr && item.approvedByInfoJsonArr != null && item.approvedByInfoJsonArr != undefined && item.approvedByInfoJsonArr != '') ? `${item.approvedByInfoJsonArr[0].firstName} ${item.approvedByInfoJsonArr[0].lastName}` : '-';

    item.technicianId = item.technicianIdStr && item.technicianIdStr != '' && item.technicianIdStr != undefined ? item.technicianIdStr : '';
    let techId = item.technicianId != '' ?  JSON.parse(item.technicianId) : '';
    let contactId = item.contactInfoStr && item.contactInfoStr != '' ?  JSON.parse(item.contactInfoStr) : '';
    let billingContactId = (item.billingContactInfoStr && item.billingContactInfoStr != '') ? JSON.parse(item.billingContactInfoStr) : '';
    let paymentMethod = (item.paymentMethodInt && item.paymentMethodInt != '') ? item.paymentMethodInt.toString() : '';
    isPreApproved = (isPreApproved == 1) ? 'Yes' : 'No';
    this.selectedContact=[];
    this.selectedContactId = [];
    let selectedContactIdArr = [], selectedBillingContactIdArr = [];
    selectedContactIdArr=(contactId);
    selectedBillingContactIdArr = (billingContactId != '') ? billingContactId : selectedBillingContactIdArr;

    let dummycontactId=[], dummyBillingContactId=[];
    if(contactId.length>0){
      for(let cid in contactId){
        dummycontactId.push(parseInt(contactId[cid]));
      }
    }
    else{
      dummycontactId.push(parseInt(contactId));
    }
    contactId = dummycontactId;
    console.log(contactId);
    this.selectedContactId=(contactId);
    if(billingContactId.length>0){
      for(let bcid in billingContactId){
        dummyBillingContactId.push(parseInt(billingContactId[bcid]));
      }
    } else{
      //dummyBillingContactId.push(parseInt(billingContactId));
    }

    billingContactId = dummyBillingContactId;
    console.log(billingContactId);
    this.selectedBillingContactId=(billingContactId);

    this.selectedTech = [];
    this.selectedTechId = [];

    var techIdArr = [];
    if(techId != ''){
      for (const i in techId) {
        if(i=='0'){
          if(techId[i]!=''){
            techIdArr.push(techId[i]);
          }
        }
      }
    }
    console.log(techIdArr);
    let techIdStr = techIdArr.length>0 ? (this.diagnationDomain) ? techIdArr[0] : (parseInt(techIdArr[0])) : '';
    this.selectedTechId=(techIdArr);
    this.estimationSelectedItems = '';
    this.estimationSelectedItems = item.estimationDataJsonArr && item.estimationDataJsonArr != undefined && item.estimationDataJsonArr != '' ? item.estimationDataJsonArr[0] : '';
    if(this.estimationSelectedItems!=''){
    this.estimationSelectedItems = this.estimationSelectedItems?.estimationArray?.length>0 ? this.estimationSelectedItems : '';
    }
    console.log(this.estimationSelectedItems);
    this.jobcodeArr=[];
    if(this.estimationSelectedItems && this.estimationSelectedItems!=''){
      if(this.estimationSelectedItems['estimationArray']?.length>0)
      {
        for (let wsd in this.estimationSelectedItems['estimationArray'])
        {
          this.jobcodeArr.push(this.estimationSelectedItems['estimationArray'][wsd].jobcode);
          console.log(this.estimationSelectedItems['estimationArray'][wsd].jobcode)
        }
      }
    }

    let jobItems = (item.jobItemsIntArr && item.jobItemsIntArr != undefined) ? item.jobItemsIntArr : [];
    this.selectedJobItemIds = jobItems;
    this.selectedJobItems = (item.jobItemsInfoJsonArr && item.jobItemsInfoJsonArr != undefined) ? item.jobItemsInfoJsonArr : [];
    let jobType = (item.jobTypeIdInt && item.jobTypeIdInt != undefined) ? item.jobTypeIdInt : 1;
    this.workstreamSelection = item.workstreamsJsonArr && item.workstreamsJsonArr != undefined ? item.workstreamsJsonArr : '' ;

    this.serialNumberReadOnly = (this.threadCategory == 10 && !this.dmaDomain) ? true : false;
    this.problemDescFlag = item.descriptionStr == '' && !this.editRO ? true : false;
    
    setTimeout(() => {
      const adasReportId = (this.editRO) ? this.ROViewData['adasReportIdInt'] : 0;
      if(adasReportId > 0) {
        this.calproAdasData = (this.ROViewData['inspectionJsonArr'] && (this.ROViewData['inspectionJsonArr'] != null || this.ROViewData['inspectionJsonArr'] != undefined || this.ROViewData['inspectionJsonArr'] != '')) ? (this.ROViewData['inspectionJsonArr']) : [];
      }
      this.roPageData = {
        access: "edit",
        fromaccess: 'repairorder-list',
        contentType: ContentTypeValues.RepairOrder,
        make: '',
        model: '',
        id: '0',
        selectedItems: this.estimationSelectedItems,
        reportId: adasReportId,
      }

      this.roEstimationFlag = false;
      setTimeout(() => {
        this.roEstimationFlag = true;
      }, 1);

      selectedContactIdArr.forEach(id => {
        let cindex = this.contacts.findIndex(option => option.id == id);
        if(cindex != '-1'){
          if(this.contacts[cindex].name!=''){
            this.selectedContact.push(this.contacts[cindex].name);
          }
        }
      });

      selectedBillingContactIdArr.forEach(id => {
        let cindex = this.contacts.findIndex(option => option.id == id);
        if(cindex != '-1'){
          if(this.contacts[cindex].name!=''){
            this.selectedBillingContact.push(this.contacts[cindex].name);
          }
        }
      });

      if(this.selectedTechId != ''){
        this.selectedTechId.forEach(id => {
          let cindex = this.Technician.findIndex(option => option.id == id);
          if(cindex != '-1'){
            if(this.Technician[cindex].name!=''){
              if(this.diagnationDomain){
                this.selectedTech.push(this.Technician[cindex]);
              }
              else{
                this.selectedTech.push(this.Technician[cindex].name);
              }
            }
          }
        });
      }
      console.log(this.selectedTech)
      console.log(this.selectedTechId)
      this.insuranceCompanyId = item.insuranceCompanyIdInt && item.insuranceCompanyIdInt != undefined ? `${item.insuranceCompanyIdInt}` : '';
      let estDate:any = item.estimateCreatedOnStr && item.estimateCreatedOnStr != undefined ? item.estimateCreatedOnStr : '';
      if(estDate != '') {
        let mdate:any = moment(estDate);
        estDate = new Date(mdate);
      //  check if nan in date
          if(estDate.toString() == 'Invalid Date') {
            estDate = this.currDate;
          }
      }

      let orderDate:any = item.orderDateStr && item.orderDateStr != undefined ? item.orderDateStr : '';
      if(orderDate != '') {
        let mdate:any = moment(orderDate);
        orderDate = new Date(mdate);
      //  check if nan in date
          if(orderDate.toString() == 'Invalid Date') {
            orderDate = this.currDate;
          }
      }

      let verificationDate:any = item.verificationDateStr && item.verificationDateStr != undefined ? item.verificationDateStr : '';
      if(verificationDate != '') {
        let mdate:any = moment(verificationDate);
        verificationDate = new Date(mdate);
      //  check if nan in date
          if(verificationDate.toString() == 'Invalid Date') {
            verificationDate = this.currDate;
          }
      }

      if(this.diagnationDomain){
        this.initcomplaint = item.customerComplaintStr ? item.customerComplaintStr : '';
        this.billingfirstname = item.billingFirstNameStr ? item.billingFirstNameStr : '' ;
        this.billinglastname = item.billingLastNameStr ? item.billingLastNameStr : '';
        this.ordernumberReadOnlyFlag = item.orderNumberStr && item.orderNumberStr != '' ? true : false;
        this.dninvoiceReadOnlyFlag = item.dn_invoiceStr && item.dn_invoiceStr != '' ? true : false;
        //this.productservicesReadOnlyFlag = item.product_service != '' ? true : false;
        this.serviceForm.patchValue({
          workstream: this.workstreamSelection,
          servicetype: item.requestTypeIdInt && item.requestTypeIdInt != undefined ? item.requestTypeIdInt : '' ,
          repairOrder: item.roIdInt && item.roIdInt != undefined ? item.roIdInt : '' ,
          shopId: item.shopIdInt && item.shopIdInt != undefined ? item.shopIdInt : '' ,
          serviceContact: contactId,
          billingfirstname: this.billingfirstname,
          billinglastname: this.billinglastname,
          vin: item.vinStr && item.vinStr != undefined ? item.vinStr : '' ,
          make: item.make && item.make != undefined ? item.make : '' ,
          model: item.model && item.model != undefined ? item.model : '' ,
          odo: item.odometerStr && item.odometerStr != undefined ? item.odometerStr : '' ,
          unit: item.unitStr && item.unitStr != undefined && item.unitStr != 'undefined' ? item.unitStr : this.unit ,
          year: item.year && item.year != undefined ? item.year : '' ,
          ordernumber: item.orderNumberStr && item.orderNumberStr != undefined ? item.orderNumberStr : '' ,
          //productservices: item.product_service,
          dninvoice: item.dn_invoiceStr && item.dn_invoiceStr != undefined ? item.dn_invoiceStr : '' ,
          serviceTech: techIdStr,
          description: item.descriptionStr && item.descriptionStr != undefined ? item.descriptionStr : '',
          initcomplaint: item.customerComplaintStr && item.customerComplaintStr != undefined ? item.customerComplaintStr : '',
          insuranceCompanyId: item.insuranceCompanyIdInt && item.insuranceCompanyIdInt != undefined ? item.insuranceCompanyIdInt : '',
          estimateCreatedOn: item.estimateCreatedOnStr && item.estimateCreatedOnStr != undefined ? estDate : this.currDate,
          marketId,
          salesRepId,
        });
      }
      else{
        let timeZone = item.appointmentTimeZoneStr && item.appointmentTimeZoneStr != undefined ? item.appointmentTimeZoneStr : '';
        if(timeZone != '') {
          this.timeZoneList.push({id: timeZone, name: timeZone});
        }
        let assignTech = (item.assignTechnicianIdStr && item.assignTechnicianIdStr != undefined) ? JSON.parse(item.assignTechnicianIdStr) : [];
        let referenceShopRO = item.referenceShopROStr && item.referenceShopROStr != undefined ? item.referenceShopROStr : '';
        referenceShopRO = (referenceShopRO == 0) ? '' : referenceShopRO;
        let customerSyteLine = (item.customerSyteLineStr && (item.customerSyteLineStr != null || item.customerSyteLineStr != undefined || item.customerSyteLineStr != '')) ? item.customerSyteLineStr : 0;
        let customerPO = (item.customerpoStr && (item.customerpoStr != null || item.customerpoStr != undefined || item.customerpoStr != '')) ? item.customerpoStr : '';
        let servicetype = item.requestTypeIdInt && item.requestTypeIdInt != undefined ? item.requestTypeIdInt : '';

        let ordertype = item.orderTypeJsonArr && item.orderTypeJsonArr != undefined && item.orderTypeJsonArr.length>0 ? item.orderTypeJsonArr[0].id : '';

        let aptDate:any = item.appointmentDateStr && item.appointmentDateStr != undefined ? item.appointmentDateStr : '';
        if(aptDate != '') {
          let mdate:any = moment(aptDate);
          aptDate = new Date(mdate);
        }
        let currDate = '';
        if(this.domainId == 462 || this.domainId == 511) {
          currDate = '';  
        } else {
          currDate = (!this.editRO) ? this.currDate : '';
        }
        let appointmentDate = item.appointmentDateStr && item.appointmentDateStr != undefined ? aptDate : currDate;
        let appointmentTime = item.appointmentTimeStr && item.appointmentTimeStr != undefined ? item.appointmentTimeStr : '';
        if(appointmentTime != '') {
          appointmentTime = moment(appointmentTime, "HH:mm:ss A").format('h:mm A')          
        }
        let ctime = (this.domainId != 462 && this.domainId != 511) ? this.ctime : '';
        appointmentTime = (appointmentTime == '') ? ctime : appointmentTime;
        console.log('3',appointmentTime, '4', ctime)
        let cdueDate:any = item.dueDateStr && item.dueDateStr != undefined ? item.dueDateStr : '';
        if(cdueDate != '') {
          let cdate:any = moment(cdueDate);
          cdueDate = new Date(cdate);
        }
        let dueDate = item.dueDateStr && item.dueDateStr != undefined ? cdueDate : currDate;
        let dueTime = item.dueTimeStr && item.dueTimeStr != undefined ? item.dueTimeStr : ctime;
        let threadCategory = item.threadCategoryInt;
        this.threadCategory = threadCategory;
        this.supportTypeOptions.forEach(option => {
          if(servicetype == 2) {
            option.display = (option.id == 1 || option.id == 7) ? true : false;
          } else {
            option.display = true;
          }
          if(option.id != this.threadCategory) {
            option.isSelected = false;
          } else {
            this.supportTypeChange('trigger-edit', option);
          }
        });
        setTimeout(() => {
          if(item.make && item.make != '') {
            console.log(this.makeList)
            let makeIndex = this.makeList.findIndex(option => option.makeName.toLowerCase() == item.make.toLowerCase());
            if(makeIndex >= 0) {
              item.make = this.makeList[makeIndex].makeName;
            }
            console.log('in model api call', item.make)
            this.getMakeModelsList(item.make, vin);
            this.modelPlaceHoder = (item.model != '') ? item.model : 'Model';
          }
        }, 1500);
        let vin = ((this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) && item.vinStr && item.vinStr != undefined && item.vinStr != 0) ? item.vinStr : ''
        let make = ((this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) && item.make && item.make != undefined) ? item.make : '';
        let model = ((this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) && item.make && item.model != undefined) ? item.model : '';
        let year = ((this.threadCategory == 1 || (this.threadCategory == 10 && this.dmaDomain)) && item.year && item.year != undefined && item.year != 0) ? item.year : '';
        let toolType = ((this.threadCategory == 2 || (this.threadCategory == 10 && !this.dmaDomain)) && item.make && item.make != undefined) ? item.make : '';
        this.toolType = toolType;
        let toolName = ((this.threadCategory == 2 || (this.threadCategory == 10 && !this.dmaDomain)) && item.model && item.model != undefined) ? item.model : '';
        this.toolName = toolName;
        let serialNumber = item.serialNumberStr;
        let scanVersion = item.scanVersionStr;
        let asap = item.isAsapInt && item.isAsapInt != undefined ? item.isAsapInt : 0;
        let flexible = item.isFlexibleInt && item.isFlexibleInt != undefined ? item.isFlexibleInt : 0;
        this.selectedAppointmentOptionId = (asap > 0) ? 2 : (flexible > 0) ? 3 : 1;
        let soi = this.appointmentOptions.findIndex(option => option.id == this.selectedAppointmentOptionId);
        let appointmentOption = this.selectedAppointmentOption;
        if(soi >= 0) {
          appointmentOption = this.appointmentOptions[soi].name;
          this.selectedAppointmentOption =  appointmentOption;
        }
        ordertype = this.gbbDomain ? ordertype : '1'; // dummy validation other domain
        setTimeout(() => {          
          this.serviceForm.patchValue({
            workstream: this.workstreamSelection,
            servicetype,
            ordertype,
            repairOrder: item.roIdInt && item.roIdInt != undefined ? item.roIdInt : '' ,
            referenceShopRO,
            customerSyteLine,
            customerPO,
            shopId: item.shopIdInt && item.shopIdInt != undefined ? item.shopIdInt : '' ,
            serviceContact: contactId,
            billingContact: billingContactId,
            isSameContact: item.isSameContactInt && item.isSameContactInt != undefined ? item.isSameContactInt : 0,
            paymentToggle,
            paymentMethod,
            isPreApproved,
            threadCategory,
            vin,
            make,
            model,
            odo: item.odometerStr && item.odometerStr != undefined && item.odometerStr != 'undefined' ? item.odometerStr : '' ,
            unit: item.unitStr && item.unitStr != undefined && item.unitStr != 'undefined' ? item.unitStr : this.unit ,
            year: year,
            serialNumber,
            toolType,
            toolName,
            scanVersion,
            appointmentOption,
            isAsap: asap,
            appointmentDate: appointmentDate,
            appointmentTime: appointmentTime,
            appointmentTimeZone: timeZone,
            dueDate: dueDate,
            dueTime: dueTime,
            durationDays: item.durationDaysStr && item.durationDaysStr != undefined ? item.durationDaysStr : '0',
            durationHours: item.durationHoursStr && item.durationHoursStr != undefined ? item.durationHoursStr : this.hourList[1].id,
            durationMinutes: item.durationMinutesStr && item.durationMinutesStr != undefined ? item.durationMinutesStr : '0',          
            isFlexible: flexible,
            isParkingLot: item.isParkingLotInt && item.isParkingLotInt != undefined ? item.isParkingLotInt == 1 : 0,
            serviceTech: techIdStr,
            description: item.descriptionStr && item.descriptionStr != undefined ? item.descriptionStr : '' ,
            internalNotes: item.internalNotesStr && item.internalNotesStr != undefined ? item.internalNotesStr : '',
            assignTechnicianId: (assignTech.length > 0) ? assignTech[0].toString() : '',
            licensePlate: item.licensePlateStr && item.licensePlateStr != undefined ? item.licensePlateStr : '',
            assetTag: item.assetTagStr && item.assetTagStr != undefined ? item.assetTagStr : '',
            marketId,
            salesRepId,
            jobItems,
            jobType,
            insuranceCompanyId: item.insuranceCompanyIdInt && item.insuranceCompanyIdInt != undefined ? item.insuranceCompanyIdInt : '',
            estimateCreatedOn: item.estimateCreatedOnStr && item.estimateCreatedOnStr != undefined ? estDate : this.currDate,
            orderCreatedOn: item.orderDateStr && item.orderDateStr != undefined ? orderDate : this.currDate,
            verificationCreatedOn: item.verificationDateStr && item.verificationDateStr != undefined ? verificationDate : this.currDate,
          });
          setTimeout(() => {
            this.setupTimeZone('shop');
          }, 100);
        }, 750);  
      }
      
      setTimeout(() => {
        this.loading = false;
        this.invisibleFlag = false;        
      }, 500);
      setTimeout(() => {
        console.log("init this.inventorySource: ", this.dropdownInventorySource);
        this.dropdownInventorySource?.updateSelectedOption(this.inventorySource || 1)
        this.cdr.detectChanges();
      }, 3000);
    }, 1000);
  }

  newRepairOrderDetail(){
    this.commentUploadedItemsLength = 0;
    this.commentUploadedItemsFlag = false;
    this.postUploadActionTrue = false;
    this.updatedAttachments = [];
    this.editAttachments = [];
    this.deletedFileIds = [];
    this.mediaUploadItems = [];
    this.attachmentsData= [];
    this.uploadedItems = [];
    this.approvedFlag=0;

    this.postApiData = {
      access: 'workorder-page',
      pageAccess: 'workorder-page',
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      countryId: this.countryId,
      userId: this.userId,
      contentType: this.contentType,
      displayOrder: this.displayOrder,
      roPushApiFlag: false,
      shopId: 0,
      assignTech: [],
      uploadedItems: [],
      mediaUploadItems: [],
      mediaAttachments: [],
      attachments: [],
      attachmentItems: [],
      updatedAttachments: [],
      deletedFileIds: [],
      removeFileIds: []
    };
    this.postApiData['uploadedItems'] = this.uploadedItems;
    this.postApiData['attachments'] = this.uploadedItems;
    this.postUpload = false;
    setTimeout(() => {
      this.postUpload = true;
    }, 100);

    this.roPageData = {
      access: "new",
      fromaccess: 'repairorder-list',
      contentType: ContentTypeValues.RepairOrder,
      make: '',
      model: '',
      id: '0'
    }

    this.roEstimationFlag = false;
    setTimeout(() => {
      this.roEstimationFlag = true;
    }, 10);


    let dataLen = this.workstreamItems.length;
    if(dataLen==1){
      this.workstreamId = [];
      this.workstreamSelection = [];
      this.workstreamSelection = this.workstreamItems;
      for (let cs of this.workstreamItems) {
        this.workstreamId.push(cs.id);
      }
      this.serviceForm.patchValue({workstream: this.workstreamSelection});
      this.getCategoryData();
    }

    if(this.defaultWorkstreamFlag) {
      if(!this.endUser) {
        let defaultWsId = '';
        for (let cs of this.workstreamItems) {
          if(parseInt(cs.defaultvalue) > 0) { 
            defaultWsId = cs.defaultvalue;
          }      
        }
        if(this.workstreamItems.length > 0) {
          let wsId = (defaultWsId == '') ? this.workstreamItems[0].id : defaultWsId;
          this.workstreamId.push(wsId);
        }        
      }
      setTimeout(() => {
        this.getCategoryData();  
      }, 100);
      
    }

    setTimeout(() => {
      this.invisibleFlag = false;
    }, 100);

  }

  editRepairOrderDetail(){
    let objData = {
      id: this.workOrderId,
      domainId: this.domainId,
      type: 7
    };
    this.commonApi.getRODetailSolr(objData).subscribe(response => {
    //this.repairOrderApi.getWorkOrderList(formData).subscribe(response => {
      console.log("getRODetailSolr: ", response);
      let ROViewData = response.items[0];
      this.ROViewData = ROViewData;
      this.setupRoDetail(ROViewData);
      this.getWorkOrderTypes(); 
      this.removeReportFlag = (ROViewData.adasReportIdInt > 0) ? true : false;     
      this.ROViewData['threadIdInt'] = ROViewData.threadIdInt;
      this.ROViewData['dispatchIdInt'] = ROViewData.dispatchIdInt;
      this.ROViewData['technicanInfoJsonArr'] = (ROViewData.technicanInfoJsonArr && ROViewData.technicanInfoJsonArr != undefined) ? ROViewData.technicanInfoJsonArr : [];
      this.ROViewData['assignTechnicanInfoJsonArr'] = (ROViewData.assignTechnicanInfoJsonArr && ROViewData.assignTechnicanInfoJsonArr != undefined) ? ROViewData.assignTechnicanInfoJsonArr : [];
      this.ROViewData['assignTechnicianIdInfoStr'] = (ROViewData.assignTechnicianIdInfoStr && ROViewData.assignTechnicianIdInfoStr != undefined) ? ROViewData.assignTechnicianIdInfoStr : "0";
      this.ROViewData['assignTechnicianIdStr'] = (ROViewData.assignTechnicianIdStr && ROViewData.assignTechnicianIdStr != undefined) ? ROViewData.assignTechnicianIdStr : [];
      this.ROViewData['jobItemsIntArr'] = (ROViewData.jobItemsIntArr && ROViewData.jobItemsIntArr != undefined) ? ROViewData.jobItemsIntArr : [];
      this.ROViewData['jobItemsInfoJsonArr'] = (ROViewData.jobItemsInfoJsonArr && ROViewData.jobItemsInfoJsonArr != undefined) ? ROViewData.jobItemsInfoJsonArr : [];
      this.ROViewData['insuranceCompanyIdInt'] = (ROViewData.insuranceCompanyIdInt && ROViewData.insuranceCompanyIdInt != undefined) ? ROViewData.insuranceCompanyIdInt : 0;
      this.ROViewData['estimateCreatedOnStr'] = (ROViewData.estimateCreatedOnStr && ROViewData.estimateCreatedOnStr != undefined) ? ROViewData.estimateCreatedOnStr : '';
      this.ROViewData['orderDateStr'] = (ROViewData.orderDateStr && ROViewData.orderDateStr != undefined) ? ROViewData.orderDateStr : '';
      this.ROViewData['verificationDateStr'] = (ROViewData.verificationDateStr && ROViewData.verificationDateStr != undefined) ? ROViewData.verificationDateStr : '';
      this.shopId = ROViewData.shopIdInt;
      this.approvedFlag=ROViewData.approvedInt;
      this.editThreadId=ROViewData.threadIdInt;
      this.isEstimateApprove = ROViewData.isEstimationApprovedInt;
      this.fromPublic = ROViewData.fromPublicInt;
      this.workstreamSelection = [];
      this.workstreamId = [];
      let itemwsid = ROViewData.workstreamsIdStrArr && ROViewData.workstreamsIdStrArr != '' && ROViewData.workstreamsIdStrArr != undefined ? (ROViewData.workstreamsIdStrArr) : '';
      let itemwsidArr = [];
      itemwsidArr = (itemwsid);
      this.workstreamId = [];
      this.workstreamId = itemwsidArr;
      let currentDtcJsonArr = ROViewData.currentDtcJsonArr && ROViewData.currentDtcJsonArr != '' && ROViewData.currentDtcJsonArr != undefined ? (ROViewData.currentDtcJsonArr) : '';
      this.errorCodes = [];
      this.errorCodesNames = [];
      this.trouble_code=[];
      let idArr=[], nameArr=[], codeArr=[];
      if(currentDtcJsonArr){
        currentDtcJsonArr.forEach((item, i) => {
          let dtcIndex = this.errorCodes.findIndex(option => option == item.id);
          if(dtcIndex < 0) {
            idArr = item.id;
            nameArr = item.description && item.description !=undefined ? item.description:'';
            codeArr = item.code && item.code !=undefined ? item.code : '';
            this.errorCodes.push(idArr);
            this.errorCodesNames.push(codeArr+" - "+nameArr);
            this.trouble_code.push(codeArr+"##"+nameArr);
          }
        });
      }
      if(!this.diagnationDomain) {
        this.invoiceData = ROViewData.invoiceDataJsonArr != undefined ? ROViewData.invoiceDataJsonArr : '';
        let invoiceCount = (this.invoiceData != '') ? 1 : 0;
        this.isManualInvoice = (ROViewData.isManualInvoiceInt && ROViewData.isManualInvoiceInt != undefined) ? ROViewData.isManualEstInt : 0;
        if(this.invoiceData != '') {
          this.estimateInfo[0]['invoiceData'] = this.invoiceData;          
        }
        this.estimateInfo[0]['isManualInvoice'] = this.isManualInvoice;
        if(this.dmaDomain) {
          this.setupDmaSidebar();
        } else {
          this.sidebarList.forEach(item => {
            let displayFlag = ((this.workOrderId == 0 && item.id > 1) || (invoiceCount == 0 && item.id == 4)) ? false : true;
            displayFlag = (item.id == 6) ? this.calproAccess : displayFlag;
            item.display = displayFlag;
          });
        }
      }
      if(this.gbbDomain){
        this.inventorySource = ROViewData.inventorySourceInt || 1;

        if(this.inventorySource == 2) {
          this.customerInventory = 1
        } else {
          this.customerInventory = 0;
        }
        if(this.inventorySource == 1) {
          this.fetchWarehouseQtyData((this.ROViewData as any)?.partNumberStr)
        }
        if((this.ROViewData as any)?.assignTechnicanInfoJsonArr?.length > 0) {
          this.allocatedCount = 1;
        }
        if((this.ROViewData as any)?.partsTagsJsonArr?.length > 0) {
          const specialData = (this.ROViewData as any)?.partsTagsJsonArr?.find((item: any) => {
            return item?.name == 'Specialty';
          }) || {}
          this.isSpecialPart = specialData?.specialTag == 1 ? true : false;
        }
      }
      let timeout = (this.diagnationDomain) ? 750 : 750;
      //timeout = (this.domainId == 411) ? 500 : timeout;
      let shopId = ROViewData.shopIdInt;
      this.getShopList(shopId);
      if(!this.diagnationDomain) {
        this.getPaymentMethods();
        this.threadCategory = ROViewData.threadCategoryInt;
        switch(this.threadCategory) {
          case 2:
          case 10:
            //timeout = 2500;
            this.getToolType(this.threadCategory, true);
          break;
        }
      }
      if(ROViewData.disablePreApproveInt == 1) {
        this.approveOptions.forEach(aitem => {
          aitem.disabled = true;
        });
      }

      setTimeout(() => {
        this.editServiceData(ROViewData);
        if(this.roViewEstActionFlag) {
          setTimeout(() => {
            this.roViewEstActionFlag = false;
            this.roFlag = false;
            this.submitModal = false;
            this.viewEstimate();  
          }, 1000);          
        }
      }, timeout);
    });
  }

  roestimationAction(data){
    this.escalationMatrix_array = data;
    console.log(this.escalationMatrix_array);
    this.jobcodeArr = [];
    if(this.escalationMatrix_array && this.escalationMatrix_array['estimationArray']?.length>0)
    {
      for (let wsd in this.escalationMatrix_array['estimationArray'])
      {
        this.jobcodeArr.push(this.escalationMatrix_array['estimationArray'][wsd].jobcode);
      }
    }
   console.log("roestimationAction: ", this.escalationMatrix_array);
   console.log("roestimationAction", this.jobcodeArr)
  }

  // Set Screen Height
  setScreenHeight() {
    this.bodyHeight = window.innerHeight;
    this.innerHeight = (this.bodyHeight - 87 );
  }

  closeModal() {
    let data = {
      action: 'close',
      closeFlag: true,
      roAction: ''
    };
    this.ROManageService.emit(data);
  }

  updateSolr(action, actionType, dataId, postId = '') {
    let env:any = (environment.production) ? 1 : 0;
    let apiDatasocial = new FormData();
    apiDatasocial.append('apiKey', Constant.ApiKey);
    apiDatasocial.append('domainId', this.domainId);
    apiDatasocial.append('userId', this.userId);
    apiDatasocial.append('action', action);
    apiDatasocial.append('actionType', actionType);
    apiDatasocial.append('environment', env);
    switch (actionType) {
      case 1:
        apiDatasocial.append('threadId', dataId);
        if(postId != '') {
          apiDatasocial.append('postId', postId);
        }
        break;
      case 7:
        apiDatasocial.append('workOrderId', this.workOrderId);
        break;
      case 16:
        apiDatasocial.append('threadId', dataId);
        break;
    }
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });
  }

  sendPushMobile(threadId, teamId, tsuid) {
    let tindex = this.technicians.findIndex(option => option.userId == tsuid);
    let tsuname = this.technicians[tindex]['userName'];
    let techFlag = (this.servicetype == 1) ? true : false;
    tsuid = (techFlag) ? tsuid : 0;
    tsuname = (techFlag) ? tsuname : '';
    let fromTechSupport = (techFlag) ? "1" : "0";
    let fromRo: any = 1;
    let apiDataPush = new FormData();
    apiDataPush.append('apiKey', Constant.ApiKey);
    apiDataPush.append('domainId', this.domainId);
    apiDataPush.append('countryId', this.countryId);
    apiDataPush.append('userId', this.userId);
    apiDataPush.append("techSupportUserId",tsuid);
    apiDataPush.append('fromRo', fromRo);
    if(tsuname != ''){
      apiDataPush.append("techSupportUserName",tsuname);
    }
    let threadIdData = [threadId];
    let thradIdDataJSON = JSON.stringify(threadIdData);
    apiDataPush.append("teamId", teamId);
    apiDataPush.append("fromTechSupport", fromTechSupport);
    apiDataPush.append("threadId", thradIdDataJSON);
    this.threadPostService.sendPushtoMobileAPI(apiDataPush).subscribe((response) => { console.log(response); });
  }

  pushApi(data) {
    console.log(data)
    console.log(Array.isArray(data.techId))
    let fcmToken = localStorage.getItem('fcm_token');
    let techId = (Array.isArray(data.techId)) ? data.techId : JSON.parse(data.techId);
    let tindex = -1;
    let tsuname = [];
    if(Array.isArray(techId) && techId?.length > 0) {
      tindex = this.technicians.findIndex(option => parseInt(option.userId) == parseInt(techId[0]));
      tsuname = [this.technicians[tindex]['userName']];
    }
    let pushData = {
      apikey: Constant.ApiKey,
      domainId: localStorage.getItem('domainId'),
      userId: this.userId,
      deviceToken: fcmToken,
      action: data.action,
      customerName: data.customerName,
      serviceId: data.serviceId,
      prevTechnicianId: JSON.stringify(data.prevTechId),
      technicianId: JSON.stringify(data.techId),
      statusId: data.statusId,
      prevStatusId: 0,
      technicianName: JSON.stringify(tsuname),
      prevTechnicianName: JSON.stringify(data.prevTechName)
    }
    console.log(pushData)
    this.LandingpagewidgetsAPI.cbtV3SendPush(pushData).subscribe((response) => {
      console.log(response)
    });
  }

  calproPushApi(reportId) {
    let fcmToken = localStorage.getItem('fcm_token');
    let pushFormData = new FormData();
    pushFormData.append('apiKey', Constant.ApiKey);
    pushFormData.append('domainId', this.domainId);
    pushFormData.append('userId', this.userId);
    pushFormData.append('deviceToken', fcmToken);
    pushFormData.append('reportId', reportId);
    this.LandingpagewidgetsAPI.cbtV3SendCalproPush(pushFormData).subscribe((response) => {
      console.log(response)
    });
  }

  roPushApi(roId, shopId, threadId, postId, assignTech) {
    let fcmToken = localStorage.getItem('fcm_token');
    let pushFormData = new FormData();
    pushFormData.append('apiKey', Constant.ApiKey);
    pushFormData.append('domainId', this.domainId);
    pushFormData.append('userId', this.userId);
    pushFormData.append('deviceToken', fcmToken);
    pushFormData.append('roId', roId);
    pushFormData.append('threadId', threadId);
    pushFormData.append('postId', postId);
    pushFormData.append('shopId', shopId);
    pushFormData.append('workstreamsList', JSON.stringify(assignTech));
    //let endUser: any = (this.endUser) ? 1 : 0;
    //pushFormData.append('endUser', endUser);

    this.LandingpagewidgetsAPI.cbtV3SendROPush(pushFormData).subscribe((response) => {
      console.log(response)
    });
  }

  fieldChange(field, event) {
    console.log(field, event, this.serviceForm)
    switch(field) {
      case 'serviceType':
        let typeId = event.value;
        if(!this.editRO && !this.diagnationDomain) {
          this.assignTechDisable = false;
        }
        if(typeId == 1) {
          this.supportTypeOptions.forEach(option => {
            option.display = true;
          });
        } else {
          this.supportTypeOptions.forEach(option => {
            option.display = (option.id == 1 || option.id == 7) ? true : false;
            option.isSelected = (option.id == 1) ? true : false;
            if(option.id == 1) {
              this.supportTypeChange('trigger', option);
            }
          });
        }
        break;
      case 'make':
        this.makeValid = true;
        break;
      case 'model':
        this.modelValid = true;
        break;
      case 'year':
        this.yearValid = true;
        break;
      case 'serialNumber':
        this.serialNumberValid = true;
        break;
      case 'toolType':
        this.toolTypeValid = true;
        this.getToolName(event.originalEvent.target.innerText);
        break;
      case 'toolName':
        this.toolNameValid = true;
        if(this.threadCategory == 10) {
          let toolNameVal = event.value;
          if(toolNameVal != 'new') {
            let tni = this.toolNameOptions.findIndex(option => option.name == toolNameVal);
            if(tni >= 0) {
              let serialNumber = this.toolNameOptions[tni].serialNumber;
              this.serviceForm.patchValue({serialNumber});
            }
          }
        }
        break;
      case 'toolNameCheck':
        let ctoolNameVal = event.target.value;
        console.log(ctoolNameVal);
        let ctni = this.toolNameOptions.findIndex(option => option.name.toLowerCase() == ctoolNameVal.toLowerCase());
        this.toolNameExist = (ctni >= 0) ? true : false;
        this.existError = (this.toolNameExist) ? 'Tool name alread exists' : '';
        break;
      case 'scanVersion':
        this.scanVersionValid = true;
        break;
      case 'paymentMehod':
        let pid = event.target.id;
        this.paymentMethods.forEach(pitem => {
          pitem.selected = (pitem.name == pid) ? event.target.checked : false;
        });
        break;
      case 'preapprove':
        console.log(event)
        let approveVal = event.target.id;
        this.assignTechDisable = (approveVal == 'Yes') ? false : true;
        if(approveVal == 'No') {
          this.serviceForm.value.assignTechnicianId = '';
        }
        this.ROViewData['isPreApprovedInt'] = (approveVal == 'Yes') ? 1 : 0;
        this.RODetailData.isPreApprovedInt = (approveVal == 'Yes') ? 1 : 0;
        break;
      case 'sameContact':
        if(this.contactDisable) {
          return false;
        } else {
          this.selectedBillingContact = this.selectedContact;
          this.selectedBillingContactId = this.selectedContactId;
          this.serviceForm.patchValue({billingContact: this.selectedBillingContactId});
        }
        break;
      case 'unit':
        this.unit = event.value;
        break;
      case 'sameBusinessEmail':
        let sameBusinessEmailChecked = event.target.checked;
        this.isSameBusinessEmail = (sameBusinessEmailChecked) ? 1 : 0;
        if(sameBusinessEmailChecked) {
          let userEmail = this.serviceShopForm.value.email;
          this.serviceShopForm.patchValue({userEmail});
        }
        break;
      case 'sameContactPhone':
        let sameContactChecked = event.target.checked;
        this.isSameContactPhone = (sameContactChecked) ? 1 : 0;
        if(sameContactChecked) {
          this.setupSamePhone('userPhone','contact');
        }
        break;
      case 'isCustomerEmailInvite':
        let isCustomerEmailInviteChecked = event.target.checked;
        this.isCustomerEmailInvite = (isCustomerEmailInviteChecked) ? 1 : 0;
        this.serviceShopForm.patchValue({userEmailCheck: this.isCustomerEmailInvite});
        let cemailInviteAction = (isCustomerEmailInviteChecked) ? 'init' : 'remove';
        this.updateValidators(this.serviceShopForm, 'userEmail', cemailInviteAction);
        break;
      case 'isContactEmailInvite':
        let isContactEmailInviteChecked = event.target.checked;
        this.isContactEmailInvite = (isContactEmailInviteChecked) ? 1 : 0;
        this.serviceContactForm.patchValue({userEmailCheck: this.isContactEmailInvite});
        let contactEmailInviteAction = (isContactEmailInviteChecked) ? 'init' : 'remove';
        let access = this.getContactAccess();
        this.updateValidators(this.serviceContactForm, 'email', contactEmailInviteAction, access);
        break;  
      case 'appointmentOption':
        let aptName = event.target.id;
        let aptIndex = this.appointmentOptions.findIndex(option => option.name == aptName);
        if(aptIndex >= 0) {
          this.selectedAppointmentOption = aptName;
          this.selectedAppointmentOptionId = this.appointmentOptions[aptIndex].id;
          let isAsap = (this.selectedAppointmentOptionId == 2) ? 1 : 0;
          let isFlexible = (this.selectedAppointmentOptionId == 3) ? 1 : 0;
          this.serviceForm.patchValue({isAsap, isFlexible});
        }
        break;
      case 'inventory-source':
        console.log("event", event.value);
        this.inventorySource = event.value;
        if(this.inventorySource == 2) {
          this.customerInventory = 1;
        } else {
          this.customerInventory = 0;
        }
        break;
      case 'insuranceCompanyId':
        this.insuranceCompanyId = event.value;
        break;
    }
  }

  setupSamePhone(currentField, existingField) {
    let access = 'userPhone';
    switch(currentField) {
      case 'userPhone':
        this.phoneNumberData = {
          countryCode: this.icountryCode,
          phoneNumber: this.iphoneNumber,
          country: this.icountryName,
          dialCode: this.idialCode,
          access
        }
        this.userPhoneNumberData = this.phoneNumberData;
        this.serviceShopForm.patchValue({
          userCountryName: this.icountryName,
          userCountryCode: this.icountryCode,
          userDialCode: this.idialCode,
          userPhone: this.iphoneNumber
        });
        let phoneValue = this.businessPhoneNumberData.phoneVal;
        console.log(this.businessPhoneNumberData)
        this.userCountryPhoneRef.ngxInputControl = access;
        this.userCountryPhoneRef.phoneNumberData = this.userPhoneNumberData;
        this.userCountryPhoneRef.initPhone();
        setTimeout(() => {
          this.userPhoneNumberValid = false;
        }, 1000);
        break;
    }
  }

  stripeCardCallBack(data) {
    this.stripeCardPageRef = data;
  }

  iscanSubmit() {
    let iscanRef = this.iscanPageRef;
    iscanRef.saveService();
  }

  iscanCallback(data) {
    console.log(data);
    let action = data.emitAction;
    let values = data.iscanFormData;
    switch(action) {
      case 'submit':
        this.postUploadActionTrue = data.postUploadActionTrue;
        this.postUpload = data.postUpload;
        this.uploadedItems = data.uploadedItems;
        this.commentUploadedItemsFlag = data.commentUploadedItemsFlag;
        this.commentUploadedItemsLength = data.commentUploadedItemsLength;
        this.mediaUploadItems = data.mediaUploadItems;
        this.mediaAttachments = data.mediaAttachments;
        this.mediaAttachmentsIds = data.mediaAttachmentsIds;
        this.attachmentItems = data.attachmentItems;
        this.problemDescFlag = false;
        for (let ws of this.Shops) {
          if(ws.id == this.shopId){
            this.businessName = ws.name;
            this.selectedShop = ws;
          }
        }
        this.setupShopAddress(this.selectedShop,true,'edit',values);
        break;
    }
  }

  supportTypeChange(action, item) {
    let id = item.id;
    this.threadCategory = id;
    let threadCategory = (this.dmaDomain && id == 10) ? 1 : this.threadCategory;
    item.isSelected = true;
    let formValue = this.serviceForm.value;
    console.log(action, this.threadCategory)
    switch(threadCategory) {
      case 1:
        this.threadCategoryTile = 'Vehicle';
        this.threadCategoryImage = `${this.imagePath}/repair-order/vehicle-info.svg`;
        if(action == 'change') {
          let makeVal = formValue.make;
          this.makeValid = (makeVal == '' && this.diagnationDomain) ? false : true;
          let modelVal = formValue.model;
          this.modelValid = (modelVal == '' && this.diagnationDomain) ? false : true;
          let yearVal = formValue.make;
          this.yearValid = (yearVal == '' && this.diagnationDomain) ? false : true;
          this.serialNumberValid = true;
          this.toolTypeValid = true;
          this.toolNameValid = true;
          this.scanVersionValid = true;
          if(this.makeList.length == 0) {
            this.getProductMakeList();
          }
        } else if(action != 'trigger-edit')  {
          this.makeList = [];
          this.Models = [];
          this.serviceForm.value.make = "";
          this.serviceForm.value.model = "";
          this.serviceForm.value.year = "";
          this.getProductMakeList();
        }
        break;
      case 2:
      case 10:
        this.threadCategoryTile = (this.threadCategory == 2) ? 'Scan Tool' : 'Part';
        let catgImg = (this.threadCategory == 2) ? 'common/scan-tool-icon.svg' : 'thread/tc-part-normal.svg';
        this.threadCategoryImage = `${this.imagePath}/${catgImg}`;
        if(action == 'change') {
          this.getToolType(this.threadCategory);
          this.makeValid = true;
          this.modelValid = true;
          this.yearValid = true;
          this.serialNumberReadOnly = (this.threadCategory == 10 && !this.dmaDomain) ? true : false;
          let serialNumberVal = formValue.serialNumber;
          this.serialNumberValid = true;
          let toolTypeVal = formValue.toolType;
          this.toolTypeValid = true;
          let toolNameVal = formValue.toolName;
          this.toolNameValid = true;
          let scanVersionVal = formValue.scanVersion;
          this.scanVersionValid = true;
        }
        if(action == 'trigger' && this.dmaDomain && threadCategory == 10) {
           this.makeList = [];
            this.Models = [];
            this.serviceForm.value.make = "";
            this.serviceForm.value.model = "";
            this.serviceForm.value.year = "";
            this.getProductMakeList();
        }
        break;
      case 7:
        if(action == 'change') {
          this.makeValid = true;
          this.modelValid = true;
          this.yearValid = true;
          this.serialNumberValid = true;
          this.toolTypeValid = true;
          this.toolNameValid = true;
          this.scanVersionValid = true;
        }
        this.threadCategoryTile = 'General';
        this.threadCategoryImage = `${this.imagePath}/thread/tc-general-normal.svg`;
        break;
    }
    this.supportTypeOptions.forEach(option => {
      if(option.id != id) {
        option.isSelected = false;
      }
    });
  }

  getToolType(threadCategoryId, edit = false) {
    let userId: any = this.userId;
    let wsList: any = this.workstreamId;
    let emptyVal = '';
    this.toolTypeDisable = true;
    this.toolTypeLoading = true;
    this.toolType = emptyVal;
    this.toolName = emptyVal;
    this.toolTypeOptions = [];
    this.toolNameOptions = [];
    this.serviceForm.patchValue({serialNumber: emptyVal, toolType: this.toolType, toolName: this.toolName, scanVersion: emptyVal});
    let threadCategory:any = [];
    threadCategory.push(threadCategoryId);
    let apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('userId', userId);
    apiFormData.append('workstreamsList', JSON.stringify(wsList))
    apiFormData.append('threadCategoryId', JSON.stringify(threadCategory));
    apiFormData.append('access', 'New Thread');
    this.LandingpagewidgetsAPI.getProductMakeListsAPI(apiFormData).subscribe(
      (response) => {
        if (response.status == 'Success') {
          this.toolTypeDisable = false;
          this.toolTypeLoading = false;
          let resultData = response.modelData;
          resultData.forEach(item => {
            let toolType = {id: item.id, name: item.makeName};
            this.toolTypeOptions.push(toolType);
          });
          if(edit) {
            let toolType = (this.ROViewData['make'] && this.ROViewData['make'] != undefined) ? this.ROViewData['make'] : '';
            this.getToolName(toolType);
          }
        }
      }
    );
  }

  getToolName(makeName) {
    this.toolNameDisable = true;
    this.toolNameLoading = true;
    this.toolNameOptions = [];
    this.toolName = '';
    if(this.threadCategory == 10) {
      this.serviceForm.patchValue({serialNumber: ''});
    }
    let userId: any = 0;
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: userId,
      displayOrder: 0,
      type: 1,
      makeName,
      offset: '',
      limit: '',
    };
    this.LandingpagewidgetsAPI.getMakeModelsList(apiInfo).subscribe(
      (response) => {
        this.toolNameDisable = false;
        this.toolNameLoading = false;
        if (response.status == 'Success') {
          let resultData = response.modelData;
          resultData.forEach(item => {
            let modelItems = item.modelItems[0];
            let serialNumber = (this.threadCategory == 10) ? item.PartNumber : ''
            let toolName = {id: parseInt(modelItems.id), name: modelItems.name, serialNumber};
            this.toolNameOptions.push(toolName);
          });
          if(this.threadCategory == 10) {
            let newData = {id: 0, name: 'New', serialNumber: ''};
            this.toolNameOptions.unshift(newData);
            console.log(this.toolNameOptions)
          }
        }
      }
    );
  }

  getCategoryData(sitem:any = '') {
    this.supportTypeOptions = [];
    let userId = 0;
    let wsList: any = (this.aetoolsDomain) ? ["770"] : this.workstreamId;
    wsList = (this.lmvDomain && !this.endUser) ? ["788"] : wsList;
    let apiUrl = `${this.baseApiUrl}${Constant.getThreadCategoryData}`;
    this.threadCategory = (sitem == 1) ? sitem.threadCategoryInt : this.threadCategory;
    const apiData: any = new FormData();
    apiData.append("apiKey", Constant.ApiKey);
    apiData.append("domainId", this.domainId);
    apiData.append("countryId", '');
    apiData.append("userId", userId);
    apiData.append('workstreamsList', JSON.stringify(wsList));
    this.commonApi.apiCall(apiUrl, apiData).subscribe((response) => {
      console.log(response)
      let items = response.items;
      items.forEach((item, index) => {
        let id = parseInt(item.id);
        let name = item.name;
        let imagClass = item.imageClass;
        let isSelected = (id == 1) ? true : false;
        let disabled = (sitem != '' && sitem.disablePreApproveInt == 1) ? true : false;
        disabled = this.threadCategory == 7 ? false : disabled;
        let display = true;
        let sindex = this.supportTypeOptions.findIndex(option => option.id == id);
        if(sindex < 0) {
          this.supportTypeOptions.push({id, name, class:imagClass, isSelected, disabled, display});
        }
        if(!this.diagnationDomain && this.workOrderType == "new" && this.workstreamId.length == 1 && index == 0){
          this.threadCategory = id;
        }
      });
      console.log(this.servicetype, this.supportTypeOptions, this.threadCategory)
      if(this.servicetype >= 0 && this.supportTypeOptions.length > 0) {
        let servicetype = (this.servicetype == 0) ? 1 : this.servicetype;
        this.supportTypeOptions.forEach(option => {
          let optionId = parseInt(option.id);
          if(servicetype == 1) {
            option.display = true;
            /* if(this.dmaDomain && this.threadCategory == 10) {
              option.isSelected = true;  
            } */
          } else {
            option.display = (optionId == 1 || optionId == 7) ? true : false;
            option.isSelected = (optionId == 1) ? true : false;
          }          
          if(optionId == 1 || (this.dmaDomain && optionId == 10)) {
            if(this.workstreamId.length > 0) {
              this.supportTypeChange('trigger', option);
            }
          }
        });
      }
    }, (error: any) => {

    })
  }

  closeRequire(event) {
    this.requiredFlag = false;
    this.requiredFields = [];
  }

  updateBulkSolr(dataId) {
    let apiDatasocial = {
      type: SolrContentTypeValues.repairOrder,
      ids: dataId
    }
    console.log(apiDatasocial)
    this.LandingpagewidgetsAPI.manageSolrBulkIndex(apiDatasocial).subscribe((response: any) => { });
  }

  onChangeSelection(type){
    let filteredItems=[];
    let filteredLists=[];
    let inputData = {};
    let apiData = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      countryId: this.countryId,
      userId: this.userId,
      roleId: this.roleId,
      limit: 20,
      offset: 0,
    };
    let title =  '';
    let access = '';
    let accessAction: boolean;
    let emptyStrArr = [];
    let filteredROPartDesc = [];

    let configObj: NgbModalConfig = {
      ...this.config,
      size: 'lg'
    }
    if(type == 'jobItem' && this.callProFlag){
       configObj.size = 'xl'
    }

    switch(type){
      case 'ro-parts':
        configObj['size'] = 'xl';
        title = "Select Parts";
        access = "roParts";
        console.log(this.Shops)
        accessAction = false;
        filteredItems = [this.partBatteryTypeStr];
        filteredLists = [this.partNumberStr];
        filteredROPartDesc = [this.partDescriptionStr];
        console.log(filteredItems, filteredLists);
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: "",
          workstreamId: this.workstreamId,
          pageAccess: 'thread',
          field: 'roParts',
          selectionType: "single",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          filteredROPartDesc: filteredROPartDesc,
          apiData: apiData,
        };
      break;
      case 'ro-tools':
        configObj['size'] = 'xl';
        title = "Select Tools";
        access = "roTools";
        console.log(this.Shops)
        accessAction = false;
        filteredItems = [this.partBatteryTypeStr];
        filteredLists = [this.partNumberStr];
        filteredROPartDesc = [this.partDescriptionStr];
        console.log(filteredItems, filteredLists);
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: "",
          workstreamId: this.workstreamId,
          pageAccess: 'thread',
          field: 'roTools',
          selectionType: "single",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          filteredROPartDesc: filteredROPartDesc,
          apiData: apiData,
        };
      break;
      case 'ro-carrier':
        this.config['size'] = 'lg';
        title = "Select Carrier";
        access = "roCarrier";
        console.log(this.Shops)
        accessAction = false;
        filteredItems = [this.partBatteryTypeStr];
        filteredLists = [this.partNumberStr];
        filteredROPartDesc = [this.partDescriptionStr];
        console.log(filteredItems, filteredLists);
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: "",
          workstreamId: this.workstreamId,
          pageAccess: 'thread',
          field: 'roParts',
          selectionType: "single",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          filteredROPartDesc: filteredROPartDesc,
          apiData: apiData,
        };
         case 'ro-status':
        this.config['size'] = 'lg';
        title = "Select Status";
        access = "roStatus";
        console.log(this.Shops)
        accessAction = false;
        filteredItems = [this.partBatteryTypeStr];
        filteredLists = [this.partNumberStr];
        filteredROPartDesc = [this.partDescriptionStr];
        console.log(filteredItems, filteredLists);
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: "",
          workstreamId: this.workstreamId,
          pageAccess: 'thread',
          field: 'roParts',
          selectionType: "single",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          filteredROPartDesc: filteredROPartDesc,
          apiData: apiData,
        };
      case 'ro-part-number':
        title = "Item Number";
        access = "roPartNumber";
        console.log(this.Shops)
        accessAction = false;
        filteredItems = [this.partBatteryTypeStr];
        filteredLists = [this.partNumberStr];
        filteredROPartDesc = [this.partDescriptionStr];
        console.log(filteredItems, filteredLists);
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: "",
          workstreamId: this.workstreamId,
          pageAccess: 'thread',
          field: 'roPartNumber',
          selectionType: "single",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          filteredROPartDesc: filteredROPartDesc,
          apiData: apiData,
        };
        break;
      case 'ro-qty-available':
        title = "Available Qty in Warehouse - " + this.partNumberStr;
        access = "roQtyAvailable";
        accessAction = false;
        filteredItems = [this.partBatteryTypeStr];
        filteredLists = [this.partNumberStr];
        filteredROPartDesc = [this.partDescriptionStr];
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: "",
          workstreamId: this.workstreamId,
          pageAccess: 'thread',
          field: 'roQtyAvailable',
          selectionType: "single",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          filteredROPartDesc: filteredROPartDesc,
          partNumber: this.partNumberStr,
          apiData: apiData, 
        };
        configObj = {
          ...this.config,
          size: 'lg'
        }
        break;
      case 'customer':
        this.config['size'] = 'max-width-800';
        let businessCount:any = localStorage.getItem('businessCount');
        let shoplistArr: any = localStorage.getItem('shoplistArr');
        if(this.endUser && businessCount < 2) {
          return false;
        }
        title = "Customer";
        access = "customerListRO";
        console.log(this.Shops)
        accessAction = false;
        filteredItems = (this.shopId > 0) ? [this.Shops[0].id] : filteredItems;
        filteredLists = (this.shopId > 0) ? [this.Shops[0].showval] : filteredLists;
        console.log(filteredItems, filteredLists)
        apiData['shopArr'] = (this.endUser && businessCount > 1) ? shoplistArr : JSON.stringify(emptyStrArr);
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: "",
          pageAccess: 'thread',
          field: 'customerListRO',
          selectionType: "single",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          apiData: apiData,
        };
        break;
      case 'error-code':
        title = "DTCs";
        access = "New Thread Error Codes";
        accessAction = true;
        inputData = {
          baseApiUrl: this.collabticApi,
          apiUrl: this.collabticApi+"/"+Constant.filterErrorCodeApiUrl,
          pageAccess: 'thread',
          field: 'errorCode',
          selectionType: "multiple",
          actionApiName: "",
          actionQueryValues: "",
          title: title,
          filteredItems: this.errorCodes,
          filteredLists: this.errorCodesNames,
        };
        break;
      case 'jobItem':
        this.config['size'] = 'max-width-800';
        title = "Job List";
        access = "jobListRO";
        console.log(this.selectedJobItemIds, this.selectedJobItems)
        accessAction = true;
        filteredItems = this.selectedJobItemIds;
        filteredLists = this.selectedJobItems;
        console.log(filteredItems, filteredLists)
        apiData['teamId'] = this.teamId;
        inputData = {
          baseApiUrl: this.collabticApi,
          baseV3ApiUrl: this.baseV3ApiUrl,
          apiUrl: this.baseV3ApiUrl,
          pageAccess: 'thread',
          newJobPopup: true,
          field: access,
          selectionType: "multiple",
          actionApiName: "support-tickets/managejobtype",
          actionQueryValues: "",
          title: title,
          filteredItems: filteredItems,
          filteredLists: filteredLists,
          apiData: apiData,
        };
        break;
    }
    let ht = this.innerHeight + 100;
    document.body.classList.add("manage-popup-new");
    const modalRef = this.modalService.open(ManageListComponent, configObj);
    modalRef.componentInstance.accessAction = accessAction;
    modalRef.componentInstance.apiData = apiData;
    modalRef.componentInstance.height = ht;
    modalRef.componentInstance.access = access;
    modalRef.componentInstance.inputData = inputData;
    modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
      console.log("RO Manage selectedItems", receivedService);
      switch(type) {
        case 'ro-part-number':
          let partItems = receivedService;
          console.log(partItems);
          let partNumberStr = '';
          let partBatteryTypeStr ='';
          let partDescriptionStr ='';
          let partInventorySource = 1;
          if(partItems && partItems.length>0){
            for (let t in partItems) {
             partNumberStr = (partItems[t].name);
             partBatteryTypeStr = (partItems[t].id);
             partDescriptionStr = (partItems[t].desc);
             this.availableQty = (partItems[t]?.qtyInt || 0);
             this.isSpecialPart = (partItems[t]?.attr_tags?.includes("Specialty") ? true : false);
            }
          }
          this.partNumberStr = partNumberStr || '';
          this.partBatteryTypeStr = partBatteryTypeStr || '';
          this.partDescriptionStr = partDescriptionStr || '';
          this.inventorySource = partInventorySource || 1;
          this.dropdownInventorySource?.updateSelectedOption(partInventorySource || 1);

          this.fetchWarehouseQtyData(partNumberStr);

          this.cdr.detectChanges();
        break;        
        case 'error-code':
          let tagItems = receivedService;
          console.log(tagItems)
          let idArr = [];
          let idNameArr = [];
          let nameArr = [];
          let enameArr = [];
          if(tagItems && tagItems.length>0){
            for (let t in tagItems) {
              enameArr.push(tagItems[t].ename);
              nameArr.push(tagItems[t].name);
              idArr.push(tagItems[t].id);
              idNameArr.push({id:tagItems[t].id, name: tagItems[t].name});
            }
            if(type == 'error-code'){
              this.errorCodes = idArr;
              this.errorCodesNames = nameArr;
              this.trouble_code = enameArr;
            }
          }
          else{
            this.errorCodes = idArr;
            this.errorCodesNames = nameArr;
            this.trouble_code = enameArr;
          }
          break;
        case 'customer':
          if(receivedService.length > 0) {
            this.Shops = receivedService;
            let shop = this.Shops[0];
            console.log(shop)
            let timeZone = (shop.timeZone && shop.timeZone != undefined) ? shop.timeZone : '';
            if(timeZone != '') {
              this.timeZoneList.push({id: timeZone, name: timeZone});
              this.serviceForm.patchValue({appointmentTimeZone: timeZone});
            }
            this.businessCount = shop.businessCount;
            this.shopId = shop.id;
            console.log("Change shop id"+this.shopId)
            this.marketId = shop.marketId;
            this.marketName = shop.marketName
            this.shopChanged('change', '', this.shopId);
            this.selectedTechId = [];
            this.selectedTech = [];
            this.serviceForm.patchValue({serviceTech: this.selectedTechId});
            this.serviceForm.value.serviceTech = '';
            this.Technician = [];
            this.setupTimeZone('shop');
          }
          break;
        case 'jobItem':
          let selectedJobs = receivedService;
          console.log(selectedJobs)
          let jobItem = [];
          selectedJobs.forEach(item => {
            jobItem.push(item.id)
          });
          this.selectedJobItemIds = jobItem;
          this.selectedJobItems = selectedJobs;
          if(this.editRO) {
            let updateFlag = false;
            console.log(this.RODetailData)
            let estData = this.RODetailData.estimationData;
            if(estData == '') {
              estData = {estimationArray: [], estimationTotal: "0.00", wdestimationTotal: "0.00"};
            }
            console.log(estData)
            estData = (Array.isArray(estData)) ? estData[0] : estData;
            let estimateData:any = estData.estimationArray;
            console.log(estimateData)
            if(estimateData.length == 0) {
              estimateData = this.setupJobEstimateData();
              estData = estimateData;
              console.log(estimateData)
              setTimeout(() => {
                updateFlag = true;
              }, 100);
            } else {
              let estLen = estimateData?.length;
              let itemLength = this.selectedJobItems?.length;
              let responseFlag = false;
              this.selectedJobItems.forEach((item, index) => {
                let estIndex = estimateData.findIndex(option => parseInt(option.jobId) == parseInt(item.id));
                console.log(estimateData, this.selectedJobItemIds, estIndex)
                if(estIndex < 0) {
                  let id = estLen;
                  estData = this.setupEstimateItem(id, item);
                  let uploadContents = {uploadContents: []};
                  this.RODetailData.estJobUploadContentsJsonArr.push(uploadContents);
                  estLen++;
                }
                if(itemLength == index+1) {
                  responseFlag = true;  
                }
              });
              if(responseFlag) {
                console.log('in')
                let estArray = estData.estimationArray;
                console.log(estArray)
                let estArrItem = [];
                let removeIndex = [];
                let uploadContents = [];
                estArray.forEach((estItem, estIndex) => {
                  let jobIndex = this.selectedJobItems.findIndex(option => parseInt(option.id) == estItem.jobId);
                  console.log(jobIndex, estIndex)
                  if(jobIndex < 0) {
                    removeIndex.push(estIndex)
                  } else {
                    estArrItem.push(estArray[estIndex]);
                    uploadContents.push(this.RODetailData.estJobUploadContentsJsonArr[estIndex]);
                  }
                });
                this.RODetailData.estJobUploadContentsJsonArr = uploadContents;
                console.log(estArrItem, removeIndex)
                let emptyVal:any = 0;
                let estTotal:any = parseFloat(emptyVal);
                let wdestTotal:any = parseFloat(emptyVal);
                estArrItem.forEach(est => {
                  let jobTotal:any = (est.jobtotal && est.jobTotal != undefined) ? parseFloat(est.jobTotal) : parseFloat(emptyVal);
                  let jobWdTotal:any = parseFloat(emptyVal);
                  /* if(est.wdPrice && est.wdPrice != undefined) {
                    jobWdTotal = est.wdPrice;
                  } */
                  if(est.jobWdTotal && est.jobWdTotal != undefined) {
                    jobWdTotal = parseFloat(est.jobWdTotal);
                  }                  
                  estTotal += jobTotal;
                  wdestTotal += jobWdTotal;
                });
                console.log(estTotal, wdestTotal)
                estData.estimationTotal = (Math.abs(estTotal)).toFixed(2);
                estData.wdestimationTotal = (Math.abs(wdestTotal)).toFixed(2);
                estData.estimationArray = estArrItem;
                this.RODetailData.estimationData = estData;
                updateFlag = responseFlag;
              }
            } 
            setTimeout(() => {
              if(updateFlag) {
                console.log(this.RODetailData, estData)
                let estId = 0;
                let estInfo = (this.RODetailData.estimateInfoDataJsonArr && this.RODetailData.estimateInfoDataJsonArr != undefined) ? this.RODetailData.estimateInfoDataJsonArr : [];
                if(estInfo.length > 0) {
                  estId = this.RODetailData.estimateInfoDataJsonArr[0].estId;
                }
                let field = 'estimate';
                let fieldValue = JSON.stringify(estData);
                let isInvoice = 0;
                let isGenerateInvoice = false;
                let isFromRoForm = true;
                this.updateWorkOrder(field, fieldValue, estId, isInvoice, isGenerateInvoice, isFromRoForm);
              }  
            }, 150);  
          }
          break;
      }
    });
  }

  // Disable Tag Selection
  disableTagSelection(index) {
    this.errorCodes.splice(index, 1);
    this.errorCodesNames.splice(index, 1);
  }

  onEmailChange(field, value) {
    switch(field) {
      case 'email':
        if(!this.shf.email.errors) {
          this.checkBusinessEmail(value, 'shop');
        }
        break;
      case 'userEmail':
        if(value == '') {
          this.isCustomerEmailInvite = 0;
          this.serviceShopForm.patchValue({userEmailCheck: this.isCustomerEmailInvite});
          this.updateValidators(this.serviceShopForm, field, 'remove');
        }
        break;
      case 'contactEmail':
        if(value == '' && this.isContactEmailInvite == 0) {
          this.serviceContactForm.patchValue({userEmailCheck: this.isContactEmailInvite});
          let access = this.getContactAccess();
          this.updateValidators(this.serviceContactForm, 'email', 'remove', access);
        }
        break;    
    }    
  }

  // Check Business Email Exists
  checkBusinessEmail(val, access) {
    let roContactData = new FormData();
    roContactData.append('apikey', Constant.ApiKey);
    roContactData.append('domainId', this.domainId);
    roContactData.append('email', val);
    roContactData.append('access', access);
    if(this.checkBusinessEmailFlag){
      this.checkBusinessEmailFlag.unsubscribe();
      this.fetchContactData(roContactData);
    } else {
      this.fetchContactData(roContactData);
    }
  }

  fetchContactData(apiData) {
    this.checkBusinessEmailFlag = this.LandingpagewidgetsAPI.checkROContactExists(apiData).subscribe((response) => {
      let responseData = response.data;
      this.businessEmailExist = responseData.exist;
      this.businessEmailExistMessage = (this.businessEmailExist) ? responseData.message : '';
      if(!this.businessEmailExist) {
        let email = this.serviceShopForm.value.email.trim();
        let userEmail = this.serviceShopForm.value.userEmail.trim();
        if(this.isSameBusinessEmail > 0 && userEmail == '') {
          userEmail = email;
          this.serviceShopForm.patchValue({userEmail});
        }
      }
    });
  }

  fetchWarehouseQtyData(partNumber) {
    if(!partNumber || partNumber == '') {
      console.error('Part number is required to fetch Warehouse Qty Data');
      return;
    }
    const apiData: any = new FormData();
    apiData.append("apiKey", Constant.ApiKey);
    apiData.append("domainId", this.domainId);
    apiData.append("userId", this.userId);
    apiData.append("offset", '0');
    apiData.append("limit", '10');
    apiData.append("listing", '1');
    apiData.append("tab", '1');
    apiData.append("partNumber", partNumber);

   this.LandingpagewidgetsAPI.getInventoryPartsByWarehouse(apiData).subscribe(
      (response: any) => {
        console.log('getInventoryPartsByWarehouse data:', response);
        this.availableQty = response.availableQty || 0;
        // this.allocatedCount = response.allocatedCount || 0;
      },
      error => {
        console.error('getInventoryPartsByWarehouse Error:', error);
        this.availableQty =  0;
        // this.allocatedCount = 0;
      }
    )
  }

  userCountryPhoneCallback(data) {
    console.log(data)
    this.userCountryPhoneRef = data;
  }

  deleteUserAccunt(item)
  {

    let countryId = localStorage.getItem('countryId');
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('deletedUserId', item.id);
    apiFormData.append('countryId', countryId);
    apiFormData.append('userId', this.userId);
    this.userDashboardApi.DeleteUserAccount(apiFormData).subscribe((response) => {
      if(response.status=="Success")
      {
        const modalMsgRef = this.modalService.open(SuccessComponent, this.modalConfig);
        modalMsgRef.componentInstance.msg = "Technician Deleted";
        setTimeout(() => {
          modalMsgRef.dismiss('Cross click');
            let contactIndex = this.Technician.findIndex(option => option.id == item.id);
            if(contactIndex != '-1'){
              this.Technician.splice(contactIndex, 1);
            }
            if(this.selectedTechId[0] == item.id){
              this.selectedTech = [];
              this.selectedTechId = [];
              setTimeout(() => {
                this.serviceForm.patchValue({serviceTech: ''});
              }, 100);
            }
        }, 1000);
        }
        });
  }

  deleteAction(item){
    console.log(item);
    const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
      modalRef.componentInstance.access = 'techDelete';
      modalRef.componentInstance.confirmAction.subscribe((recivedService) => {
        modalRef.dismiss('Cross click');
        console.log(recivedService);
        if(!recivedService) {
          return;
        } else {
          this.deleteUserAccunt(item);
        }
      });
  }

  viewEstimate() {
    console.log('in')
    let index = this.sidebarList.findIndex(option => option.id == 2);
    console.log(this.sidebarList, index)
    if(index >= 0) {
      this.menuNav(this.sidebarList[index]);
    }
  }

  menuNav(item) {
    if(item.display) {
      let id = item.id;
      let setupFlag = true;
      let setupMenu = false;
      //let workOrderStatus = (this.ROViewData.workOrderStatusStr != null || this.ROViewData.workOrderStatusStr != undefined || this.ROViewData.workOrderStatusStr != '') ? this.ROViewData.workOrderStatusStr : 0;
      console.log(id)
      switch(id) {
        case 1:
        case 2:
        case 4:
        case 6:  
          setupMenu = true;
          break;
        default:
          setupFlag = false;
          break;
      }
      if(setupFlag) {
        this.actionSection = item.section;
        this.setupROView(id);
      }
      if(setupMenu) {
        this.setupMenuItem(id);
      }
    }
  }

  setupMenuItem(id) {
    this.sidebarList.forEach(item => {
      item.isActive = false;
      if(item.id == id) {
        item.isActive = true;
      }
    });
  }

  setupROView(id) {
    this.roFlag = (id == 1) ? true : false;
    this.roEstimateFlag = (id == 2) ? true : false;
    this.roInvoiceFlag = (id == 4) ? true : false;
    this.roAdasReportFlag = (id == 6) ? true : false;
    if(this.roFlag) {
      let isApproval = this.RODetailData.isPreApprovedInt;
      this.assignTechDisable = (isApproval == 1) ? false : true;
      isApproval = (isApproval == 1) ? 'Yes' : 'No';
      setTimeout(() => {
        this.serviceForm.patchValue({isPreApproved: isApproval});
      }, 100);
    }
    this.appEstimateFlag = false;
    setTimeout(() => {
      this.appEstimateFlag = true;
    }, 10);
    if(this.roEstimateFlag) {
      this.actionSection = 'manage-estimation';
    } else if(this.roInvoiceFlag) {
      this.actionSection = 'manage-invoice';
      setTimeout(() => {
          this.top.nativeElement.scrollTop=0;
        }, 1200);
    } else {
      this.actionSection = 'repair-order';
    }
  }

  estimateListCallback(data) {
    this.estimateListRef = data;
  }

  estimateCallback(data) {
    console.log(data)
    let action = data.action;
    let estId = data.estId;
    let empty = [];
    this.roPageData = data.roData;
    switch (action) {
      case 'send-invoice':
      case 'resend-invoice':
        let invSendTo = (data.sendTo && data.sendTo != undefined) ? data.sendTo : empty;
        let invNotes = (data.invoiceNotes && data.invoiceNotes != undefined) ? data.invoiceNotes : '';
        let cisRetail = data.isRetail;
        if(this.generateInvoiceFlag) {
          estId = this.genereateInvoiceId;
        }
        this.sendInvoice(action, estId, cisRetail, invSendTo, invNotes);
        break;
      case 'update':
        let field = data.field;
        let fieldValue = data.fieldValue;
        this.RODetailData = data.roData;
        let isInvoice = 0;
        let isGenerateInvoice = (data.isGenerateInvoice && data.isGenerateInvoice != undefined) ? data.isGenerateInvoice : false;
        switch(field) {
          case 'estimate':
            this.roPageData = data.roData;
            //this.RODetailData.estimationData = data.estData;
            //this.roPageData.estimationData = data.estData;
            this.estimateInfo[0]['estimateData'] = this.roPageData.estimationData.estimationArray;
            this.generateInvoiceFlag = (!this.generateInvoiceFlag) ? true : this.generateInvoiceFlag;
            this.roEstimatePreview = (!this.roEstimatePreview) ? true : this.roEstimatePreview;
            if(this.RODetailData.requestTypeIdInt == 2) {
              let duration = 0;
              let durationFormat = 'Hour';
              this.roPageData.estimationData.estimationArray.forEach(estItem => {
                let jobDuration = (estItem.jobDuration && estItem.jobDuration != undefined && estItem.jobDuration != null) ? estItem.jobDuration : '';
                let jobDurationSplit = jobDuration.split(' ');
                if(jobDurationSplit.length > 1) {
                  duration += parseInt(jobDurationSplit[0]);
                }
              });
              if(duration > 0) {
                durationFormat = (duration > 1) ? `${durationFormat}s` : durationFormat;
              }
              let durationValue = `${duration} ${durationFormat}`;
              if(duration > 0) {
                let durationHours = durationValue;
                let durationMinutes = '';
                this.roPageData.durationHoursStr = durationHours;
                this.roPageData.durationMinutesStr = durationMinutes;
                this.RODetailData.durationHoursStr = durationHours;
                this.RODetailData.durationMinutesStr = durationMinutes;
                this.serviceForm.patchValue({durationHours, durationMinutes});
              }
            }
            break;
          case 'invoice':
            this.roPageData = data.roData;
            //this.roPageData.invoiceData = data.estData;
            //this.RODetailData.invoiceData = data.estData;
            isInvoice = (field == 'invoice') ? 1 : isInvoice;
            if(isGenerateInvoice) {
              this.generateInvoiceFlag = true;
              this.roInvoicePreview = (!this.roInvoicePreview) ? true : this.roInvoicePreview;
              this.estimateCount += 1;
              this.estimateInfo[0].estimateCount = this.estimateCount;
              this.roPageData.invoiceDataJsonArr = this.roPageData.estimationDataJsonArr;
              this.roPageData.invoiceInfoDataJsonArr = this.roPageData.estimateInfoDataJsonArr;
              this.roPageData.invoiceJobUploadContentsJsonArr = this.roPageData.estJobUploadContentsJsonArr;
              this.RODetailData = this.roPageData;
              this.invoiceData = this.RODetailData.invoiceDataJsonArr != undefined ? this.RODetailData.invoiceDataJsonArr : '';
              this.isManualInvoice = this.isManualEst;
              if(this.invoiceData != '') {
                this.estimateInfo[0]['invoiceData'] = this.invoiceData;
              }
              this.estimateInfo[0]['isManualInvoice'] = this.isManualInvoice;
            } else {
              this.estimateInfo[0]['invoiceData'] = this.roPageData.invoiceData.estimationArray;
            }
            break;
          case 'estimateNotes':
            this.estimateInfo[0]['estimateData'][0].notes = fieldValue;
            break;
          case 'invoiceNotes':
            console.log(this.estimateInfo)
            isInvoice = 1;
            this.estimateInfo[0]['invoiceData'][0].notes = fieldValue;
            break;
        }
        this.updateWorkOrder(field, fieldValue, estId, isInvoice, isGenerateInvoice);
        break;
      case 'preview-open':
      case 'preview-close':
        //this.detailCallback.emit(data);
        break;
      default:
        action = (this.estimateCount == 0) ? 'est-send' : 'est-resend';
        let sendTo = (data.sendTo && data.sendTo != undefined) ? data.sendTo : empty;
        let notes = (data.estNotes && data.estNotes != undefined) ? data.estNotes : '';
        let isRetail = data.isRetail;
        this.roPageData = data.roData;
        this.RODetailData = data.roData;
        //console.log(data, this.estimateData, data.isRetail, isRetail);
        if(action == 'est-resend') {
          //this.estimateData = data.estimateData;
        }
        this.sendEstimate(action, isRetail, sendTo, notes);
        break;
    }
  }

  sendEstimate(action = 'send', isRetail = 1, sendTo = [], estimateNotes = '') {
    console.log(this.roPageData, action, isRetail)
    let sentToData = (sendTo.length == 0) ? false : true;
    //this.estimateSubmit = true;
    let resendFlag = (action == 'est-resend') ? true : false;
    action = (action == 'est-send') ? 'send' : (action == 'est-resend') ? 'resend' : action;
    let estimateInfo;
    switch(action) {
      case 'send':
        estimateInfo = this.RODetailData.estimationData.estimationArray;
        break;
      case 'resend':
        //estimateInfo = this.estimateData[0].estimateData;
        estimateInfo = this.RODetailData.estimationData.estimationArray;
        break;
    }
    let estimateData = [];
    estimateInfo.forEach(est => {
      estimateData.push(est);
    });
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      id: this.workOrderId,
      estimateNotes,
      action,
      isRetail,
      estimateData: JSON.stringify(estimateData),
      sendTo: JSON.stringify(sendTo)
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiWorkOrderSendEstimate(apiInfo).subscribe((response) => {
      console.log(response);
      this.systemMsg = [{severity:'success', summary:'', detail:response.message}];
      this.primengConfig.ripple = true;
      setTimeout(() => {
        this.systemMsg = [];
      }, 3000);
      let responseData = response.data;
      //this.estimateFlag = true;
      //this.estimateSubmit = false;
      let estimateHistory = responseData.estimattionHistory;
      let estimateHistoryCount = estimateHistory.length;
      //this.estimateCount = estimateHistoryCount;
      //this.isManualEst = 0;
      let estimateDae = moment.utc(responseData.estimationData.createdOn).toDate();
      //this.estimateDate = moment(estimateDae).local().format('MMM DD, YYYY h:mm A');
      setTimeout(() => {
        this.updateROSolr(this.workOrderId, 'update');
      }, 100);
      estimateHistory.forEach((hitem, hindex) => {
        if(sentToData) {
          let estDate = hitem.estDate;
          estDate = moment.utc(estDate).toDate();
          hitem.estDate = moment(estDate).local().format('MMM DD, YYYY h:mm A');
          let estVersion = (hindex == 0) ? hitem.version : this.estimateListRef.estVersion;
          this.estimateListRef.estVersion = estVersion;
          this.estimateListRef.estDate = (hindex == 0) ? hitem.estDate : this.estimateListRef.estDate;
          this.estimateVersion = estVersion;
        }
      });

      this.estimateHistory = estimateHistory
      this.estimateInfo[0]['isManualEst'] = this.isManualEst;
      this.estimateInfo[0]['estimateCount'] = this.estimateCount;
      this.estimateInfo[0]['estimateHistory'] = this.estimateHistory;

      if(sentToData) {
        this.estimateListRef.multipleEmail = this.estimateListRef.contactEmail;
        this.estimateListRef.isManualEst = this.isManualEst;
        this.estimateListRef.estimateCount = this.estimateCount;
        this.estimateListRef.estimateText = 'Resend';
        this.estimateListRef.estimateHistory = this.estimateHistory;
      } else {
        this.estimateVersion = 'V 1.0';
      }

      let workOrderStatus = 14;
      if(this.ROViewData['workOrderStatusStr'] == 1 || this.ROViewData['workOrderStatusStr'] == 2) {
        setTimeout(() => {
          let statusText = 'Estimate Sent';
          let statusBgColor = '#7f9e2d';
          this.ROViewData['workOrderStatusStr'] = workOrderStatus;
          this.ROViewData['techSupportStatusStr'] = statusText;
          this.ROViewData['techSupportStatusBgColorStr'] = statusBgColor;
          this.ROViewData['workOrderStatusInfoJsonArr'][0].id = workOrderStatus;
          this.ROViewData['workOrderStatusInfoJsonArr'][0].statusName = statusText;
          this.ROViewData['workOrderStatusInfoJsonArr'][0].bgColor = statusBgColor;
          this.ROViewData['workOrderStatusInfoJsonArr'][0].statusClass = 'estimate';
        }, 1000);
      }

      let emitAction = 'estimate';
      let detailEmitData = {
        action: emitAction,
        workOrderStatus,
        threadId: this.threadId,
        endUser: this.endUser,
        repairOrderId: this.workOrderId,
        isCustomerActiveInt: this.RODetailData.isCustomerActiveInt
      }
      this.ROManageService.emit(detailEmitData);
    });
  }

  sendInvoice(action, estimateId, isRetail, sendTo = [], invoiceNotes = '') {
    console.log(this.RODetailData)
    let sentToData = (sendTo.length == 0) ? false : true;
    //this.invoiceSubmit = true;
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      woId: this.workOrderId,
      estimateId,
      action,
      isRetail,
      invoiceNotes,
      sendTo: JSON.stringify(sendTo)
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiWorkOrderSendInvoice(apiInfo).subscribe((response) => {
      console.log(response);
      this.systemMsg = [{severity:'success', summary:'', detail:response.message}];
      this.primengConfig.ripple = true;
      setTimeout(() => {
        this.systemMsg = [];
      }, 3000);
      this.invoiceSubmit = false;
      let responseData = response.data;
      let roCompletedStatus = (this.RODetailData.completeStatusInt != null || this.RODetailData.completeStatusInt != undefined || this.RODetailData.completeStatusInt != '') ? this.RODetailData.completeStatusInt : 0;
      let roStatus = (this.RODetailData.completeStatusInt != null || this.RODetailData.completeStatusInt != undefined || this.RODetailData.completeStatusInt != '') ? this.RODetailData.completeStatusInt : 0;
      let dispatchId = this.RODetailData.dispatchIdInt;
      let threadId = this.RODetailData.threadIdInt;
      this.isManualInvoice = 0;
      let invoiceHistory = responseData.invoiceHistory;
      let invoiceHistoryCount = invoiceHistory.length;
      this.invoiceCount = invoiceHistoryCount;
      let invoicedInt = 1;
      if(invoiceHistory) {
        let invoiceDate = moment.utc(invoiceHistory[0].invoiceDate).toDate();
        this.invoiceDate = moment(invoiceDate).local().format('MMM DD, YYYY h:mm A');
        invoiceHistory.forEach((hitem, hindex) => {
          if(sentToData) {
            let invoiceDate = hitem.estDate;
            invoiceDate = moment.utc(invoiceDate).toDate();
            hitem.estDate = moment(invoiceDate).local().format('MMM DD, YYYY h:mm A');
            hitem.invoiceDate = hitem.estDate;
            let invoiceVersion = (hindex == 0) ? hitem.version : this.estimateListRef.invoiceVersion;
            if(hindex == 0) {
              this.invoiceVersion = invoiceVersion;
            }
            this.estimateListRef.invoiceVersion = invoiceVersion;
            this.estimateListRef.templateInfo.invoiceVersion = invoiceVersion;
            this.estimateListRef.invoiceDate = (hindex == 0) ? hitem.invoiceDate : this.estimateListRef.invoiceDate;
          }
        });
      }

      this.invoiceHistory = invoiceHistory;
      this.estimateInfo[0]['isManualInvoice'] = this.isManualInvoice;
      this.estimateInfo[0]['invoiceCount'] = this.invoiceCount;
      this.estimateInfo[0]['invoiceHistory'] = this.invoiceHistory;
      this.estimateListRef.invoiceHistory = this.invoiceHistory;
      this.estimateListRef.invoicedInt = invoicedInt;
      this.RODetailData.invoicedInt = invoicedInt;

      if(sentToData) {
        this.estimateListRef.multipleEmail = this.estimateListRef.contactEmail;
        this.estimateListRef.isManualEst = this.isManualEst;
        this.estimateListRef.invoiceCount = this.invoiceCount;
        this.estimateListRef.invoiceText = 'Resend';
        this.estimateListRef.estimateHistory = this.estimateHistory;
        this.estimateListRef.invoiceHistory = this.invoiceHistory;
        this.estimateListRef.invoiceVersion = this.invoiceVersion;
        this.estimateListRef.templateInfo.invoiceVersion = this.invoiceVersion;
      } else {
        this.invoiceVersion = 'V 1.0';
      }

      if(roCompletedStatus >= 0) {
        let workOrderStatus = 12;
        if(this.RODetailData.workOrderStatusStr != workOrderStatus) {
          let statusText = 'Invoice Sent';
          let statusBgColor = '#0e9a4e';
          this.RODetailData.workOrderStatusStr = workOrderStatus;
          this.RODetailData.techSupportStatusStr = statusText;
          this.RODetailData.techSupportStatusBgColorStr = statusBgColor;
          this.RODetailData.workOrderStatusInfoJsonArr[0].id = workOrderStatus;
          this.RODetailData.workOrderStatusInfoJsonArr[0].statusName = statusText;
          this.RODetailData.workOrderStatusInfoJsonArr[0].bgColor = statusBgColor;
          this.RODetailData.workOrderStatusInfoJsonArr[0].statusClass = 'invoice';
        }
        if(roCompletedStatus == 0) {
          if(dispatchId > 0) {
            this.changeDispatchStatus(dispatchId, 4);
          }
          if(threadId > 0) {
            this.closeThread(threadId);
            this.threadSilentPush(threadId);
            let taction = 'update';
            let tactionType = SolrContentTypeValues.Thread;
            setTimeout(() => {
              this.updateSolr(taction, tactionType, this.workOrderId);
            }, 100);
          }
        }
      }
      setTimeout(() => {
        this.updateROSolr(this.workOrderId, 'update');
      }, 100);

      let roStatusData = [];
      let workOrderStatus = 12;
      let detailEmitData = {
        action: 'invoice',
        workOrderStatus,
        roStatusData,
        threadId: this.threadId,
        endUser: this.endUser,
        repairOrderId: this.workOrderId,
        isCustomerActiveInt: this.RODetailData.isCustomerActiveInt
      }
      this.ROManageService.emit(detailEmitData);
    });
  }

  changeDispatchStatus(dispatchId, statusId) {
    const apiInfo = {
      apikey: Constant.ApiKey,
      countryId: this.countryId,
      domainId: this.domainId,
      userId: this.userId,
      action: 'change',
      serviceId: dispatchId,
      statusId,
      fieldId: statusId,
      field:'status',
      platform: '3'
    };
    this.LandingpagewidgetsAPI.manageServiceAPI(apiInfo).subscribe(response => {});
  }

  closeThread(threadId) {
    let capiData = new FormData();
    capiData.append('apiKey', Constant.ApiKey);
    capiData.append('domainId', this.domainId);
    capiData.append('countryId', this.countryId);
    capiData.append('userId', this.userId);
    capiData.append('threadId', threadId);
    capiData.append('closeStatus', 'yes');
    capiData.append('emailFlag', '1');
    capiData.append('platform', '3');
    this.threadPostService.closeThread(capiData).subscribe(response => {
      let taction = 'update';
      let tactionType = SolrContentTypeValues.Thread;
      this.updateSolr(taction, tactionType, threadId);
    });
  }

  updateWorkOrder(field, fieldValue, estId = 0, isInvoice = 0, isGenerateInvoice = false, isFromRoForm = false) {
    let action = (isGenerateInvoice) ? 'generate-invoice' : '';
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      roId: this.workOrderId,
      action,
      field,
      isInvoice,
      fieldValue
    };
    console.log(estId, apiInfo, fieldValue, this.estimateListRef)
    //return false;
    this.LandingpagewidgetsAPI.apiWorkOrderUpdate(apiInfo).subscribe((response) => {
      console.log(response)
      let estimateId = response.data?.estimateId;
      if(field == 'estimate') {
        if(this.estimateListRef) {
          this.estimateListRef.estimateId = estimateId;
        }
        this.estimateInfo[0].estimateId = estimateId;
        let estCount = this.estimateInfo[0].estimateCount;
        this.estimateInfo[0].estimateCount = (estCount == 0) ? estCount+1 : estCount;
        let estData = JSON.parse(fieldValue);
        console.log(estData, this.RODetailData)
        estData.estimationArray.forEach(estItem => {
          let jobId = estItem.jobId;
          let jobIndex = this.RODetailData.jobItemsInfoJsonArr.findIndex(option => parseInt(option.id) == parseInt(jobId));
          if(jobIndex >= 0) {
            this.RODetailData.jobItemsInfoJsonArr[jobIndex].unitPrice = estItem.jobtotal;
            this.RODetailData.jobItemsInfoJsonArr[jobIndex].wdPrice = estItem.jobWdTotal;
          } else {
            this.RODetailData.jobItemsIntArr.push(jobId);
            let jobPrice = estItem.jobtotal;
            let discount = estItem.jobDiscount;
            let discountPrice = jobPrice*(discount/100);
            let jobInfo = {
              discount,
              discountPrice,
              id: estItem.jobId,
              jobCode: estItem.jobcode,
              jobDesc: estItem.jobdesc,
              jobDuration: estItem.jobDuration,
              jobTitle: estItem.jobtitle,
              name: estItem.jobtitle,
              unitPrice: jobPrice,
              wdPrice: estItem.jobWdTotal
            };
            this.RODetailData.jobItemsInfoJsonArr.push(jobInfo);
          }
        });
        if(!isFromRoForm) {
          //this.selectedJobItemIds = this.RODetailData.jobItemsIntArr
          this.selectedJobItems = this.RODetailData.jobItemsInfoJsonArr;
        }
        this.estimateInfo[0].estimateCount = (estCount == 0) ? estCount+1 : estCount;
      } else {
        this.estimateListRef.invoiceId = estimateId;
        this.estimateInfo[0].invoiceId = estimateId;
        let invoiceCount = this.estimateInfo[0].invoiceCount;
        this.estimateInfo[0].invoiceCount = (invoiceCount == 0) ? invoiceCount+1 : invoiceCount;
      }
      if(action == 'generate-invoice') {
        this.genereateInvoiceId = estimateId;
        this.estimateListRef.generateInvoiceSubmitFlag = false;
        let detail = 'Invoice generated';
        this.systemMsg = [{severity:'success', summary:'', detail}];
        this.primengConfig.ripple = true;
        setTimeout(() => {
          this.systemMsg = [];
        }, 3000);
        this.sidebarList.forEach(item => {
          let mid = item.id;
          if(mid == 4 && !item.display) {
            item.display = true;
          }
        });
        setTimeout(() => {
          this.roInvoicePreview = true;
          this.menuNav(this.sidebarList[2]);  
        }, 100);        
      }
      //if(estId == 0) {
        let updateAction = 'update';
        this.updateROSolr(this.workOrderId, updateAction);
      //}
    });
  }

  threadSilentPush(threadId) {
    let apiData = new FormData();
    apiData.append('apiKey', Constant.ApiKey);
    apiData.append('domainId', this.domainId);
    apiData.append('userId', this.userId);
    apiData.append('threadId', threadId);
    apiData.append('silentPush', '1');
    apiData.append('action', 'close');
    this.threadPostService.sendPushtoMobileAPI(apiData).subscribe((response) => {});
  }

  updateROSolr(id, action) {
    let apiDatasocial1 = new FormData();
    apiDatasocial1.append('apiKey', Constant.ApiKey);
    apiDatasocial1.append('domainId', this.domainId);
    apiDatasocial1.append('workOrderId', id);
    apiDatasocial1.append('userId', this.userId);
    apiDatasocial1.append('action', action);
    apiDatasocial1.append('actionType', this.actionType);
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial1).subscribe((response: any) => { });
  }

  setupRoDetail(ROViewData) {
    this.RODetailData = ROViewData;
    console.log(ROViewData.estimationDataJsonArr);
    this.invoiceHistory = (ROViewData.invoiceHistoryJsonArr && ROViewData.invoiceHistoryJsonArr != undefined) ? ROViewData.invoiceHistoryJsonArr : [];
    this.estimateCount = ROViewData.estimateCountInt != undefined ? ROViewData.estimateCountInt : this.estimateCount;
    this.invoiceCount = ROViewData.invoiceCountInt != undefined ? ROViewData.invoiceCountInt : this.invoiceCount;
    this.paymentCount = ROViewData.paymentCountInt != undefined ? ROViewData.paymentCountInt : this.paymentCount;
    this.paymentData = (ROViewData.paymentInfoJsonArr && ROViewData.paymentInfoJsonArr != undefined) ? ROViewData.paymentInfoJsonArr : this.paymentData;
    let estimationData = ROViewData.estimationDataJsonArr != undefined ? ROViewData.estimationDataJsonArr : '';
    this.isManualEst = (ROViewData.isManualEstInt && ROViewData.isManualEstInt != undefined) ? ROViewData.isManualEstInt : 0;
    this.estimateInfo[0]['isManualEst'] = this.isManualEst;
    this.estimateInfo[0]['invoiceHistory'] = this.invoiceHistory;
    console.log(estimationData, this.estimateData)
    let ceinfo = estimationData != '' ? estimationData : '';
    console.log(ceinfo)
    this.estimateInfo[0]['estimateCount'] = this.estimateCount;
    if(this.estimateCount == 0 && estimationData != '') {
      this.estimateFlag = (this.estimateData.length > 0) ? this.estimateFlag : false;
      this.estimateData = ceinfo;
      this.estimateInfo[0]['estimateData'] = this.estimateData;
    }
    this.estimateInfo[0]['paymentCount'] = this.paymentCount;
    if(this.paymentCount > 0) {
      this.estimateInfo[0]['paymentData'] = this.paymentData;
    }
    this.generateInvoiceFlag = (this.estimateCount > 0) ? true : false;
    this.roEstimatePreview = (this.estimateCount > 0) ? true : false;
    this.roInvoicePreview = (this.invoiceCount > 0) ? true : false;
    switch(ROViewData.paymentMethodInt) {
      case 1:
        this.paymentItemData = ROViewData.stripeAccountInfoJsonArr;
        break;
    }

    this.RODetailData.appointmentTimeDisplay = moment(this.RODetailData.appointmentTimeStr, "HH:mm:ss A").format('h:mm A');
    console.log(this.RODetailData);
    this.RODetailData.threadIdInt = ROViewData.threadIdInt;
    this.RODetailData.dispatchIdInt = ROViewData.dispatchIdInt;
    let roStatusData = this.RODetailData.workOrderStatusInfoJsonArr;
    let workOrderStatus = (this.RODetailData.workOrderStatusStr != null || this.RODetailData.workOrderStatusStr != undefined || this.RODetailData.workOrderStatusStr != '') ? parseInt(this.RODetailData.workOrderStatusStr) : 0;
    let referenceShopRO = (this.RODetailData.referenceShopROStr && (this.RODetailData.referenceShopROStr != null || this.RODetailData.referenceShopROStr != undefined || this.RODetailData.referenceShopROStr != '')) ? this.RODetailData.referenceShopROStr : 0;
    this.RODetailData.referenceShopROStr = referenceShopRO;
    let customerSyteLine = (this.RODetailData.customerSyteLineStr && (this.RODetailData.customerSyteLineStr != null || this.RODetailData.customerSyteLineStr != undefined || this.RODetailData.customerSyteLineStr != '')) ? this.RODetailData.customerSyteLineStr : 0;
    this.RODetailData.customerSyteLineStr = customerSyteLine;
    let customerPO = (this.RODetailData.customerpoStr && (this.RODetailData.customerpoStr != null || this.RODetailData.customerpoStr != undefined || this.RODetailData.customerpoStr != '')) ? this.RODetailData.customerpoStr : '' ;
    this.RODetailData.customerpoStr = customerPO;   
    this.RODetailData.id = this.RODetailData.roIdInt;
    this.RODetailData.businessInfo = (this.RODetailData.businessInfoJsonArr && (this.RODetailData.businessInfoJsonArr != null || this.RODetailData.businessInfoJsonArr != undefined || this.RODetailData.businessInfoJsonArr != '')) ? (this.RODetailData.businessInfoJsonArr[0]) : '';
    let contactDetailInfoJsonArr = (this.RODetailData.contactDetailInfoJsonArr != null || this.RODetailData.contactDetailInfoJsonArr != undefined || this.RODetailData.contactDetailInfoJsonArr != '') ? (this.RODetailData.contactDetailInfoJsonArr) : '';
    this.RODetailData.contactDetailInfo = contactDetailInfoJsonArr != '' ? contactDetailInfoJsonArr : ''
    let ownerId = (this.RODetailData.contactDetailInfo && this.RODetailData.contactDetailInfo[0].userId) ? this.RODetailData.contactDetailInfo[0].userId : '';
    this.threadId = (this.RODetailData.threadIdInt != '' && this.RODetailData.threadIdInt != '0') ? this.RODetailData.threadIdInt : 0;
    let fromPublic = (this.RODetailData.fromPublicInt == 1 && !this.diagnationDomain) ? true : false;
    if(this.RODetailData.isPaymentSectionInt && this.RODetailData.isPaymentSectionInt != undefined) {
      this.paymentSectionFlag = (this.RODetailData.isPaymentSectionInt == 0) ? false : true;
    }
    this.threadCategory = (this.RODetailData.threadCategoryInt && this.RODetailData.threadCategoryInt != undefined) ? this.RODetailData.threadCategoryInt : this.threadCategory;
    console.log(this.threadCategory)
    switch(this.threadCategory) {
      case 1:
        this.threadCategoryTile = 'Vehicle';
        this.threadCategoryImage = `${this.threadCategoryImage}/repair-order/vehicle-info.svg`;
        break;
      case 2:
        this.threadCategoryTile = 'Scan Tool';
        this.threadCategoryImage = `${this.threadCategoryImage}/common/scan-tool-icon.svg`;
        break;
      case 7:
        this.threadCategoryTile = 'General';
        this.threadCategoryImage = `${this.threadCategoryImage}/thread/tc-general-normal.svg`;
        break;
      case 10:
        this.threadCategoryTile = 'Part';
        this.threadCategoryImage = `${this.threadCategoryImage}/thread/tc-part-normal.svg`;
        break;
    }
    this.billingInfoSection = (!this.diagnationDomain && this.RODetailData.billingSectionInt && this.RODetailData.billingSectionInt != undefined) ? true : false;
    let locationEmpty = (this.RODetailData.businessInfo.addressLine1 == null || this.RODetailData.businessInfo.addressLine1 == '') ? true : false;
    locationEmpty = (locationEmpty && (this.RODetailData.businessInfo.addressLine2 == null || this.RODetailData.businessInfo.addressLine2 == '')) ? true : false;
    locationEmpty = (locationEmpty && (this.RODetailData.businessInfo.city == null || this.RODetailData.businessInfo.city == '')) ? true : false;
    locationEmpty = (locationEmpty && (this.RODetailData.businessInfo.state == null || this.RODetailData.businessInfo.state == '')) ? true : false;
    locationEmpty = (locationEmpty && (this.RODetailData.businessInfo.zip == null || this.RODetailData.businessInfo.zip == '')) ? true : false;

    this.RODetailData.marketIdInt = (this.RODetailData.marketIdInt && this.RODetailData.marketIdInt != null && this.RODetailData.marketIdInt != undefined && this.RODetailData.marketIdInt != '') ? this.RODetailData.marketIdInt : 0;
    this.RODetailData.marketNameStr = (this.RODetailData.marketNameStr && this.RODetailData.marketNameStr != null && this.RODetailData.marketNameStr != undefined && this.RODetailData.marketNameStr != '') ? this.RODetailData.marketNameStr : '';
    this.RODetailData.salesRepInt = (this.RODetailData.salesRepInt && this.RODetailData.salesRepInt != null && this.RODetailData.salesRepInt != undefined && this.RODetailData.salesRepInt != '') ? this.RODetailData.salesRepInt : 0;
    this.RODetailData.salesRepNameStr = (this.RODetailData.salesRepNameStr && this.RODetailData.salesRepNameStr != null && this.RODetailData.salesRepNameStr != undefined && this.RODetailData.salesRepNameStr != '') ? this.RODetailData.salesRepNameStr : '';

    if(this.RODetailData.createdOnStr !='0000-00-00 00:00:00'){
      let createdOn = moment.utc(this.RODetailData.createdOnStr).toDate();
      this.RODetailData.requestedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
    }
    else{
      this.RODetailData.requestedDate = "-";
    }

    if(this.RODetailData.createdOnStr !='0000-00-00 00:00:00'){
      let createdOn = moment.utc(this.RODetailData.createdOnStr).toDate();
      this.RODetailData.createdOn = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
    }
    else{
      this.RODetailData.createdOn = "-";
    }
    this.RODetailData.approvedDate = (this.RODetailData.approvedDateStr && this.RODetailData.approvedDateStr != null && this.RODetailData.approvedDateStr != undefined && this.RODetailData.approvedDateStr != '') ? (this.RODetailData.approvedDateStr) : '';
    console.log(this.RODetailData.approvedDate)
    let approveDate = this.RODetailData.approvedDate;
    if(approveDate != '') {
      approveDate = moment.utc(approveDate).toDate();
      approveDate = moment(approveDate).local().format('MMM DD, YYYY h:mm A');
      this.RODetailData.approveDate = approveDate;
    } else {
      this.RODetailData.approveDate = "-";
    }
    this.RODetailData.approvedBy = (this.RODetailData.approvedByInt > 0 && this.RODetailData.approvedByInfoJsonArr && this.RODetailData.approvedByInfoJsonArr != null && this.RODetailData.approvedByInfoJsonArr != undefined && this.RODetailData.approvedByInfoJsonArr != '') ? `${this.RODetailData.approvedByInfoJsonArr[0].firstName} ${this.RODetailData.approvedByInfoJsonArr[0].lastName}` : '-';
    if(this.diagnationDomain){
      if(this.RODetailData.wooStatusTextStr !='' && this.RODetailData.wooStatusTextStr != undefined){}
      else{
        this.RODetailData.wooStatusTextStr = '';
      }
      this.RODetailData.wooLastUpdatedOn = (this.RODetailData.wooLastUpdatedOnStr != null && this.RODetailData.wooLastUpdatedOnStr != undefined && this.RODetailData.wooLastUpdatedOnStr != '') ? (this.RODetailData.wooLastUpdatedOnStr) : '';
      if(this.RODetailData.wooLastUpdatedOn !=''){
        let wooLastUpdatedOn = moment.utc(this.RODetailData.wooLastUpdatedOn).toDate();
        this.RODetailData.wooLastUpdatedOn = moment(wooLastUpdatedOn).local().format('MMM DD, YYYY h:mm A');
      }
      else{
        this.RODetailData.wooLastUpdatedOn = "";
      }
    }

    if(!this.diagnationDomain) {
      if(!this.paymentSectionFlag && this.estimateCount > 0) {
        this.sidebarList.forEach(sitem => {
          let sid = sitem.id;
          if((sid > 1 && sid < 3) || sid == 4) {
            let itemFlag = true;
            sitem.display = itemFlag;
          }
        });
      }
      if(this.paymentSectionFlag) {
        this.sidebarList.forEach(sitem => {
          let sid = sitem.id;
          if(sid > 1 && sid < 6) {
            let itemFlag = true;
            sitem.display = itemFlag;
          }
        });
      }
      if(!this.dmaDomain) {
        this.sidebarList.forEach(item => {
          let displayFlag = (item.id == 6) ? this.calproAccess : true; 
          item.display = displayFlag;
        });
      }
      if(this.dmaDomain) {
        this.setupDmaSidebar();
      }
    }

    this.RODetailData.contactDetailInfo = this.RODetailData.contactDetailInfoJsonArr && this.RODetailData.contactDetailInfoJsonArr!= undefined ? this.RODetailData.contactDetailInfoJsonArr : '';
    if(this.RODetailData.contactDetailInfo?.length>0){
      this.RODetailData.contactDetailInfoArr=[];
      for(let cdi in this.RODetailData.contactDetailInfo){
        let firstName = this.RODetailData.contactDetailInfo[cdi].firstName != undefined && this.RODetailData.contactDetailInfo[cdi].firstName != '' && this.RODetailData.contactDetailInfo[cdi].firstName != null ? this.RODetailData.contactDetailInfo[cdi].firstName : '';
        let lastName = this.RODetailData.contactDetailInfo[cdi].lastName != undefined && this.RODetailData.contactDetailInfo[cdi].lastName != '' && this.RODetailData.contactDetailInfo[cdi].lastName != null ? this.RODetailData.contactDetailInfo[cdi].lastName : '';
        let jobTitle = this.RODetailData.contactDetailInfo[cdi].jobTitle != undefined && this.RODetailData.contactDetailInfo[cdi].jobTitle != '' && this.RODetailData.contactDetailInfo[cdi].lastName != null ? ", "+this.RODetailData.contactDetailInfo[cdi].jobTitle : '';
        let email = this.RODetailData.contactDetailInfo[cdi].email != undefined && this.RODetailData.contactDetailInfo[cdi].email != '' && this.RODetailData.contactDetailInfo[cdi].email != null ? ", "+this.RODetailData.contactDetailInfo[cdi].email : '';
        let phone = this.RODetailData.contactDetailInfo[cdi].phone != undefined && this.RODetailData.contactDetailInfo[cdi].phone != '' && this.RODetailData.contactDetailInfo[cdi].phone != null ? ", "+this.RODetailData.contactDetailInfo[cdi].phone : '';
        this.RODetailData.contactDetailInfo[cdi].name = '';
        this.RODetailData.contactDetailInfo[cdi].info = '';
        if(firstName != '' || lastName != '' || jobTitle != '' || email != '' || phone != ''){
          this.RODetailData.contactDetailInfo[cdi].name = firstName+" "+lastName;
          this.RODetailData.contactDetailInfo[cdi].info = firstName+" "+lastName+jobTitle+email+phone;
          this.RODetailData.contactDetailInfoArr.push(this.RODetailData.contactDetailInfo[cdi].info);
        }
      }
      console.log(this.RODetailData.contactDetailInfoArr);
    }
    let billingContactInfo = (this.RODetailData.billingContactInfoStr && this.RODetailData.billingContactInfoStr != undefined) ? JSON.parse(this.RODetailData.billingContactInfoStr) : [];
    this.RODetailData.billingContactInfoStr = billingContactInfo;
    this.RODetailData.billingContactDetailInfo = billingContactInfo.length > 0 && this.RODetailData.billingContactDetailInfoJsonArr && this.RODetailData.billingContactDetailInfoJsonArr!= undefined ? this.RODetailData.billingContactDetailInfoJsonArr : '';
    if(this.RODetailData.billingContactDetailInfo?.length>0){
      this.RODetailData.billingContactDetailInfoArr=[];
      for(let cdi in this.RODetailData.billingContactDetailInfo){
        let firstName = this.RODetailData.billingContactDetailInfo[cdi].firstName != undefined && this.RODetailData.billingContactDetailInfo[cdi].firstName != '' && this.RODetailData.billingContactDetailInfo[cdi].firstName != null ? this.RODetailData.billingContactDetailInfo[cdi].firstName : '';
        let lastName = this.RODetailData.billingContactDetailInfo[cdi].lastName != undefined && this.RODetailData.billingContactDetailInfo[cdi].lastName != '' && this.RODetailData.billingContactDetailInfo[cdi].lastName != null ? this.RODetailData.billingContactDetailInfo[cdi].lastName : '';
        let jobTitle = this.RODetailData.billingContactDetailInfo[cdi].jobTitle != undefined && this.RODetailData.billingContactDetailInfo[cdi].jobTitle != '' && this.RODetailData.billingContactDetailInfo[cdi].lastName != null ? ", "+this.RODetailData.billingContactDetailInfo[cdi].jobTitle : '';
        let email = this.RODetailData.billingContactDetailInfo[cdi].email != undefined && this.RODetailData.billingContactDetailInfo[cdi].email != '' && this.RODetailData.billingContactDetailInfo[cdi].email != null ? ", "+this.RODetailData.billingContactDetailInfo[cdi].email : '';
        let phone = this.RODetailData.billingContactDetailInfo[cdi].phone != undefined && this.RODetailData.billingContactDetailInfo[cdi].phone != '' && this.RODetailData.billingContactDetailInfo[cdi].phone != null ? ", "+this.RODetailData.billingContactDetailInfo[cdi].phone : '';
        this.RODetailData.billingContactDetailInfo[cdi].name = '';
        this.RODetailData.billingContactDetailInfo[cdi].info = '';
        if(firstName != '' || lastName != '' || jobTitle != '' || email != '' || phone != ''){
          this.RODetailData.billingContactDetailInfo[cdi].name = firstName+" "+lastName;
          this.RODetailData.billingContactDetailInfo[cdi].info = firstName+" "+lastName+jobTitle+email+phone;
          this.RODetailData.billingContactDetailInfoArr.push(this.RODetailData.billingContactDetailInfo[cdi].info);
        }
      }
      console.log(this.RODetailData.billingContactDetailInfoArr);
    }

    ROViewData.technicanInfoJsonArr = ROViewData.technicanInfoJsonArr;
    this.RODetailData.technicanInfo = this.RODetailData.technicanInfoJsonArr != undefined ? this.RODetailData.technicanInfoJsonArr : '';

    if(this.RODetailData.technicanInfo && this.RODetailData.technicanInfo?.length>0){
      for(let cdi in this.RODetailData.technicanInfo){
        let firstName = this.RODetailData.technicanInfo[cdi].firstName != '' ? this.RODetailData.technicanInfo[cdi].firstName : '';
        let lastName = this.RODetailData.technicanInfo[cdi].lastName != '' ? this.RODetailData.technicanInfo[cdi].lastName : '';
        let email = this.RODetailData.technicanInfo[cdi].email != '' ? ", "+this.RODetailData.technicanInfo[cdi].email : '';
        let phone = this.RODetailData.technicanInfo[cdi].phone != '' ? ", "+this.RODetailData.technicanInfo[cdi].phone : '';
        this.RODetailData.technicanInfo[cdi].info = firstName+" "+lastName+email+phone;
        this.RODetailData.technicanInfo[cdi].name = firstName+" "+lastName;
      }
    }

    this.RODetailData.assignTechnicanInfoJsonArr = ROViewData.assignTechnicanInfoJsonArr;
    this.RODetailData.assignTechnicianIdInfoStr = ROViewData.assignTechnicianIdInfoStr;
    this.RODetailData.assignTechnicianIdStr = ROViewData.assignTechnicianIdStr;
    this.RODetailData.assignTechnicanInfo = this.RODetailData.assignTechnicanInfoJsonArr != undefined ? this.RODetailData.assignTechnicanInfoJsonArr : [];
    console.log(this.RODetailData.assignTechnicanInfo.length+'::'+this.ROViewData)
    if(this.RODetailData.assignTechnicanInfo && this.RODetailData.assignTechnicanInfo?.length>0){
      for(let adi in this.RODetailData.assignTechnicanInfo){
        let afirstName = this.RODetailData.assignTechnicanInfo[adi].firstName != '' ? this.RODetailData.assignTechnicanInfo[adi].firstName : '';
        let alastName = this.RODetailData.assignTechnicanInfo[adi].lastName != '' ? this.RODetailData.assignTechnicanInfo[adi].lastName : '';
        let email = this.RODetailData.assignTechnicanInfo[adi].email != '' ? ", "+this.RODetailData.assignTechnicanInfo[adi].email : '';
        let phone = this.RODetailData.assignTechnicanInfo[adi].phone != '' ? ", "+this.RODetailData.assignTechnicanInfo[adi].phone : '';
        this.RODetailData.assignTechnicanInfo[adi].info = afirstName+" "+alastName+email+phone;
        this.RODetailData.assignTechnicanInfo[adi].name = afirstName+" "+alastName;
      }
    }

    this.RODetailData.createdByInfo = this.RODetailData.createdByInfoJsonArr != undefined ? this.RODetailData.createdByInfoJsonArr : '';
    console.log(this.RODetailData.createdByInfo);
    if(this.RODetailData.createdByInfo && this.RODetailData.createdByInfo?.length>0){
      for(let cbi in this.RODetailData.createdByInfo){
        let cbfirstName = this.RODetailData.createdByInfo[cbi].firstName != '' ? this.RODetailData.createdByInfo[cbi].firstName : '';
        let cbilastName = this.RODetailData.createdByInfo[cbi].lastName != '' ? this.RODetailData.createdByInfo[cbi].lastName : '';
        let email = this.RODetailData.createdByInfo[cbi].email != '' ? ", "+this.RODetailData.createdByInfo[cbi].email : '';
        let phone = this.RODetailData.createdByInfo[cbi].phone != '' ? ", "+this.RODetailData.createdByInfo[cbi].phone : '';
        this.RODetailData.createdByInfo[cbi].info = cbfirstName+" "+cbilastName+email+phone;
        this.RODetailData.createdByInfo[cbi].name = cbfirstName+" "+cbilastName;
      }
    }

    this.RODetailData.estimationData = this.RODetailData.estimationDataJsonArr != undefined ? this.RODetailData.estimationDataJsonArr : '';
    let einfo = this.RODetailData.estimationData != '' ? (this.RODetailData.estimationData[0]) : '';
    let customerDiscount = (this.RODetailData?.customerDiscountInt && this.RODetailData?.customerDiscountInt != undefined) ? this.RODetailData.customerDiscountInt : 0;
    this.roPageData = {
      access: "view",
      fromaccess: 'repairorder-list',
      contentType: ContentTypeValues.RepairOrder,
      id: this.workOrderId,
      estimationData: einfo,
      customerDiscount
    }

    console.log(this.RODetailData.technicanInfo);
    let make = (this.RODetailData.make && this.RODetailData.make != undefined) ? this.RODetailData.make : '';
    let model = (this.RODetailData.model && this.RODetailData.model != undefined) ? this.RODetailData.model : '';
    let year = (this.RODetailData.year && this.RODetailData.year != undefined && this.RODetailData.year != 0) ? this.RODetailData.year : '';
    let chevron = '<i class="pi pi-chevron-right" style="font-size: 11px; vertical-align: text-top; margin-top: 0px;margin-left:12px;"></i>';
    let vehicle = '-';
    let serialNumberStr = (this.RODetailData.serialNumberStr && this.RODetailData.serialNumberStr != undefined) ? this.RODetailData.serialNumberStr : '';
    this.RODetailData.serialNumberStr = (serialNumberStr == '') ? '-' : serialNumberStr;
    vehicle = (make != '') ? make : vehicle;
    vehicle = (model != '') ? `${vehicle}${chevron}${model}` : vehicle;
    vehicle = (year != '') ? `${vehicle}${chevron}${year}` : vehicle;
    if(ROViewData.threadCategoryInt == 10 && serialNumberStr != '' && serialNumberStr != 'undefined') {
      vehicle = `${vehicle}${chevron}${serialNumberStr}`;
    }

    this.RODetailData.makeVal = vehicle;
    let content:any = '';
    if(this.RODetailData.descriptionStr && this.RODetailData.descriptionStr!='') {
      content = this.authenticationService.convertunicode(this.authenticationService.ChatUCode(this.RODetailData.descriptionStr));
      //content = this.sanitizer.bypassSecurityTrustHtml(this.authenticationService.URLReplacer(content));
      this.RODetailData.descriptionStr = content;
      this.description = content;
    }
    let internalNotes:any = '';
    if(this.RODetailData.internalNotesStr && this.RODetailData.internalNotesStr!='') {
      internalNotes = this.authenticationService.convertunicode(this.authenticationService.ChatUCode(this.RODetailData.internalNotesStr));
      //internalNotes = this.sanitizer.bypassSecurityTrustHtml(this.authenticationService.URLReplacer(internalNotes));
      //this.RODetailData.internalNotesStr = internalNotes;
      this.internalNotes = internalNotes;
    }
    let userInfo = {};

    if(this.RODetailData.updatedonStr !='0000-00-00 00:00:00' && this.RODetailData.updatedonStr != undefined && this.RODetailData.updatedonStr != ''){
      let updatedonStr = moment.utc(this.RODetailData.updatedonStr).toDate();
      this.RODetailData.updatedon = moment(updatedonStr).local().format('MMM DD, YYYY h:mm A');
    }
    else{
      this.RODetailData.updatedon = "-";
    }

    this.RODetailData.updatedByInfo = this.RODetailData.updatedByInfoJsonArr != undefined ? this.RODetailData.updatedByInfoJsonArr : '';

    if(this.RODetailData.updatedByInfo && this.RODetailData.updatedByInfo?.length>0){
      for(let udi in this.RODetailData.updatedByInfo){
        let firstName = this.RODetailData.updatedByInfo[udi].firstName != '' ? this.RODetailData.updatedByInfo[udi].firstName : '';
        let lastName = this.RODetailData.updatedByInfo[udi].lastName != '' ? this.RODetailData.updatedByInfo[udi].lastName : '';
        if(firstName != '' || lastName != ''){
          this.RODetailData.updatedByInfo[udi].name = firstName+" "+lastName;
        }
        else{
          this.RODetailData.updatedByInfo[udi].name = '';
        }
      }
    }

    let createdBy = this.RODetailData.contactDetailInfo && this.RODetailData.contactDetailInfo[0].name != '' ? this.RODetailData.contactDetailInfo[0].name : "-";
    if(!this.diagnationDomain) {
      console.log(this.RODetailData.createdByInfo);
      createdBy = this.RODetailData.createdByInfo && this.RODetailData.createdByInfo[0].userName != '' ? `${this.RODetailData.createdByInfo[0].firstName} ${this.RODetailData.createdByInfo[0].lastName}` : "-";
    }
    let updatedBy = this.RODetailData.updatedByInfo && this.RODetailData.updatedByInfo[0].name != '' ? this.RODetailData.updatedByInfo[0].name : "-";

    if(updatedBy == '-'){
      this.RODetailData.updatedon = '-';
    }

    userInfo = {
      createdBy: createdBy,
      createdOn: this.RODetailData.createdOn,
      updatedBy: updatedBy,
      updatedOn: this.RODetailData.updatedon,
    };
    this.RODetailData.currentDtcJsonArr = this.RODetailData.currentDtcJsonArr &&  this.RODetailData.currentDtcJsonArr != undefined ? (this.RODetailData.currentDtcJsonArr) : [];
   
    if(this.gbbDomain || this.dmaDomain){
      this.partNumberStr = this.RODetailData.partNumberStr != undefined && this.RODetailData.partNumberStr != 'undefined' ? this.RODetailData.partNumberStr : '' ;
      this.partBatteryTypeStr = this.RODetailData.partBatteryTypeStr != undefined && this.RODetailData.partBatteryTypeStr != 'undefined' ? this.RODetailData.partBatteryTypeStr : '' ;
      this.partDescriptionStr = this.RODetailData.partDescriptionStr != undefined && this.RODetailData.partDescriptionStr != 'undefined' ? this.RODetailData.partDescriptionStr : '' ;
    }   
    if(!this.dmaDomain) {
      this.getEstimateList();
    }
  }

  getEstimateList() {
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      id: this.workOrderId,
      action: 'list'
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiGetWorkOrderEstimateList(apiInfo).subscribe((response) => {
      let estimateData = response.data;
      this.estimateCount = estimateData.estimateCountInt;
      this.estimateData = estimateData.estimateInfoDataJsonArr;
      this.isEstimateApprove = estimateData.isEstimationApprovedInt;
      this.estimateInfo[0]['estimateCount'] = this.estimateCount;
      this.estimateInfo[0]['isEstimateApprove'] = this.isEstimateApprove;
      if(this.estimateCount > 0) {
        let lastEstimateDate = this.estimateData[0].createdOn;
        lastEstimateDate = moment.utc(lastEstimateDate).toDate();
        this.estimateDate = moment(lastEstimateDate).local().format('MMM DD, YYYY h:mm A');
        this.estimateHistory = estimateData.estimateHistoryJsonArr;
        this.estimateInfo[0]['estimateHistory'] = this.estimateHistory;
        this.estimateInfo[0]['estimateData'] = estimateData.estimateInfoDataJsonArr;
        if(this.estimateHistory.length > 0) {
          let estVersion = this.estimateHistory[0].version;
          this.estimateVersion = estVersion;
        }
        if(this.invoiceData != '') {
          let lastInvoiceDate = this.invoiceData[0].createdOn;
          lastInvoiceDate = moment.utc(lastInvoiceDate).toDate();
          this.invoiceDate = moment(lastInvoiceDate).local().format('MMM DD, YYYY h:mm A');
          this.invoiceHistory = (this.RODetailData.invoiceHistoryJsonArr && this.RODetailData.invoiceHistoryJsonArr != undefined) ? this.RODetailData.invoiceHistoryJsonArr : [];
          this.estimateInfo[0]['invoiceHistory'] = this.invoiceHistory;
          this.estimateInfo[0]['invoiceData'] = this.RODetailData.invoiceInfoDataJsonArr;
          if(this.invoiceHistory.length > 0) {
            let invoiceVersion = this.invoiceHistory[0].version;
            this.invoiceVersion = invoiceVersion;
          }
        }
      }
      this.stripeInfo = estimateData.stripeInfoJsonArr;
      this.estimateInfo[0]['stripeInfo'] = this.stripeInfo;
      setTimeout(() => {
        this.loading = false;
      }, 1500);
    });
  }

  addMarket(action) {
    let id = 0;
    let name = '';
    let apiData = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      action,
      id,
      name
    };
    let actionInfo = {
      action
    }
    const modalRef = this.modalService.open(ActionFormComponent, { backdrop: 'static', keyboard: false, centered: true });
    modalRef.componentInstance.access = 'New Market';
    modalRef.componentInstance.apiData = apiData;
    modalRef.componentInstance.actionInfo = actionInfo;
    modalRef.componentInstance.dtcAction.subscribe((receivedService) => {
      console.log(receivedService)
      let action = receivedService['action'];
      let actionItem = receivedService['actionItem'];
      if(action && actionItem == 'new') {
        let mitem = receivedService['item'];
        let marketId = mitem[0].id;
        let marketName = mitem[0].name;
        let itemList = [];
        itemList.push({id: marketId, name: marketName});
        this.marketDataOptions.splice(1, 0, itemList[0]);
        const selectedMarket = this.marketDataOptions.filter(
          (element) => element.id == marketId
        );
        this.selectedMarket = selectedMarket[0];
        this.serviceShopForm.patchValue({marketId});
      }
      modalRef.dismiss('Cross click');
    });
  }

  marketChange(action, event) {
    console.log(action,event)
    let value = (action == 'change') ? event.value : (event != null) ? event : -1;
    value = (value == null) ? -1 : value;
    switch(value) {
      case -1:
        this.addMarket('new');
        break;
      default:
        let marketId = value;
        this.serviceShopForm.patchValue({marketId});
        const selectedMarket = this.marketDataOptions.filter(
          (element) => element.id == marketId
        );
        this.selectedMarket = selectedMarket[0];
        this.marketId = marketId;
        break;
    }
  }

  sortBy(item, prop: string, type = 'asc') {
    let sortItem: any;
    switch(type) {
      case 'asc':
        sortItem = item.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
        break;
      case 'desc':
        sortItem = item.sort((a, b) => a[prop] < b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
        break;
    }
    return sortItem;
  }

  setupJobEstimateData() {
    let estimateData = {estimationArray: [], estimationTotal: "0.00", wdestimationTotal: "0.00"};
    let estimationTotal = 0, wdestimationTotal = 0;
    this.selectedJobItems.forEach((item, index) => {
      let id = index+1;
      let qbId = item.qbId;
      let jobDiscount = item.discount;
      let jobqty:any = "1.00";
      let jobPrice = item.unitPrice;
      let jobtotalVal:any = jobqty * jobPrice;
      let jobtotal = (Math.abs(jobtotalVal)).toFixed(2);
      let wdPrice:any = jobtotalVal*(jobDiscount/100);
      wdPrice = jobtotalVal-wdPrice;
      let wdPriceVal = (Math.abs(wdPrice)).toFixed(2);
      let jobItem = {
        id,
        qbId,
        jobId: item.id,
        jobcode: item.jobCode,
        jobtitle: item.jobTitle,
        jobdesc: item.jobDesc,
        jobDiscount,
        jobDuration: item.jobDuration,
        jobprice: jobPrice,
        jobqty,
        jobtotal,
        jobtotalShowStr: jobtotal,
        jobtotalShowOnly: jobtotal,
        jobWdTotal: wdPriceVal,
        wdPrice: wdPriceVal,
        jobNotes: "",
        jobMedia: [],
        jobNotesEditFlag: false
      }
      estimateData.estimationArray.push(jobItem);
      estimationTotal += jobtotalVal;
      wdestimationTotal += wdPrice;
    });
    estimateData.estimationTotal = (Math.abs(estimationTotal)).toFixed(2);
    estimateData.wdestimationTotal = (Math.abs(wdestimationTotal)).toFixed(2);
    return estimateData;
  }

  setupEstimateItem(id, item) {
    console.log(id, item);
    let qbId = item.qbId;
    let jobDiscount = item.discount;
    let jobqty:any = "1.00";
    let jobPrice = item.unitPrice;
    let jobtotalVal:any = jobqty * jobPrice;
    let jobtotal = (Math.abs(jobtotalVal)).toFixed(2)
    let wdPrice:any = jobtotalVal*(jobDiscount/100);
    wdPrice = jobtotalVal-wdPrice;
    let wdPriceVal = (Math.abs(wdPrice)).toFixed(2);
    let jobItem = {
      id,
      qbId,
      jobId: item.id,
      jobcode: item.jobCode,
      jobtitle: item.jobTitle,
      jobdesc: item.jobDesc,
      jobDiscount,
      jobDuration: item.jobDuration,
      jobprice: jobPrice,
      jobqty,
      jobtotal,
      jobtotalShowStr: jobtotal,
      jobtotalShowOnly: jobtotal,
      jobWdTotal: wdPriceVal,
      wdPrice: wdPriceVal,
      jobNotes: "",
      jobMedia: [],
      jobNotesEditFlag: false
    }
    let estData = this.RODetailData.estimationData;
    estData = (Array.isArray(estData)) ? estData[0] : estData;
    let estimateInfo = estData.estimationArray;
    estimateInfo.push(jobItem);
    console.log(estData)
    let estTotal = parseFloat(estData.estimationTotal)+jobtotalVal;
    let wdestTotal = parseFloat(estData.wdestimationTotal)+wdPrice;
    estData.estimationTotal = (Math.abs(estTotal)).toFixed(2);
    estData.wdestimationTotal = (Math.abs(wdestTotal)).toFixed(2);
    this.RODetailData.estimationData = estData;

    return estData;
  }

  updateValidators(form, field, action, access = '') {
    console.log(form, field);
    let formField = form.get(field);
    console.log(formField)
    switch(action) {
      case 'init':
        if(access == 'contactForm') {
          form.controls[field].setValidators([Validators.required, Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);  
        } else {
          if(access == 'userEmail') {
            form.controls[field].setValidators([Validators.required, Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);  
          } else {
            form.controls[field].setValidators([Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
          }
          formField.setErrors(null);//updating error message
        }        
        break;
      case 'remove':
        if(access == 'contactForm') {
          form.controls[field].setValidators([Validators.required, Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);  
        } else {
          form.controls[field].setValidators([Validators.email,Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
        }        
        formField.setErrors(null);//updating error message
        formField.status = 'VALID';
        break;  
    }
    form.updateValueAndValidity();//update validation
  }

  getContactAccess() {
    let id = this.serviceContactForm.value.contactId;
    let access = (id > 0) ? 'contactForm' : '';
    if(id > 0) {
      let contactIndex = this.contacts.findIndex(option => option.id == id);
      let selectedEmail = this.contacts[contactIndex].email;
      let splitEmail = selectedEmail.split(this.maskEmail);    
      if(id > 0 && splitEmail.length > 1) {
        access = 'contactForm';
      }
    }
    return access;    
  }

  editContact(id) {
    let contactIndex = this.contacts.findIndex(option => option.id == id);
    let contact = this.contacts[contactIndex];
    this.serviceAction('edit','contact', contact);
  }

  setupEstAction(data) {
    console.log(data)
    let roData = data.roData;
    let estimateRef = roData.estimateListRef;
    this.roEstimatePreview = false;
    this.generateInvoiceFlag = false;
    this.roInvoicePreview = false;
    let previewFlag = false;
    this.previewUrl = "";
    let estPath = 'estimate-pdf';
    let estId = 0;
    let previewUrl = `${this.baseV3ApiUrl}/${this.supportTicketPath}/${estPath}?id=${this.workOrderId}&eid=`;
    if(roData.roEstimateFlag && !estimateRef?.estimateItemEmpty) {
      estId = (roData.estimateData && roData.estimateData != undefined && roData.estimateData?.length > 0) ? roData.estimateData[0].estId : estId;
      this.roEstimatePreview = (roData.estimateData?.length > 0) ? true : this.roEstimatePreview;
      this.generateInvoiceFlag = (roData.estimateData?.length > 0) ? true : this.generateInvoiceFlag;
      previewFlag = true;
    }
    if(roData.roInvoiceFlag) {
      estId = (roData.invoiceData && roData.ROViewData.invoiceData != undefined) ? roData.ROViewData.invoiceData[0].estId : estId;
      this.roInvoicePreview = (roData.invoiceCount > 0) ? true : this.roInvoicePreview;
      previewFlag = true;
    }
    if(previewFlag && estId > 0) {
      this.previewUrl = `${previewUrl}${estId}`;
    }
  }

  generateinvoice() {
    this.estimateListRef.invoiceAction('generate-invoice');
  }

  print() {
    let estId = 0;
    let estPath = 'estimate-pdf';
    let access = '';
    if(this.roEstimatePreview) {
      let estInfo = (this.RODetailData.estimateInfoDataJsonArr && this.RODetailData.estimateInfoDataJsonArr != undefined) ? this.RODetailData.estimateInfoDataJsonArr : [];
      if(estInfo.length > 0) {
        estId = this.RODetailData.estimateInfoDataJsonArr[0].estId;
      }
    } else {
      access = '&access=invoice';
      let invInfo = (this.RODetailData.invoiceInfoDataJsonArr && this.RODetailData.invoiceInfoDataJsonArr != undefined) ? this.RODetailData.invoiceInfoDataJsonArr : [];
      if(invInfo.length > 0) {
        estId = this.RODetailData.invoiceInfoDataJsonArr[0].estId;
      }
    }
    if(estId > 0) {
      let previewUrl = `${this.baseV3ApiUrl}/${this.supportTicketPath}/${estPath}?id=${this.workOrderId}&eid=${estId}${access}`;
      let aurl = previewUrl;
      let navPreviewPdf = window.open(aurl, aurl);
      navPreviewPdf.focus();
    }    
  }

  payAfterCallback(data) {
    console.log(data);
    if(data['paymentStatus'] == 'paid'){
        let workOrderStatus = '13';
        let statusText = 'Paid';
        let statusBgColor = '#0e9a4e';
        this.RODetailData.workOrderStatusStr = workOrderStatus;
        this.RODetailData.techSupportStatusStr = statusText;
        this.RODetailData.techSupportStatusBgColorStr = statusBgColor;
        this.RODetailData.workOrderStatusInfoJsonArr[0].id = workOrderStatus;
        this.RODetailData.workOrderStatusInfoJsonArr[0].statusName = statusText;
        this.RODetailData.workOrderStatusInfoJsonArr[0].bgColor = statusBgColor;
        this.RODetailData.workOrderStatusInfoJsonArr[0].statusClass = 'paid';
        localStorage.setItem('roPaymentStatus','1');
        localStorage.setItem('roPaymentStatusId',this.workOrderId);  
    }
  }

  setupDefaultWorkstream() {
    let wsId = localStorage.getItem('defaultWorkstream');
    let itemwsid = wsId && wsId != '' && wsId != undefined ? (wsId) : '';
    let itemwsidArr:any = [];
    itemwsidArr.push(itemwsid);
    this.workstreamId = itemwsidArr;
    console.log(this.workstreamId, this.workstreamSelection)
  }

  calproRefCallback(data) {
    console.log(data)
    this.calproReportRef = data;
  }

  adasReportCallaback(data) {
    console.log(data) 
    let action = data.action;
    let roData = data.roData;
    this.createParamReportId = data.reportId;
    this.serviceForm.patchValue({adasReportId: parseInt(this.createParamReportId)});
    switch(action) {
      case 'remove':
        this.removeReportFlag = false;
        break;  
      case 'roData':
      default:
        this.removeReportFlag = (data.reportId > 0) ? true : false;
        this.calproAdasData = data.calproAdasData;
        if(this.removeReportFlag) {
          let vin:any = this.serviceForm.get('vin').value;
          let make:any = this.serviceForm.get('make').value;
          if(vin == '' && (make == '' || make == 'General Make')) {
            let calproAdasData = this.calproAdasData[0];
            let vin = calproAdasData.vinNo;
            this.threadCategory = 1;
            this.serviceForm.patchValue({vin});
            this.vinChanged('change', vin, 'adasReport');
          }
        }
        break;
    }
  }

  getPlaceholderForInventorySource() {
    const optionSelected = this.inventorySourceOptions?.find(option => option?.id == this.inventorySource);
    if (optionSelected) {
      return optionSelected?.name || 'Select';
    } else {
      return 'Select';
    }
  }

  checkAccessLevel(){
    let viewAccess = true, createAccess = true, editAccess = true,  deleteAccess = true;
    let chkType = '', chkFlag = true;
    localStorage.removeItem('checkAccess');
    this.authenticationService.checkAccess(ContentTypeValues.CalproAdas, chkType, chkFlag);
    this.setInterval = setInterval(()=>{                
      let checkAccess = localStorage.getItem('checkAccess');  
      if(checkAccess == '1') { 
        let accessLevels = this.authenticationService.checkAccessItems;
        if(accessLevels && accessLevels.length > 0) {
          let reportAccess = accessLevels[0].pageAccess;
          reportAccess.forEach(item => {
            let accessId = parseInt(item.id);
            let roles = item.roles;
            let roleIndex = roles.findIndex(option => option.id == this.roleId);
            if(roleIndex < 0) {
              return false;
            }
            let roleAccess = (roles[roleIndex].access && roles[roleIndex].access != undefined) ? roles[roleIndex].access : 0;
            console.log(accessId, roleAccess)
            switch (accessId) {
              case 2:
                if(roleAccess == 1) {
                  this.calproAccess = true;
                  this.sidebarList.forEach(item => {
                    if(item.section == 'adas') {
                      item.display = true;
                      item.isHide = false;
                    }
                  });
                }
                break;
            }
          });
        }        
        clearInterval(this.setInterval);
      }
    },50);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    document.body.classList.remove("landing-page");
    document.body.classList.remove("view-modal-popup");
    document.body.classList.remove('view-modal-popup-manage');
  }

  adasThirdPartyDataUpdate(data) {
    console.log(data)
    let id = data.id;
    let name = data.name;
    let link = data.link;
    let jobId = data.jobId;
    let reportData = data.data;
    let roMapData = (data?.roMapData && data?.roMapData != undefined) ? data?.roMapData : '';
    console.log(data)
    if(!this.editRO) {
      this.serviceForm.patchValue({adasThirdPartyReportId: data.id});
      let adasThirdPartData = {id, name, link, jobId, data: reportData, roMapData};
      this.adasThirdPartData = adasThirdPartData;
      if(roMapData != '') {
        if(roMapData?.customerData) {
          let shopId = roMapData?.customerData?.id;
          this.getShopList(shopId, true);
          let ws = this.serviceForm.get('workstream').value;
          if(this.workstreamId?.length == 0) {
            let wsId = localStorage.getItem('defaultWorkstream');
            this.workstreamId = [];
            this.workstreamSelection = this.workstreamItems.filter(option => option.id == wsId);
            this.workstreamId = [wsId];
            this.serviceForm.patchValue({workstream: this.workstreamSelection});
          }
          if(this.workstreamId?.length > 0) {
            let vehicleData = roMapData?.vehicleData;
            this.threadCategory = vehicleData?.threadCategory;
            let vin = vehicleData?.vin;
            this.getCategoryData();
            setTimeout(() => {
              this.serviceForm.patchValue({vin});
              this.vinChanged('change', vin, 'adasReport');
            }, 2000);
          }
        }
      }
    } else {
      this.ROViewData['adasThirdPartyIdInt'] = id;
      this.ROViewData['adasThirdPartyFileNameStr'] = name;
      this.ROViewData['adasThirdPartyLinkStr'] = link;
      this.ROViewData['adasThirdPartyJobIdStr'] = jobId;
      this.ROViewData['adasThirdPartyDataJsonArr'] = reportData;
    }
  }

  removeReport() {
    const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
      modalRef.componentInstance.access = 'removeDelete';
      modalRef.componentInstance.confirmAction.subscribe((recivedService) => {
        modalRef.dismiss('Cross click');
        console.log(recivedService);
        if(!recivedService) {
          return;
        } else {
          this.removeAdasReport();
        }
      });
  }

  removeAdasReport() {
    let action = 'remove';
    let roData = this.RODetailData;
    let adasReportId: any = 0;
    let emptyId: any = 0;
    roData.adasReportIdInt = adasReportId;
    this.createParamReportId = adasReportId;    
    this.removeReportFlag = false;
    this.createParamSalesRepId = adasReportId;
    this.createParamShopId = emptyId;
    this.createParamMarketId = emptyId;
    this.createParamContactId = '';    
    this.createParamVIN = '';
    this.calproAdasReportData = [];
    this.calproAdasData = this.calproAdasReportData;
    this.serviceForm.patchValue({adasReportId: parseInt(this.createParamReportId)});
    let calproRef:any = this.calproReportRef;
    console.log(calproRef)
    if(this.workOrderId > 0) {    
      let adasReportId:any = calproRef.reportId;
      console.log(adasReportId)
      this.createParamReportId = adasReportId;    
      calproRef.removeLoading = true;
      console.log(this.RODetailData, roData, adasReportId);
      calproRef.calproReportAction(action, adasReportId);
    } else {
      this.calproReportRef.emptyFlag = true;
      this.calproReportRef.roReportMapFlag = true;
      this.calproReportRef.inspectionInfo = [];
    }
  }

  dueDateSelect(field = '') {
    if(field == 'date') {
      this.setupTimeZone();            
    }
    this.getAssigneeList();
  }

  setupTimeZone(action = '') {
    let shop = this.Shops;
    if(shop?.length > 0) {
      let shopData = shop[0];
      let shopId = (action == 'shop') ? shopData.id : 0;
      let lat = (shopData?.lat && shopData.lat != '' && shopData.lat != undefined) ? shopData.lat : '';
      let lng = (shopData?.lat && shopData.lng != '' && shopData.lng != undefined) ? shopData.lng : '';
      let appointmentDate = this.serviceForm.value.appointmentDate;
      let currDate = moment(this.currDate).format('YYYY-MM-DD');
      let aptDateTime = '';
      let apiCallFlag = true;
      if(appointmentDate != '' && appointmentDate != undefined) {
        appointmentDate = moment(appointmentDate).format('YYYY-MM-DD');
        let appointmentTime = this.serviceForm.value.appointmentTime;
        appointmentTime = (appointmentTime == '' || appointmentTime == undefined) ? this.ctime : appointmentTime;
        console.log(currDate, appointmentDate, appointmentTime)          
        if(appointmentTime != '' && appointmentTime != undefined) {
          aptDateTime = `${appointmentDate} ${appointmentTime}`;
          if(shopId == 0) {
            apiCallFlag = (currDate == appointmentDate) ? false : true;
            if(!apiCallFlag) {
              let timeZone = shopData.timeZone;
              this.timeZoneList = [];
              this.timeZoneList.push({id: timeZone, name: timeZone});
              this.serviceForm.patchValue({appointmentTimeZone: timeZone});
            }
          }          
        } else {
          if(action == '') {
            apiCallFlag = (appointmentTime == '' || appointmentTime == undefined) ? false : apiCallFlag;
          }
        }
      }
      if(apiCallFlag) {
        this.getTimeZone(lat, lng, aptDateTime, shopId);
      }
    }
  }

  getTimeZone(latitude, longitude, dateTime, shopId = 0) {
    let action = (shopId > 0) ? 'customer-timezone' : 'apt-timezone';
    let domainId = this.domainId;
    let apiInfo = { dateTime, latitude, longitude, action, domainId };
    if(shopId > 0) {
      apiInfo['shopId'] = shopId;
    }
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiGetTimeZoneByDate(apiInfo).subscribe((response) => {
      console.log(response)
      if(response?.code == 200) {
        let data = response?.data;
        this.timeZoneInfo = data;
        if(Object.keys(data).length > 0) {
          if(data.hasOwnProperty('timeZoneName')) {
            let timeZone = this.getInitials(data.timeZoneName);             
            this.timeZoneList = [];
            this.timeZoneList.push({id: timeZone, name: timeZone});
            this.serviceForm.patchValue({appointmentTimeZone: timeZone});
          }        
        }
      }      
    });
  }

  getInitials(text: string): string {
    return text.trim().split(/\s+/).map(word => word.charAt(0).toUpperCase()).join('');
  }

  timePipe(time: any) {
    if (!time) {
      return;
    }

    const m = moment(time, 'HH:mm:ss', true); // 'true' enables strict parsing
    if (!m.isValid()) {
      return; // or return a fallback like ''
    }

    return m.format('hh:mm A'); // Outputs '06:51 PM'
  }

  setupDmaSidebar() {
    this.sidebarList.forEach(item => {
      let displayFlag = (item.id > 1) ? false : true;
      displayFlag = (item.id == 6) ? this.callProFlag : displayFlag; 
      item.display = displayFlag;
      item.isHide = !displayFlag;
    });
  }

}
